
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $b2a774aae58c7b4e$var$n, $b2a774aae58c7b4e$export$41c562ebe57d11e2, $b2a774aae58c7b4e$var$u, $b2a774aae58c7b4e$export$a8257692ac88316c, $b2a774aae58c7b4e$var$i, $b2a774aae58c7b4e$var$o, $b2a774aae58c7b4e$var$r, $b2a774aae58c7b4e$var$f, $b2a774aae58c7b4e$var$e, $b2a774aae58c7b4e$var$c, $b2a774aae58c7b4e$var$s, $b2a774aae58c7b4e$var$a, $b2a774aae58c7b4e$var$h = {}, $b2a774aae58c7b4e$var$v = [], $b2a774aae58c7b4e$var$p = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $b2a774aae58c7b4e$var$y = Array.isArray;
function $b2a774aae58c7b4e$var$d(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $b2a774aae58c7b4e$var$_(n) {
    var l = n.parentNode;
    l && l.removeChild(n);
}
function $b2a774aae58c7b4e$export$c8a8987d4410bf2d(l, u, t) {
    var i, o, r, f = {};
    for(r in u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
    if (arguments.length > 2 && (f.children = arguments.length > 3 ? $b2a774aae58c7b4e$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(r in l.defaultProps)void 0 === f[r] && (f[r] = l.defaultProps[r]);
    return $b2a774aae58c7b4e$var$b(l, f, i, o, null);
}
function $b2a774aae58c7b4e$var$b(n, t, i, o, r) {
    var f = {
        type: n,
        props: t,
        key: i,
        ref: o,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        constructor: void 0,
        __v: null == r ? ++$b2a774aae58c7b4e$var$u : r,
        __i: -1,
        __u: 0
    };
    return null == r && null != $b2a774aae58c7b4e$export$41c562ebe57d11e2.vnode && $b2a774aae58c7b4e$export$41c562ebe57d11e2.vnode(f), f;
}
function $b2a774aae58c7b4e$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $b2a774aae58c7b4e$export$ffb0004e005737fa(n) {
    return n.children;
}
function $b2a774aae58c7b4e$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $b2a774aae58c7b4e$var$x(n, l) {
    if (null == l) return n.__ ? $b2a774aae58c7b4e$var$x(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $b2a774aae58c7b4e$var$x(n) : null;
}
function $b2a774aae58c7b4e$var$C(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $b2a774aae58c7b4e$var$C(n);
    }
}
function $b2a774aae58c7b4e$var$P(n) {
    (!n.__d && (n.__d = !0) && $b2a774aae58c7b4e$var$i.push(n) && !$b2a774aae58c7b4e$var$S.__r++ || $b2a774aae58c7b4e$var$o !== $b2a774aae58c7b4e$export$41c562ebe57d11e2.debounceRendering) && (($b2a774aae58c7b4e$var$o = $b2a774aae58c7b4e$export$41c562ebe57d11e2.debounceRendering) || $b2a774aae58c7b4e$var$r)($b2a774aae58c7b4e$var$S);
}
function $b2a774aae58c7b4e$var$S() {
    var n, u, t, o, r, e, c, s;
    for($b2a774aae58c7b4e$var$i.sort($b2a774aae58c7b4e$var$f); n = $b2a774aae58c7b4e$var$i.shift();)n.__d && (u = $b2a774aae58c7b4e$var$i.length, o = void 0, e = (r = (t = n).__v).__e, c = [], s = [], t.__P && ((o = $b2a774aae58c7b4e$var$d({}, r)).__v = r.__v + 1, $b2a774aae58c7b4e$export$41c562ebe57d11e2.vnode && $b2a774aae58c7b4e$export$41c562ebe57d11e2.vnode(o), $b2a774aae58c7b4e$var$O(t.__P, o, r, t.__n, void 0 !== t.__P.ownerSVGElement, 32 & r.__u ? [
        e
    ] : null, c, null == e ? $b2a774aae58c7b4e$var$x(r) : e, !!(32 & r.__u), s), o.__v = r.__v, o.__.__k[o.__i] = o, $b2a774aae58c7b4e$var$j(c, o, s), o.__e != e && $b2a774aae58c7b4e$var$C(o)), $b2a774aae58c7b4e$var$i.length > u && $b2a774aae58c7b4e$var$i.sort($b2a774aae58c7b4e$var$f));
    $b2a774aae58c7b4e$var$S.__r = 0;
}
function $b2a774aae58c7b4e$var$$(n, l, u, t, i, o, r, f, e, c, s) {
    var a, p, y, d, _, g = t && t.__k || $b2a774aae58c7b4e$var$v, b = l.length;
    for(u.__d = e, $b2a774aae58c7b4e$var$I(u, l, g), e = u.__d, a = 0; a < b; a++)null != (y = u.__k[a]) && "boolean" != typeof y && "function" != typeof y && (p = -1 === y.__i ? $b2a774aae58c7b4e$var$h : g[y.__i] || $b2a774aae58c7b4e$var$h, y.__i = a, $b2a774aae58c7b4e$var$O(n, y, p, i, o, r, f, e, c, s), d = y.__e, y.ref && p.ref != y.ref && (p.ref && $b2a774aae58c7b4e$var$N(p.ref, null, y), s.push(y.ref, y.__c || d, y)), null == _ && null != d && (_ = d), 65536 & y.__u || p.__k === y.__k ? (e && !e.isConnected && (e = $b2a774aae58c7b4e$var$x(p)), e = $b2a774aae58c7b4e$var$H(y, e, n)) : "function" == typeof y.type && void 0 !== y.__d ? e = y.__d : d && (e = d.nextSibling), y.__d = void 0, y.__u &= -196609);
    u.__d = e, u.__e = _;
}
function $b2a774aae58c7b4e$var$I(n, l, u) {
    var t, i, o, r, f, e = l.length, c = u.length, s = c, a = 0;
    for(n.__k = [], t = 0; t < e; t++)r = t + a, null != (i = n.__k[t] = null == (i = l[t]) || "boolean" == typeof i || "function" == typeof i ? null : "string" == typeof i || "number" == typeof i || "bigint" == typeof i || i.constructor == String ? $b2a774aae58c7b4e$var$b(null, i, null, null, null) : $b2a774aae58c7b4e$var$y(i) ? $b2a774aae58c7b4e$var$b($b2a774aae58c7b4e$export$ffb0004e005737fa, {
        children: i
    }, null, null, null) : void 0 === i.constructor && i.__b > 0 ? $b2a774aae58c7b4e$var$b(i.type, i.props, i.key, i.ref ? i.ref : null, i.__v) : i) ? (i.__ = n, i.__b = n.__b + 1, f = $b2a774aae58c7b4e$var$A(i, u, r, s), i.__i = f, o = null, -1 !== f && (s--, (o = u[f]) && (o.__u |= 131072)), null == o || null === o.__v ? (-1 == f && a--, "function" != typeof i.type && (i.__u |= 65536)) : f !== r && (f === r + 1 ? a++ : f > r ? s > e - r ? a += f - r : a-- : f < r ? f == r - 1 && (a = f - r) : a = 0, f !== t + a && (i.__u |= 65536))) : (o = u[r]) && null == o.key && o.__e && 0 == (131072 & o.__u) && (o.__e == n.__d && (n.__d = $b2a774aae58c7b4e$var$x(o)), $b2a774aae58c7b4e$var$q(o, o, !1), u[r] = null, s--);
    if (s) for(t = 0; t < c; t++)null != (o = u[t]) && 0 == (131072 & o.__u) && (o.__e == n.__d && (n.__d = $b2a774aae58c7b4e$var$x(o)), $b2a774aae58c7b4e$var$q(o, o));
}
function $b2a774aae58c7b4e$var$H(n, l, u) {
    var t, i;
    if ("function" == typeof n.type) {
        for(t = n.__k, i = 0; t && i < t.length; i++)t[i] && (t[i].__ = n, l = $b2a774aae58c7b4e$var$H(t[i], l, u));
        return l;
    }
    n.__e != l && (u.insertBefore(n.__e, l || null), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 === l.nodeType);
    return l;
}
function $b2a774aae58c7b4e$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($b2a774aae58c7b4e$var$y(n) ? n.some(function(n) {
        $b2a774aae58c7b4e$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $b2a774aae58c7b4e$var$A(n, l, u, t) {
    var i = n.key, o = n.type, r = u - 1, f = u + 1, e = l[u];
    if (null === e || e && i == e.key && o === e.type && 0 == (131072 & e.__u)) return u;
    if (t > (null != e && 0 == (131072 & e.__u) ? 1 : 0)) for(; r >= 0 || f < l.length;){
        if (r >= 0) {
            if ((e = l[r]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return r;
            r--;
        }
        if (f < l.length) {
            if ((e = l[f]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return f;
            f++;
        }
    }
    return -1;
}
function $b2a774aae58c7b4e$var$F(n, l, u) {
    "-" === l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $b2a774aae58c7b4e$var$p.test(l) ? u : u + "px";
}
function $b2a774aae58c7b4e$var$L(n, l, u, t, i) {
    var o;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $b2a774aae58c7b4e$var$F(n.style, l, "");
            if (u) for(l in u)t && u[l] === t[l] || $b2a774aae58c7b4e$var$F(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) o = l !== (l = l.replace(/(PointerCapture)$|Capture$/i, "$1")), l = l.toLowerCase() in n || "onFocusOut" === l || "onFocusIn" === l ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, u ? t ? u.u = t.u : (u.u = $b2a774aae58c7b4e$var$e, n.addEventListener(l, o ? $b2a774aae58c7b4e$var$s : $b2a774aae58c7b4e$var$c, o)) : n.removeEventListener(l, o ? $b2a774aae58c7b4e$var$s : $b2a774aae58c7b4e$var$c, o);
    else {
        if (i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" != l && "height" != l && "href" != l && "list" != l && "form" != l && "tabIndex" != l && "download" != l && "rowSpan" != l && "colSpan" != l && "role" != l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" !== l[4] ? n.removeAttribute(l) : n.setAttribute(l, u));
    }
}
function $b2a774aae58c7b4e$var$M(n) {
    return function(u) {
        if (this.l) {
            var t = this.l[u.type + n];
            if (null == u.t) u.t = $b2a774aae58c7b4e$var$e++;
            else if (u.t < t.u) return;
            return t($b2a774aae58c7b4e$export$41c562ebe57d11e2.event ? $b2a774aae58c7b4e$export$41c562ebe57d11e2.event(u) : u);
        }
    };
}
function $b2a774aae58c7b4e$var$O(n, u, t, i, o, r, f, e, c, s) {
    var a, h, v, p, _, g, b, m, x, C, P, S, I, H, T, A = u.type;
    if (void 0 !== u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), r = [
        e = u.__e = t.__e
    ]), (a = $b2a774aae58c7b4e$export$41c562ebe57d11e2.__b) && a(u);
    n: if ("function" == typeof A) try {
        if (m = u.props, x = (a = A.contextType) && i[a.__c], C = a ? x ? x.props.value : a.__ : i, t.__c ? b = (h = u.__c = t.__c).__ = h.__E : ("prototype" in A && A.prototype.render ? u.__c = h = new A(m, C) : (u.__c = h = new $b2a774aae58c7b4e$export$16fa2f45be04daa8(m, C), h.constructor = A, h.render = $b2a774aae58c7b4e$var$B), x && x.sub(h), h.props = m, h.state || (h.state = {}), h.context = C, h.__n = i, v = h.__d = !0, h.__h = [], h._sb = []), null == h.__s && (h.__s = h.state), null != A.getDerivedStateFromProps && (h.__s == h.state && (h.__s = $b2a774aae58c7b4e$var$d({}, h.__s)), $b2a774aae58c7b4e$var$d(h.__s, A.getDerivedStateFromProps(m, h.__s))), p = h.props, _ = h.state, h.__v = u, v) null == A.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), null != h.componentDidMount && h.__h.push(h.componentDidMount);
        else {
            if (null == A.getDerivedStateFromProps && m !== p && null != h.componentWillReceiveProps && h.componentWillReceiveProps(m, C), !h.__e && (null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(m, h.__s, C) || u.__v === t.__v)) {
                for(u.__v !== t.__v && (h.props = m, h.state = h.__s, h.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.forEach(function(n) {
                    n && (n.__ = u);
                }), P = 0; P < h._sb.length; P++)h.__h.push(h._sb[P]);
                h._sb = [], h.__h.length && f.push(h);
                break n;
            }
            null != h.componentWillUpdate && h.componentWillUpdate(m, h.__s, C), null != h.componentDidUpdate && h.__h.push(function() {
                h.componentDidUpdate(p, _, g);
            });
        }
        if (h.context = C, h.props = m, h.__P = n, h.__e = !1, S = $b2a774aae58c7b4e$export$41c562ebe57d11e2.__r, I = 0, "prototype" in A && A.prototype.render) {
            for(h.state = h.__s, h.__d = !1, S && S(u), a = h.render(h.props, h.state, h.context), H = 0; H < h._sb.length; H++)h.__h.push(h._sb[H]);
            h._sb = [];
        } else do h.__d = !1, S && S(u), a = h.render(h.props, h.state, h.context), h.state = h.__s;
        while (h.__d && ++I < 25);
        h.state = h.__s, null != h.getChildContext && (i = $b2a774aae58c7b4e$var$d($b2a774aae58c7b4e$var$d({}, i), h.getChildContext())), v || null == h.getSnapshotBeforeUpdate || (g = h.getSnapshotBeforeUpdate(p, _)), $b2a774aae58c7b4e$var$$(n, $b2a774aae58c7b4e$var$y(T = null != a && a.type === $b2a774aae58c7b4e$export$ffb0004e005737fa && null == a.key ? a.props.children : a) ? T : [
            T
        ], u, t, i, o, r, f, e, c, s), h.base = u.__e, u.__u &= -161, h.__h.length && f.push(h), b && (h.__E = h.__ = null);
    } catch (n) {
        u.__v = null, c || null != r ? (u.__e = e, u.__u |= c ? 160 : 32, r[r.indexOf(e)] = null) : (u.__e = t.__e, u.__k = t.__k), $b2a774aae58c7b4e$export$41c562ebe57d11e2.__e(n, u, t);
    }
    else null == r && u.__v === t.__v ? (u.__k = t.__k, u.__e = t.__e) : u.__e = $b2a774aae58c7b4e$var$z(t.__e, u, t, i, o, r, f, c, s);
    (a = $b2a774aae58c7b4e$export$41c562ebe57d11e2.diffed) && a(u);
}
function $b2a774aae58c7b4e$var$j(n, u, t) {
    u.__d = void 0;
    for(var i = 0; i < t.length; i++)$b2a774aae58c7b4e$var$N(t[i], t[++i], t[++i]);
    $b2a774aae58c7b4e$export$41c562ebe57d11e2.__c && $b2a774aae58c7b4e$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $b2a774aae58c7b4e$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $b2a774aae58c7b4e$var$z(l, u, t, i, o, r, f, e, c) {
    var s, a, v, p, d, g, b, m = t.props, w = u.props, k = u.type;
    if ("svg" === k && (o = !0), null != r) {
        for(s = 0; s < r.length; s++)if ((d = r[s]) && "setAttribute" in d == !!k && (k ? d.localName === k : 3 === d.nodeType)) {
            l = d, r[s] = null;
            break;
        }
    }
    if (null == l) {
        if (null === k) return document.createTextNode(w);
        l = o ? document.createElementNS("http://www.w3.org/2000/svg", k) : document.createElement(k, w.is && w), r = null, e = !1;
    }
    if (null === k) m === w || e && l.data === w || (l.data = w);
    else {
        if (r = r && $b2a774aae58c7b4e$var$n.call(l.childNodes), m = t.props || $b2a774aae58c7b4e$var$h, !e && null != r) for(m = {}, s = 0; s < l.attributes.length; s++)m[(d = l.attributes[s]).name] = d.value;
        for(s in m)d = m[s], "children" == s || ("dangerouslySetInnerHTML" == s ? v = d : "key" === s || s in w || $b2a774aae58c7b4e$var$L(l, s, null, d, o));
        for(s in w)d = w[s], "children" == s ? p = d : "dangerouslySetInnerHTML" == s ? a = d : "value" == s ? g = d : "checked" == s ? b = d : "key" === s || e && "function" != typeof d || m[s] === d || $b2a774aae58c7b4e$var$L(l, s, d, m[s], o);
        if (a) e || v && (a.__html === v.__html || a.__html === l.innerHTML) || (l.innerHTML = a.__html), u.__k = [];
        else if (v && (l.innerHTML = ""), $b2a774aae58c7b4e$var$$(l, $b2a774aae58c7b4e$var$y(p) ? p : [
            p
        ], u, t, i, o && "foreignObject" !== k, r, f, r ? r[0] : t.__k && $b2a774aae58c7b4e$var$x(t, 0), e, c), null != r) for(s = r.length; s--;)null != r[s] && $b2a774aae58c7b4e$var$_(r[s]);
        e || (s = "value", void 0 !== g && (g !== l[s] || "progress" === k && !g || "option" === k && g !== m[s]) && $b2a774aae58c7b4e$var$L(l, s, g, m[s], !1), s = "checked", void 0 !== b && b !== l[s] && $b2a774aae58c7b4e$var$L(l, s, b, m[s], !1));
    }
    return l;
}
function $b2a774aae58c7b4e$var$N(n, u, t) {
    try {
        "function" == typeof n ? n(u) : n.current = u;
    } catch (n) {
        $b2a774aae58c7b4e$export$41c562ebe57d11e2.__e(n, t);
    }
}
function $b2a774aae58c7b4e$var$q(n, u, t) {
    var i, o;
    if ($b2a774aae58c7b4e$export$41c562ebe57d11e2.unmount && $b2a774aae58c7b4e$export$41c562ebe57d11e2.unmount(n), (i = n.ref) && (i.current && i.current !== n.__e || $b2a774aae58c7b4e$var$N(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $b2a774aae58c7b4e$export$41c562ebe57d11e2.__e(n, u);
        }
        i.base = i.__P = null;
    }
    if (i = n.__k) for(o = 0; o < i.length; o++)i[o] && $b2a774aae58c7b4e$var$q(i[o], u, t || "function" != typeof n.type);
    t || null == n.__e || $b2a774aae58c7b4e$var$_(n.__e), n.__c = n.__ = n.__e = n.__d = void 0;
}
function $b2a774aae58c7b4e$var$B(n, l, u) {
    return this.constructor(n, u);
}
function $b2a774aae58c7b4e$export$b3890eb0ae9dca99(u, t, i) {
    var o, r, f, e;
    $b2a774aae58c7b4e$export$41c562ebe57d11e2.__ && $b2a774aae58c7b4e$export$41c562ebe57d11e2.__(u, t), r = (o = "function" == typeof i) ? null : i && i.__k || t.__k, f = [], e = [], $b2a774aae58c7b4e$var$O(t, u = (!o && i || t).__k = $b2a774aae58c7b4e$export$c8a8987d4410bf2d($b2a774aae58c7b4e$export$ffb0004e005737fa, null, [
        u
    ]), r || $b2a774aae58c7b4e$var$h, $b2a774aae58c7b4e$var$h, void 0 !== t.ownerSVGElement, !o && i ? [
        i
    ] : r ? null : t.firstChild ? $b2a774aae58c7b4e$var$n.call(t.childNodes) : null, f, !o && i ? i : r ? r.__e : t.firstChild, o, e), $b2a774aae58c7b4e$var$j(f, u, e);
}
function $b2a774aae58c7b4e$export$fa8d919ba61d84db(n, l) {
    $b2a774aae58c7b4e$export$b3890eb0ae9dca99(n, l, $b2a774aae58c7b4e$export$fa8d919ba61d84db);
}
function $b2a774aae58c7b4e$export$e530037191fcd5d7(l, u, t) {
    var i, o, r, f, e = $b2a774aae58c7b4e$var$d({}, l.props);
    for(r in l.type && l.type.defaultProps && (f = l.type.defaultProps), u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : e[r] = void 0 === u[r] && void 0 !== f ? f[r] : u[r];
    return arguments.length > 2 && (e.children = arguments.length > 3 ? $b2a774aae58c7b4e$var$n.call(arguments, 2) : t), $b2a774aae58c7b4e$var$b(l.type, e, i || l.key, o || l.ref, null);
}
function $b2a774aae58c7b4e$export$fd42f52fd3ae1109(n, l) {
    var u = {
        __c: l = "__cC" + $b2a774aae58c7b4e$var$a++,
        __: n,
        Consumer: function(n, l) {
            return n.children(l);
        },
        Provider: function(n) {
            var u, t;
            return this.getChildContext || (u = [], (t = {})[l] = this, this.getChildContext = function() {
                return t;
            }, this.shouldComponentUpdate = function(n) {
                this.props.value !== n.value && u.some(function(n) {
                    n.__e = !0, $b2a774aae58c7b4e$var$P(n);
                });
            }, this.sub = function(n) {
                u.push(n);
                var l = n.componentWillUnmount;
                n.componentWillUnmount = function() {
                    u.splice(u.indexOf(n), 1), l && l.call(n);
                };
            }), n.children;
        }
    };
    return u.Provider.__ = u.Consumer.contextType = u;
}
$b2a774aae58c7b4e$var$n = $b2a774aae58c7b4e$var$v.slice, $b2a774aae58c7b4e$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, t) {
        for(var i, o, r; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((o = i.constructor) && null != o.getDerivedStateFromError && (i.setState(o.getDerivedStateFromError(n)), r = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), r = i.__d), r) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $b2a774aae58c7b4e$var$u = 0, $b2a774aae58c7b4e$export$a8257692ac88316c = function(n) {
    return null != n && null == n.constructor;
}, $b2a774aae58c7b4e$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $b2a774aae58c7b4e$var$d({}, this.state), "function" == typeof n && (n = n($b2a774aae58c7b4e$var$d({}, u), this.props)), n && $b2a774aae58c7b4e$var$d(u, n), null != n && this.__v && (l && this._sb.push(l), $b2a774aae58c7b4e$var$P(this));
}, $b2a774aae58c7b4e$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $b2a774aae58c7b4e$var$P(this));
}, $b2a774aae58c7b4e$export$16fa2f45be04daa8.prototype.render = $b2a774aae58c7b4e$export$ffb0004e005737fa, $b2a774aae58c7b4e$var$i = [], $b2a774aae58c7b4e$var$r = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $b2a774aae58c7b4e$var$f = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $b2a774aae58c7b4e$var$S.__r = 0, $b2a774aae58c7b4e$var$e = 0, $b2a774aae58c7b4e$var$c = $b2a774aae58c7b4e$var$M(!1), $b2a774aae58c7b4e$var$s = $b2a774aae58c7b4e$var$M(!0), $b2a774aae58c7b4e$var$a = 0;


var $ea6c2efa7087cd4a$var$n = function(t, s, r, e) {
    var u;
    s[0] = 0;
    for(var h = 1; h < s.length; h++){
        var p = s[h++], a = s[h] ? (s[0] |= p ? 1 : 2, r[s[h++]]) : s[++h];
        3 === p ? e[0] = a : 4 === p ? e[1] = Object.assign(e[1] || {}, a) : 5 === p ? (e[1] = e[1] || {})[s[++h]] = a : 6 === p ? e[1][s[++h]] += a + "" : p ? (u = t.apply(a, $ea6c2efa7087cd4a$var$n(t, a, r, [
            "",
            null
        ])), e.push(u), a[0] ? s[0] |= 2 : (s[h - 2] = 0, s[h] = u)) : e.push(a);
    }
    return e;
}, $ea6c2efa7087cd4a$var$t = new Map;
function $ea6c2efa7087cd4a$export$2e2bcd8739ae039(s) {
    var r = $ea6c2efa7087cd4a$var$t.get(this);
    return r || (r = new Map, $ea6c2efa7087cd4a$var$t.set(this, r)), (r = $ea6c2efa7087cd4a$var$n(this, r.get(s) || (r.set(s, r = function(n) {
        for(var t, s, r = 1, e = "", u = "", h = [
            0
        ], p = function(n) {
            1 === r && (n || (e = e.replace(/^\s*\n\s*|\s*\n\s*$/g, ""))) ? h.push(0, n, e) : 3 === r && (n || e) ? (h.push(3, n, e), r = 2) : 2 === r && "..." === e && n ? h.push(4, n, 0) : 2 === r && e && !n ? h.push(5, 0, !0, e) : r >= 5 && ((e || !n && 5 === r) && (h.push(r, 0, e, s), r = 6), n && (h.push(r, n, 0, s), r = 6)), e = "";
        }, a = 0; a < n.length; a++){
            a && (1 === r && p(), p(a));
            for(var l = 0; l < n[a].length; l++)t = n[a][l], 1 === r ? "<" === t ? (p(), h = [
                h
            ], r = 3) : e += t : 4 === r ? "--" === e && ">" === t ? (r = 1, e = "") : e = t + e[0] : u ? t === u ? u = "" : e += t : '"' === t || "'" === t ? u = t : ">" === t ? (p(), r = 1) : r && ("=" === t ? (r = 5, s = e, e = "") : "/" === t && (r < 5 || ">" === n[a][l + 1]) ? (p(), 3 === r && (h = h[0]), r = h, (h = h[0]).push(2, 0, r), r = 0) : " " === t || "	" === t || "\n" === t || "\r" === t ? (p(), r = 2) : e += t), 3 === r && "!--" === e && (r = 4, h = h[0]);
        }
        return p(), h;
    }(s)), r), arguments, [])).length > 1 ? r : r[0];
}


var $efca0cb2e3ea1e67$exports = {};

$parcel$export($efca0cb2e3ea1e67$exports, "State", () => $efca0cb2e3ea1e67$export$7254cc27399e90bd);
$parcel$export($efca0cb2e3ea1e67$exports, "regexp", () => $efca0cb2e3ea1e67$export$efdc1e5bdb609bb);
$parcel$export($efca0cb2e3ea1e67$exports, "stringToArray", () => $efca0cb2e3ea1e67$export$b9ca061da17f2d30);
$parcel$export($efca0cb2e3ea1e67$exports, "Options", () => $efca0cb2e3ea1e67$export$c019608e5b5bb4cb);
$parcel$export($efca0cb2e3ea1e67$exports, "options", () => $efca0cb2e3ea1e67$export$41c562ebe57d11e2);
$parcel$export($efca0cb2e3ea1e67$exports, "MultiToken", () => $efca0cb2e3ea1e67$export$28075db42e06f164);
$parcel$export($efca0cb2e3ea1e67$exports, "createTokenClass", () => $efca0cb2e3ea1e67$export$21042e7280c1baba);
$parcel$export($efca0cb2e3ea1e67$exports, "multi", () => $efca0cb2e3ea1e67$export$13e2537ceeaf8a3a);
$parcel$export($efca0cb2e3ea1e67$exports, "reset", () => $efca0cb2e3ea1e67$export$aad8462122ac592b);
$parcel$export($efca0cb2e3ea1e67$exports, "registerTokenPlugin", () => $efca0cb2e3ea1e67$export$56d1f1cb1f3c0e96);
$parcel$export($efca0cb2e3ea1e67$exports, "registerPlugin", () => $efca0cb2e3ea1e67$export$7612db19fb8beb1e);
$parcel$export($efca0cb2e3ea1e67$exports, "registerCustomProtocol", () => $efca0cb2e3ea1e67$export$821627edc2d26f5f);
$parcel$export($efca0cb2e3ea1e67$exports, "init", () => $efca0cb2e3ea1e67$export$2cd8252107eb640b);
$parcel$export($efca0cb2e3ea1e67$exports, "tokenize", () => $efca0cb2e3ea1e67$export$660b2ee2d4fb4eff);
$parcel$export($efca0cb2e3ea1e67$exports, "find", () => $efca0cb2e3ea1e67$export$71aa6c912b956294);
$parcel$export($efca0cb2e3ea1e67$exports, "test", () => $efca0cb2e3ea1e67$export$e0969da9b8fb378d);
// THIS FILE IS AUTOMATICALLY GENERATED DO NOT EDIT DIRECTLY
// See update-tlds.js for encoding/decoding format
// https://data.iana.org/TLD/tlds-alpha-by-domain.txt
const $efca0cb2e3ea1e67$var$encodedTlds = "aaa1rp3bb0ott3vie4c1le2ogado5udhabi7c0ademy5centure6ountant0s9o1tor4d0s1ult4e0g1ro2tna4f0l1rica5g0akhan5ency5i0g1rbus3force5tel5kdn3l0ibaba4pay4lfinanz6state5y2sace3tom5m0azon4ericanexpress7family11x2fam3ica3sterdam8nalytics7droid5quan4z2o0l2partments8p0le4q0uarelle8r0ab1mco4chi3my2pa2t0e3s0da2ia2sociates9t0hleta5torney7u0ction5di0ble3o3spost5thor3o0s4vianca6w0s2x0a2z0ure5ba0by2idu3namex3narepublic11d1k2r0celona5laycard4s5efoot5gains6seball5ketball8uhaus5yern5b0c1t1va3cg1n2d1e0ats2uty4er2ntley5rlin4st0buy5t2f1g1h0arti5i0ble3d1ke2ng0o3o1z2j1lack0friday9ockbuster8g1omberg7ue3m0s1w2n0pparibas9o0ats3ehringer8fa2m1nd2o0k0ing5sch2tik2on4t1utique6x2r0adesco6idgestone9oadway5ker3ther5ussels7s1t1uild0ers6siness6y1zz3v1w1y1z0h3ca0b1fe2l0l1vinklein9m0era3p2non3petown5ital0one8r0avan4ds2e0er0s4s2sa1e1h1ino4t0ering5holic7ba1n1re3c1d1enter4o1rn3f0a1d2g1h0anel2nel4rity4se2t2eap3intai5ristmas6ome4urch5i0priani6rcle4sco3tadel4i0c2y3k1l0aims4eaning6ick2nic1que6othing5ud3ub0med6m1n1o0ach3des3ffee4llege4ogne5m0cast4mbank4unity6pany2re3uter5sec4ndos3struction8ulting7tact3ractors9oking4l1p2rsica5untry4pon0s4rses6pa2r0edit0card4union9icket5own3s1uise0s6u0isinella9v1w1x1y0mru3ou3z2dabur3d1nce3ta1e1ing3sun4y2clk3ds2e0al0er2s3gree4livery5l1oitte5ta3mocrat6ntal2ist5si0gn4v2hl2iamonds6et2gital5rect0ory7scount3ver5h2y2j1k1m1np2o0cs1tor4g1mains5t1wnload7rive4tv2ubai3nlop4pont4rban5vag2r2z2earth3t2c0o2deka3u0cation8e1g1mail3erck5nergy4gineer0ing9terprises10pson4quipment8r0icsson6ni3s0q1tate5t1u0rovision8s2vents5xchange6pert3osed4ress5traspace10fage2il1rwinds6th3mily4n0s2rm0ers5shion4t3edex3edback6rrari3ero6i0delity5o2lm2nal1nce1ial7re0stone6mdale6sh0ing5t0ness6j1k1lickr3ghts4r2orist4wers5y2m1o0o0d1tball6rd1ex2sale4um3undation8x2r0ee1senius7l1ogans4ntier7tr2ujitsu5n0d2rniture7tbol5yi3ga0l0lery3o1up4me0s3p1rden4y2b0iz3d0n2e0a1nt0ing5orge5f1g0ee3h1i0ft0s3ves2ing5l0ass3e1obal2o4m0ail3bh2o1x2n1odaddy5ld0point6f2o0dyear5g0le4p1t1v2p1q1r0ainger5phics5tis4een3ipe3ocery4up4s1t1u0ardian6cci3ge2ide2tars5ru3w1y2hair2mburg5ngout5us3bo2dfc0bank7ealth0care8lp1sinki6re1mes5iphop4samitsu7tachi5v2k0t2m1n1ockey4ldings5iday5medepot5goods5s0ense7nda3rse3spital5t0ing5t0els3mail5use3w2r1sbc3t1u0ghes5yatt3undai7ibm2cbc2e1u2d1e0ee3fm2kano4l1m0amat4db2mo0bilien9n0c1dustries8finiti5o2g1k1stitute6urance4e4t0ernational10uit4vestments10o1piranga7q1r0ish4s0maili5t0anbul7t0au2v3jaguar4va3cb2e0ep2tzt3welry6io2ll2m0p2nj2o0bs1urg4t1y2p0morgan6rs3uegos4niper7kaufen5ddi3e0rryhotels6logistics9properties14fh2g1h1i0a1ds2m1ndle4tchen5wi3m1n1oeln3matsu5sher5p0mg2n2r0d1ed3uokgroup8w1y0oto4z2la0caixa5mborghini8er3ncaster6d0rover6xess5salle5t0ino3robe5w0yer5b1c1ds2ease3clerc5frak4gal2o2xus4gbt3i0dl2fe0insurance9style7ghting6ke2lly3mited4o2ncoln4k2psy3ve1ing5k1lc1p2oan0s3cker3us3l1ndon4tte1o3ve3pl0financial11r1s1t0d0a3u0ndbeck6xe1ury5v1y2ma0drid4if1son4keup4n0agement7go3p1rket0ing3s4riott5shalls7ttel5ba2c0kinsey7d1e0d0ia3et2lbourne7me1orial6n0u2rckmsd7g1h1iami3crosoft7l1ni1t2t0subishi9k1l0b1s2m0a2n1o0bi0le4da2e1i1m1nash3ey2ster5rmon3tgage6scow4to0rcycles9v0ie4p1q1r1s0d2t0n1r2u0seum3ic4v1w1x1y1z2na0b1goya4me2tura4vy3ba2c1e0c1t0bank4flix4work5ustar5w0s2xt0direct7us4f0l2g0o2hk2i0co2ke1on3nja3ssan1y5l1o0kia3rton4w0ruz3tv4p1r0a1w2tt2u1yc2z2obi1server7ffice5kinawa6layan0group9dnavy5lo3m0ega4ne1g1l0ine5oo2pen3racle3nge4g0anic5igins6saka4tsuka4t2vh3pa0ge2nasonic7ris2s1tners4s1y3y2ccw3e0t2f0izer5g1h0armacy6d1ilips5one2to0graphy6s4ysio5ics1tet2ures6d1n0g1k2oneer5zza4k1l0ace2y0station9umbing5s3m1n0c2ohl2ker3litie5rn2st3r0america6xi3ess3ime3o0d0uctions8f1gressive8mo2perties3y5tection8u0dential9s1t1ub2w0c2y2qa1pon3uebec3st5racing4dio4e0ad1lestate6tor2y4cipes5d0stone5umbrella9hab3ise0n3t2liance6n0t0als5pair3ort3ublican8st0aurant8view0s5xroth6ich0ardli6oh3l1o1p2o0cks3deo3gers4om3s0vp3u0gby3hr2n2w0e2yukyu6sa0arland6fe0ty4kura4le1on3msclub4ung5ndvik0coromant12ofi4p1rl2s1ve2xo3b0i1s2c0a1b1haeffler7midt4olarships8ol3ule3warz5ience5ot3d1e0arch3t2cure1ity6ek2lect4ner3rvices6ven3w1x0y3fr2g1h0angrila6rp2w2ell3ia1ksha5oes2p0ping5uji3w3i0lk2na1gles5te3j1k0i0n2y0pe4l0ing4m0art3ile4n0cf3o0ccer3ial4ftbank4ware6hu2lar2utions7ng1y2y2pa0ce3ort2t3r0l2s1t0ada2ples4r1tebank4farm7c0group6ockholm6rage3e3ream4udio2y3yle4u0cks3pplies3y2ort5rf1gery5zuki5v1watch4iss4x1y0dney4stems6z2tab1ipei4lk2obao4rget4tamotors6r2too4x0i3c0i2d0k2eam2ch0nology8l1masek5nnis4va3f1g1h0d1eater2re6iaa2ckets5enda4ps2res2ol4j0maxx4x2k0maxx5l1m0all4n1o0day3kyo3ols3p1ray3shiba5tal3urs3wn2yota3s3r0ade1ing4ining5vel0ers0insurance16ust3v2t1ube2i1nes3shu4v0s2w1z2ua1bank3s2g1k1nicom3versity8o2ol2ps2s1y1z2va0cations7na1guard7c1e0gas3ntures6risign5m\xf6gensberater2ung14sicherung10t2g1i0ajes4deo3g1king4llas4n1p1rgin4sa1ion4va1o3laanderen9n1odka3lvo3te1ing3o2yage5u2wales2mart4ter4ng0gou5tch0es6eather0channel12bcam3er2site5d0ding5ibo2r3f1hoswho6ien2ki2lliamhill9n0dows4e1ners6me2olterskluwer11odside6rk0s2ld3w2s1tc1f3xbox3erox4finity6ihuan4n2xx2yz3yachts4hoo3maxun5ndex5e1odobashi7ga2kohama6u0tube6t1un3za0ppos4ra3ero3ip2m1one3uerich6w2";
// Internationalized domain names containing non-ASCII
const $efca0cb2e3ea1e67$var$encodedUtlds = "\u03B5\u03BB1\u03C52\u0431\u04331\u0435\u043B3\u0434\u0435\u0442\u04384\u0435\u044E2\u043A\u0430\u0442\u043E\u043B\u0438\u043A6\u043E\u043C3\u043C\u043A\u04342\u043E\u043D1\u0441\u043A\u0432\u04306\u043E\u043D\u043B\u0430\u0439\u043D5\u0440\u04333\u0440\u0443\u04412\u04442\u0441\u0430\u0439\u04423\u0440\u04313\u0443\u043A\u04403\u049B\u0430\u04373\u0570\u0561\u05753\u05D9\u05E9\u05E8\u05D0\u05DC5\u05E7\u05D5\u05DD3\u0627\u0628\u0648\u0638\u0628\u064A5\u0631\u0627\u0645\u0643\u06485\u0644\u0627\u0631\u062F\u06464\u0628\u062D\u0631\u064A\u06465\u062C\u0632\u0627\u0626\u06315\u0633\u0639\u0648\u062F\u064A\u06296\u0639\u0644\u064A\u0627\u06465\u0645\u063A\u0631\u06285\u0645\u0627\u0631\u0627\u062A5\u06CC\u0631\u0627\u06465\u0628\u0627\u0631\u062A2\u0632\u0627\u06314\u064A\u062A\u06433\u06BE\u0627\u0631\u062A5\u062A\u0648\u0646\u06334\u0633\u0648\u062F\u0627\u06463\u0631\u064A\u06295\u0634\u0628\u0643\u06294\u0639\u0631\u0627\u06422\u06282\u0645\u0627\u06464\u0641\u0644\u0633\u0637\u064A\u06466\u0642\u0637\u06313\u0643\u0627\u062B\u0648\u0644\u064A\u06436\u0648\u06453\u0645\u0635\u06312\u0644\u064A\u0633\u064A\u06275\u0648\u0631\u064A\u062A\u0627\u0646\u064A\u06277\u0642\u06394\u0647\u0645\u0631\u0627\u06475\u067E\u0627\u06A9\u0633\u062A\u0627\u06467\u0680\u0627\u0631\u062A4\u0915\u0949\u092E3\u0928\u0947\u091F3\u092D\u093E\u0930\u09240\u092E\u094D3\u094B\u09245\u0938\u0902\u0917\u0920\u09285\u09AC\u09BE\u0982\u09B2\u09BE5\u09AD\u09BE\u09B0\u09A42\u09F0\u09A44\u0A2D\u0A3E\u0A30\u0A244\u0AAD\u0ABE\u0AB0\u0AA44\u0B2D\u0B3E\u0B30\u0B244\u0B87\u0BA8\u0BCD\u0BA4\u0BBF\u0BAF\u0BBE6\u0BB2\u0B99\u0BCD\u0B95\u0BC86\u0B9A\u0BBF\u0B99\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0BC2\u0BB0\u0BCD11\u0C2D\u0C3E\u0C30\u0C24\u0C4D5\u0CAD\u0CBE\u0CB0\u0CA44\u0D2D\u0D3E\u0D30\u0D24\u0D025\u0DBD\u0D82\u0D9A\u0DCF4\u0E04\u0E2D\u0E213\u0E44\u0E17\u0E223\u0EA5\u0EB2\u0EA73\u10D2\u10D42\u307F\u3093\u306A3\u30A2\u30DE\u30BE\u30F34\u30AF\u30E9\u30A6\u30C94\u30B0\u30FC\u30B0\u30EB4\u30B3\u30E02\u30B9\u30C8\u30A23\u30BB\u30FC\u30EB3\u30D5\u30A1\u30C3\u30B7\u30E7\u30F36\u30DD\u30A4\u30F3\u30C84\u4E16\u754C2\u4E2D\u4FE11\u56FD1\u570B1\u6587\u7F513\u4E9A\u9A6C\u900A3\u4F01\u4E1A2\u4F5B\u5C712\u4FE1\u606F2\u5065\u5EB72\u516B\u53662\u516C\u53F81\u76CA2\u53F0\u6E7E1\u70632\u5546\u57CE1\u5E971\u68072\u5609\u91CC0\u5927\u9152\u5E975\u5728\u7EBF2\u5927\u62FF2\u5929\u4E3B\u65593\u5A31\u4E502\u5BB6\u96FB2\u5E7F\u4E1C2\u5FAE\u535A2\u6148\u55842\u6211\u7231\u4F603\u624B\u673A2\u62DB\u80582\u653F\u52A11\u5E9C2\u65B0\u52A0\u57612\u95FB2\u65F6\u5C1A2\u66F8\u7C4D2\u673A\u67842\u6DE1\u9A6C\u95213\u6E38\u620F2\u6FB3\u95802\u70B9\u770B2\u79FB\u52A82\u7EC4\u7EC7\u673A\u67844\u7F51\u57401\u5E971\u7AD91\u7EDC2\u8054\u901A2\u8C37\u6B4C2\u8D2D\u72692\u901A\u8CA92\u96C6\u56E22\u96FB\u8A0A\u76C8\u79D14\u98DE\u5229\u6D663\u98DF\u54C12\u9910\u53852\u9999\u683C\u91CC\u62C93\u6E2F2\uB2F7\uB1371\uCEF42\uC0BC\uC1312\uD55C\uAD6D2";
/**
 * @template A
 * @template B
 * @param {A} target
 * @param {B} properties
 * @return {A & B}
 */ const $efca0cb2e3ea1e67$var$assign = (target, properties)=>{
    for(const key in properties)target[key] = properties[key];
    return target;
};
/**
 * Finite State Machine generation utilities
 */ /**
 * @template T
 * @typedef {{ [group: string]: T[] }} Collections
 */ /**
 * @typedef {{ [group: string]: true }} Flags
 */ // Keys in scanner Collections instances
const $efca0cb2e3ea1e67$var$numeric = "numeric";
const $efca0cb2e3ea1e67$var$ascii = "ascii";
const $efca0cb2e3ea1e67$var$alpha = "alpha";
const $efca0cb2e3ea1e67$var$asciinumeric = "asciinumeric";
const $efca0cb2e3ea1e67$var$alphanumeric = "alphanumeric";
const $efca0cb2e3ea1e67$var$domain = "domain";
const $efca0cb2e3ea1e67$var$emoji = "emoji";
const $efca0cb2e3ea1e67$var$scheme = "scheme";
const $efca0cb2e3ea1e67$var$slashscheme = "slashscheme";
const $efca0cb2e3ea1e67$var$whitespace = "whitespace";
/**
 * @template T
 * @param {string} name
 * @param {Collections<T>} groups to register in
 * @returns {T[]} Current list of tokens in the given collection
 */ function $efca0cb2e3ea1e67$var$registerGroup(name, groups) {
    if (!(name in groups)) groups[name] = [];
    return groups[name];
}
/**
 * @template T
 * @param {T} t token to add
 * @param {Collections<T>} groups
 * @param {Flags} flags
 */ function $efca0cb2e3ea1e67$var$addToGroups(t, flags, groups) {
    if (flags[$efca0cb2e3ea1e67$var$numeric]) {
        flags[$efca0cb2e3ea1e67$var$asciinumeric] = true;
        flags[$efca0cb2e3ea1e67$var$alphanumeric] = true;
    }
    if (flags[$efca0cb2e3ea1e67$var$ascii]) {
        flags[$efca0cb2e3ea1e67$var$asciinumeric] = true;
        flags[$efca0cb2e3ea1e67$var$alpha] = true;
    }
    if (flags[$efca0cb2e3ea1e67$var$asciinumeric]) flags[$efca0cb2e3ea1e67$var$alphanumeric] = true;
    if (flags[$efca0cb2e3ea1e67$var$alpha]) flags[$efca0cb2e3ea1e67$var$alphanumeric] = true;
    if (flags[$efca0cb2e3ea1e67$var$alphanumeric]) flags[$efca0cb2e3ea1e67$var$domain] = true;
    if (flags[$efca0cb2e3ea1e67$var$emoji]) flags[$efca0cb2e3ea1e67$var$domain] = true;
    for(const k in flags){
        const group = $efca0cb2e3ea1e67$var$registerGroup(k, groups);
        if (group.indexOf(t) < 0) group.push(t);
    }
}
/**
 * @template T
 * @param {T} t token to check
 * @param {Collections<T>} groups
 * @returns {Flags} group flags that contain this token
 */ function $efca0cb2e3ea1e67$var$flagsForToken(t, groups) {
    const result = {};
    for(const c in groups)if (groups[c].indexOf(t) >= 0) result[c] = true;
    return result;
}
/**
 * @template T
 * @typedef {null | T } Transition
 */ /**
 * Define a basic state machine state. j is the list of character transitions,
 * jr is the list of regex-match transitions, jd is the default state to
 * transition to t is the accepting token type, if any. If this is the terminal
 * state, then it does not emit a token.
 *
 * The template type T represents the type of the token this state accepts. This
 * should be a string (such as of the token exports in `text.js`) or a
 * MultiToken subclass (from `multi.js`)
 *
 * @template T
 * @param {T} [token] Token that this state emits
 */ function $efca0cb2e3ea1e67$export$7254cc27399e90bd(token) {
    if (token === void 0) token = null;
    // this.n = null; // DEBUG: State name
    /** @type {{ [input: string]: State<T> }} j */ this.j = {}; // IMPLEMENTATION 1
    // this.j = []; // IMPLEMENTATION 2
    /** @type {[RegExp, State<T>][]} jr */ this.jr = [];
    /** @type {?State<T>} jd */ this.jd = null;
    /** @type {?T} t */ this.t = token;
}
/**
 * Scanner token groups
 * @type Collections<string>
 */ $efca0cb2e3ea1e67$export$7254cc27399e90bd.groups = {};
$efca0cb2e3ea1e67$export$7254cc27399e90bd.prototype = {
    accepts () {
        return !!this.t;
    },
    /**
   * Follow an existing transition from the given input to the next state.
   * Does not mutate.
   * @param {string} input character or token type to transition on
   * @returns {?State<T>} the next state, if any
   */ go (input) {
        const state = this;
        const nextState = state.j[input];
        if (nextState) return nextState;
        for(let i = 0; i < state.jr.length; i++){
            const regex = state.jr[i][0];
            const nextState = state.jr[i][1]; // note: might be empty to prevent default jump
            if (nextState && regex.test(input)) return nextState;
        }
        // Nowhere left to jump! Return default, if any
        return state.jd;
    },
    /**
   * Whether the state has a transition for the given input. Set the second
   * argument to true to only look for an exact match (and not a default or
   * regular-expression-based transition)
   * @param {string} input
   * @param {boolean} exactOnly
   */ has (input, exactOnly) {
        if (exactOnly === void 0) exactOnly = false;
        return exactOnly ? input in this.j : !!this.go(input);
    },
    /**
   * Short for "transition all"; create a transition from the array of items
   * in the given list to the same final resulting state.
   * @param {string | string[]} inputs Group of inputs to transition on
   * @param {Transition<T> | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   */ ta (inputs, next, flags, groups) {
        for(let i = 0; i < inputs.length; i++)this.tt(inputs[i], next, flags, groups);
    },
    /**
   * Short for "take regexp transition"; defines a transition for this state
   * when it encounters a token which matches the given regular expression
   * @param {RegExp} regexp Regular expression transition (populate first)
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */ tr (regexp, next, flags, groups) {
        groups = groups || $efca0cb2e3ea1e67$export$7254cc27399e90bd.groups;
        let nextState;
        if (next && next.j) nextState = next;
        else {
            // Token with maybe token groups
            nextState = new $efca0cb2e3ea1e67$export$7254cc27399e90bd(next);
            if (flags && groups) $efca0cb2e3ea1e67$var$addToGroups(next, flags, groups);
        }
        this.jr.push([
            regexp,
            nextState
        ]);
        return nextState;
    },
    /**
   * Short for "take transitions", will take as many sequential transitions as
   * the length of the given input and returns the
   * resulting final state.
   * @param {string | string[]} input
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */ ts (input, next, flags, groups) {
        let state = this;
        const len = input.length;
        if (!len) return state;
        for(let i = 0; i < len - 1; i++)state = state.tt(input[i]);
        return state.tt(input[len - 1], next, flags, groups);
    },
    /**
   * Short for "take transition", this is a method for building/working with
   * state machines.
   *
   * If a state already exists for the given input, returns it.
   *
   * If a token is specified, that state will emit that token when reached by
   * the linkify engine.
   *
   * If no state exists, it will be initialized with some default transitions
   * that resemble existing default transitions.
   *
   * If a state is given for the second argument, that state will be
   * transitioned to on the given input regardless of what that input
   * previously did.
   *
   * Specify a token group flags to define groups that this token belongs to.
   * The token will be added to corresponding entires in the given groups
   * object.
   *
   * @param {string} input character, token type to transition on
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of groups
   * @returns {State<T>} taken after the given input
   */ tt (input, next, flags, groups) {
        groups = groups || $efca0cb2e3ea1e67$export$7254cc27399e90bd.groups;
        const state = this;
        // Check if existing state given, just a basic transition
        if (next && next.j) {
            state.j[input] = next;
            return next;
        }
        const t = next;
        // Take the transition with the usual default mechanisms and use that as
        // a template for creating the next state
        let nextState, templateState = state.go(input);
        if (templateState) {
            nextState = new $efca0cb2e3ea1e67$export$7254cc27399e90bd();
            $efca0cb2e3ea1e67$var$assign(nextState.j, templateState.j);
            nextState.jr.push.apply(nextState.jr, templateState.jr);
            nextState.jd = templateState.jd;
            nextState.t = templateState.t;
        } else nextState = new $efca0cb2e3ea1e67$export$7254cc27399e90bd();
        if (t) {
            // Ensure newly token is in the same groups as the old token
            if (groups) {
                if (nextState.t && typeof nextState.t === "string") {
                    const allFlags = $efca0cb2e3ea1e67$var$assign($efca0cb2e3ea1e67$var$flagsForToken(nextState.t, groups), flags);
                    $efca0cb2e3ea1e67$var$addToGroups(t, allFlags, groups);
                } else if (flags) $efca0cb2e3ea1e67$var$addToGroups(t, flags, groups);
            }
            nextState.t = t; // overwrite anything that was previously there
        }
        state.j[input] = nextState;
        return nextState;
    }
};
// Helper functions to improve minification (not exported outside linkifyjs module)
/**
 * @template T
 * @param {State<T>} state
 * @param {string | string[]} input
 * @param {Flags} [flags]
 * @param {Collections<T>} [groups]
 */ const $efca0cb2e3ea1e67$var$ta = (state, input, next, flags, groups)=>state.ta(input, next, flags, groups);
/**
 * @template T
 * @param {State<T>} state
 * @param {RegExp} regexp
 * @param {T | State<T>} [next]
 * @param {Flags} [flags]
 * @param {Collections<T>} [groups]
 */ const $efca0cb2e3ea1e67$var$tr = (state, regexp, next, flags, groups)=>state.tr(regexp, next, flags, groups);
/**
 * @template T
 * @param {State<T>} state
 * @param {string | string[]} input
 * @param {T | State<T>} [next]
 * @param {Flags} [flags]
 * @param {Collections<T>} [groups]
 */ const $efca0cb2e3ea1e67$var$ts = (state, input, next, flags, groups)=>state.ts(input, next, flags, groups);
/**
 * @template T
 * @param {State<T>} state
 * @param {string} input
 * @param {T | State<T>} [next]
 * @param {Collections<T>} [groups]
 * @param {Flags} [flags]
 */ const $efca0cb2e3ea1e67$var$tt = (state, input, next, flags, groups)=>state.tt(input, next, flags, groups);
/******************************************************************************
Text Tokens
Identifiers for token outputs from the regexp scanner
******************************************************************************/ // A valid web domain token
const $efca0cb2e3ea1e67$var$WORD = "WORD"; // only contains a-z
const $efca0cb2e3ea1e67$var$UWORD = "UWORD"; // contains letters other than a-z, used for IDN
// Special case of word
const $efca0cb2e3ea1e67$var$LOCALHOST = "LOCALHOST";
// Valid top-level domain, special case of WORD (see tlds.js)
const $efca0cb2e3ea1e67$var$TLD = "TLD";
// Valid IDN TLD, special case of UWORD (see tlds.js)
const $efca0cb2e3ea1e67$var$UTLD = "UTLD";
// The scheme portion of a web URI protocol. Supported types include: `mailto`,
// `file`, and user-defined custom protocols. Limited to schemes that contain
// only letters
const $efca0cb2e3ea1e67$var$SCHEME = "SCHEME";
// Similar to SCHEME, except makes distinction for schemes that must always be
// followed by `://`, not just `:`. Supported types include `http`, `https`,
// `ftp`, `ftps`
const $efca0cb2e3ea1e67$var$SLASH_SCHEME = "SLASH_SCHEME";
// Any sequence of digits 0-9
const $efca0cb2e3ea1e67$var$NUM = "NUM";
// Any number of consecutive whitespace characters that are not newline
const $efca0cb2e3ea1e67$var$WS = "WS";
// New line (unix style)
const $efca0cb2e3ea1e67$var$NL$1 = "NL"; // \n
// Opening/closing bracket classes
// TODO: Rename OPEN -> LEFT and CLOSE -> RIGHT in v5 to fit with Unicode names
// Also rename angle brackes to LESSTHAN and GREATER THAN
const $efca0cb2e3ea1e67$var$OPENBRACE = "OPENBRACE"; // {
const $efca0cb2e3ea1e67$var$CLOSEBRACE = "CLOSEBRACE"; // }
const $efca0cb2e3ea1e67$var$OPENBRACKET = "OPENBRACKET"; // [
const $efca0cb2e3ea1e67$var$CLOSEBRACKET = "CLOSEBRACKET"; // ]
const $efca0cb2e3ea1e67$var$OPENPAREN = "OPENPAREN"; // (
const $efca0cb2e3ea1e67$var$CLOSEPAREN = "CLOSEPAREN"; // )
const $efca0cb2e3ea1e67$var$OPENANGLEBRACKET = "OPENANGLEBRACKET"; // <
const $efca0cb2e3ea1e67$var$CLOSEANGLEBRACKET = "CLOSEANGLEBRACKET"; // >
const $efca0cb2e3ea1e67$var$FULLWIDTHLEFTPAREN = "FULLWIDTHLEFTPAREN"; // （
const $efca0cb2e3ea1e67$var$FULLWIDTHRIGHTPAREN = "FULLWIDTHRIGHTPAREN"; // ）
const $efca0cb2e3ea1e67$var$LEFTCORNERBRACKET = "LEFTCORNERBRACKET"; // 「
const $efca0cb2e3ea1e67$var$RIGHTCORNERBRACKET = "RIGHTCORNERBRACKET"; // 」
const $efca0cb2e3ea1e67$var$LEFTWHITECORNERBRACKET = "LEFTWHITECORNERBRACKET"; // 『
const $efca0cb2e3ea1e67$var$RIGHTWHITECORNERBRACKET = "RIGHTWHITECORNERBRACKET"; // 』
const $efca0cb2e3ea1e67$var$FULLWIDTHLESSTHAN = "FULLWIDTHLESSTHAN"; // ＜
const $efca0cb2e3ea1e67$var$FULLWIDTHGREATERTHAN = "FULLWIDTHGREATERTHAN"; // ＞
// Various symbols
const $efca0cb2e3ea1e67$var$AMPERSAND = "AMPERSAND"; // &
const $efca0cb2e3ea1e67$var$APOSTROPHE = "APOSTROPHE"; // '
const $efca0cb2e3ea1e67$var$ASTERISK = "ASTERISK"; // *
const $efca0cb2e3ea1e67$var$AT = "AT"; // @
const $efca0cb2e3ea1e67$var$BACKSLASH = "BACKSLASH"; // \
const $efca0cb2e3ea1e67$var$BACKTICK = "BACKTICK"; // `
const $efca0cb2e3ea1e67$var$CARET = "CARET"; // ^
const $efca0cb2e3ea1e67$var$COLON = "COLON"; // :
const $efca0cb2e3ea1e67$var$COMMA = "COMMA"; // ,
const $efca0cb2e3ea1e67$var$DOLLAR = "DOLLAR"; // $
const $efca0cb2e3ea1e67$var$DOT = "DOT"; // .
const $efca0cb2e3ea1e67$var$EQUALS = "EQUALS"; // =
const $efca0cb2e3ea1e67$var$EXCLAMATION = "EXCLAMATION"; // !
const $efca0cb2e3ea1e67$var$HYPHEN = "HYPHEN"; // -
const $efca0cb2e3ea1e67$var$PERCENT = "PERCENT"; // %
const $efca0cb2e3ea1e67$var$PIPE = "PIPE"; // |
const $efca0cb2e3ea1e67$var$PLUS = "PLUS"; // +
const $efca0cb2e3ea1e67$var$POUND = "POUND"; // #
const $efca0cb2e3ea1e67$var$QUERY = "QUERY"; // ?
const $efca0cb2e3ea1e67$var$QUOTE = "QUOTE"; // "
const $efca0cb2e3ea1e67$var$SEMI = "SEMI"; // ;
const $efca0cb2e3ea1e67$var$SLASH = "SLASH"; // /
const $efca0cb2e3ea1e67$var$TILDE = "TILDE"; // ~
const $efca0cb2e3ea1e67$var$UNDERSCORE = "UNDERSCORE"; // _
// Emoji symbol
const $efca0cb2e3ea1e67$var$EMOJI$1 = "EMOJI";
// Default token - anything that is not one of the above
const $efca0cb2e3ea1e67$var$SYM = "SYM";
var $efca0cb2e3ea1e67$var$tk = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    WORD: $efca0cb2e3ea1e67$var$WORD,
    UWORD: $efca0cb2e3ea1e67$var$UWORD,
    LOCALHOST: $efca0cb2e3ea1e67$var$LOCALHOST,
    TLD: $efca0cb2e3ea1e67$var$TLD,
    UTLD: $efca0cb2e3ea1e67$var$UTLD,
    SCHEME: $efca0cb2e3ea1e67$var$SCHEME,
    SLASH_SCHEME: $efca0cb2e3ea1e67$var$SLASH_SCHEME,
    NUM: $efca0cb2e3ea1e67$var$NUM,
    WS: $efca0cb2e3ea1e67$var$WS,
    NL: $efca0cb2e3ea1e67$var$NL$1,
    OPENBRACE: $efca0cb2e3ea1e67$var$OPENBRACE,
    CLOSEBRACE: $efca0cb2e3ea1e67$var$CLOSEBRACE,
    OPENBRACKET: $efca0cb2e3ea1e67$var$OPENBRACKET,
    CLOSEBRACKET: $efca0cb2e3ea1e67$var$CLOSEBRACKET,
    OPENPAREN: $efca0cb2e3ea1e67$var$OPENPAREN,
    CLOSEPAREN: $efca0cb2e3ea1e67$var$CLOSEPAREN,
    OPENANGLEBRACKET: $efca0cb2e3ea1e67$var$OPENANGLEBRACKET,
    CLOSEANGLEBRACKET: $efca0cb2e3ea1e67$var$CLOSEANGLEBRACKET,
    FULLWIDTHLEFTPAREN: $efca0cb2e3ea1e67$var$FULLWIDTHLEFTPAREN,
    FULLWIDTHRIGHTPAREN: $efca0cb2e3ea1e67$var$FULLWIDTHRIGHTPAREN,
    LEFTCORNERBRACKET: $efca0cb2e3ea1e67$var$LEFTCORNERBRACKET,
    RIGHTCORNERBRACKET: $efca0cb2e3ea1e67$var$RIGHTCORNERBRACKET,
    LEFTWHITECORNERBRACKET: $efca0cb2e3ea1e67$var$LEFTWHITECORNERBRACKET,
    RIGHTWHITECORNERBRACKET: $efca0cb2e3ea1e67$var$RIGHTWHITECORNERBRACKET,
    FULLWIDTHLESSTHAN: $efca0cb2e3ea1e67$var$FULLWIDTHLESSTHAN,
    FULLWIDTHGREATERTHAN: $efca0cb2e3ea1e67$var$FULLWIDTHGREATERTHAN,
    AMPERSAND: $efca0cb2e3ea1e67$var$AMPERSAND,
    APOSTROPHE: $efca0cb2e3ea1e67$var$APOSTROPHE,
    ASTERISK: $efca0cb2e3ea1e67$var$ASTERISK,
    AT: $efca0cb2e3ea1e67$var$AT,
    BACKSLASH: $efca0cb2e3ea1e67$var$BACKSLASH,
    BACKTICK: $efca0cb2e3ea1e67$var$BACKTICK,
    CARET: $efca0cb2e3ea1e67$var$CARET,
    COLON: $efca0cb2e3ea1e67$var$COLON,
    COMMA: $efca0cb2e3ea1e67$var$COMMA,
    DOLLAR: $efca0cb2e3ea1e67$var$DOLLAR,
    DOT: $efca0cb2e3ea1e67$var$DOT,
    EQUALS: $efca0cb2e3ea1e67$var$EQUALS,
    EXCLAMATION: $efca0cb2e3ea1e67$var$EXCLAMATION,
    HYPHEN: $efca0cb2e3ea1e67$var$HYPHEN,
    PERCENT: $efca0cb2e3ea1e67$var$PERCENT,
    PIPE: $efca0cb2e3ea1e67$var$PIPE,
    PLUS: $efca0cb2e3ea1e67$var$PLUS,
    POUND: $efca0cb2e3ea1e67$var$POUND,
    QUERY: $efca0cb2e3ea1e67$var$QUERY,
    QUOTE: $efca0cb2e3ea1e67$var$QUOTE,
    SEMI: $efca0cb2e3ea1e67$var$SEMI,
    SLASH: $efca0cb2e3ea1e67$var$SLASH,
    TILDE: $efca0cb2e3ea1e67$var$TILDE,
    UNDERSCORE: $efca0cb2e3ea1e67$var$UNDERSCORE,
    EMOJI: $efca0cb2e3ea1e67$var$EMOJI$1,
    SYM: $efca0cb2e3ea1e67$var$SYM
});
// Note that these two Unicode ones expand into a really big one with Babel
const $efca0cb2e3ea1e67$var$ASCII_LETTER = /[a-z]/;
const $efca0cb2e3ea1e67$var$LETTER = /\p{L}/u; // Any Unicode character with letter data type
const $efca0cb2e3ea1e67$var$EMOJI = /\p{Emoji}/u; // Any Unicode emoji character
const $efca0cb2e3ea1e67$var$EMOJI_VARIATION$1 = /\ufe0f/;
const $efca0cb2e3ea1e67$var$DIGIT = /\d/;
const $efca0cb2e3ea1e67$var$SPACE = /\s/;
var $efca0cb2e3ea1e67$export$efdc1e5bdb609bb = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ASCII_LETTER: $efca0cb2e3ea1e67$var$ASCII_LETTER,
    LETTER: $efca0cb2e3ea1e67$var$LETTER,
    EMOJI: $efca0cb2e3ea1e67$var$EMOJI,
    EMOJI_VARIATION: $efca0cb2e3ea1e67$var$EMOJI_VARIATION$1,
    DIGIT: $efca0cb2e3ea1e67$var$DIGIT,
    SPACE: $efca0cb2e3ea1e67$var$SPACE
});
/**
	The scanner provides an interface that takes a string of text as input, and
	outputs an array of tokens instances that can be used for easy URL parsing.
*/ const $efca0cb2e3ea1e67$var$NL = "\n"; // New line character
const $efca0cb2e3ea1e67$var$EMOJI_VARIATION = "\uFE0F"; // Variation selector, follows heart and others
const $efca0cb2e3ea1e67$var$EMOJI_JOINER = "\u200D"; // zero-width joiner
let $efca0cb2e3ea1e67$var$tlds = null, $efca0cb2e3ea1e67$var$utlds = null; // don't change so only have to be computed once
/**
 * Scanner output token:
 * - `t` is the token name (e.g., 'NUM', 'EMOJI', 'TLD')
 * - `v` is the value of the token (e.g., '123', '❤️', 'com')
 * - `s` is the start index of the token in the original string
 * - `e` is the end index of the token in the original string
 * @typedef {{t: string, v: string, s: number, e: number}} Token
 */ /**
 * @template T
 * @typedef {{ [collection: string]: T[] }} Collections
 */ /**
 * Initialize the scanner character-based state machine for the given start
 * state
 * @param {[string, boolean][]} customSchemes List of custom schemes, where each
 * item is a length-2 tuple with the first element set to the string scheme, and
 * the second element set to `true` if the `://` after the scheme is optional
 */ function $efca0cb2e3ea1e67$var$init$2(customSchemes) {
    if (customSchemes === void 0) customSchemes = [];
    // Frequently used states (name argument removed during minification)
    /** @type Collections<string> */ const groups = {}; // of tokens
    $efca0cb2e3ea1e67$export$7254cc27399e90bd.groups = groups;
    /** @type State<string> */ const Start = new $efca0cb2e3ea1e67$export$7254cc27399e90bd();
    if ($efca0cb2e3ea1e67$var$tlds == null) $efca0cb2e3ea1e67$var$tlds = $efca0cb2e3ea1e67$var$decodeTlds($efca0cb2e3ea1e67$var$encodedTlds);
    if ($efca0cb2e3ea1e67$var$utlds == null) $efca0cb2e3ea1e67$var$utlds = $efca0cb2e3ea1e67$var$decodeTlds($efca0cb2e3ea1e67$var$encodedUtlds);
    // States for special URL symbols that accept immediately after start
    $efca0cb2e3ea1e67$var$tt(Start, "'", $efca0cb2e3ea1e67$var$APOSTROPHE);
    $efca0cb2e3ea1e67$var$tt(Start, "{", $efca0cb2e3ea1e67$var$OPENBRACE);
    $efca0cb2e3ea1e67$var$tt(Start, "}", $efca0cb2e3ea1e67$var$CLOSEBRACE);
    $efca0cb2e3ea1e67$var$tt(Start, "[", $efca0cb2e3ea1e67$var$OPENBRACKET);
    $efca0cb2e3ea1e67$var$tt(Start, "]", $efca0cb2e3ea1e67$var$CLOSEBRACKET);
    $efca0cb2e3ea1e67$var$tt(Start, "(", $efca0cb2e3ea1e67$var$OPENPAREN);
    $efca0cb2e3ea1e67$var$tt(Start, ")", $efca0cb2e3ea1e67$var$CLOSEPAREN);
    $efca0cb2e3ea1e67$var$tt(Start, "<", $efca0cb2e3ea1e67$var$OPENANGLEBRACKET);
    $efca0cb2e3ea1e67$var$tt(Start, ">", $efca0cb2e3ea1e67$var$CLOSEANGLEBRACKET);
    $efca0cb2e3ea1e67$var$tt(Start, "\uFF08", $efca0cb2e3ea1e67$var$FULLWIDTHLEFTPAREN);
    $efca0cb2e3ea1e67$var$tt(Start, "\uFF09", $efca0cb2e3ea1e67$var$FULLWIDTHRIGHTPAREN);
    $efca0cb2e3ea1e67$var$tt(Start, "\u300C", $efca0cb2e3ea1e67$var$LEFTCORNERBRACKET);
    $efca0cb2e3ea1e67$var$tt(Start, "\u300D", $efca0cb2e3ea1e67$var$RIGHTCORNERBRACKET);
    $efca0cb2e3ea1e67$var$tt(Start, "\u300E", $efca0cb2e3ea1e67$var$LEFTWHITECORNERBRACKET);
    $efca0cb2e3ea1e67$var$tt(Start, "\u300F", $efca0cb2e3ea1e67$var$RIGHTWHITECORNERBRACKET);
    $efca0cb2e3ea1e67$var$tt(Start, "\uFF1C", $efca0cb2e3ea1e67$var$FULLWIDTHLESSTHAN);
    $efca0cb2e3ea1e67$var$tt(Start, "\uFF1E", $efca0cb2e3ea1e67$var$FULLWIDTHGREATERTHAN);
    $efca0cb2e3ea1e67$var$tt(Start, "&", $efca0cb2e3ea1e67$var$AMPERSAND);
    $efca0cb2e3ea1e67$var$tt(Start, "*", $efca0cb2e3ea1e67$var$ASTERISK);
    $efca0cb2e3ea1e67$var$tt(Start, "@", $efca0cb2e3ea1e67$var$AT);
    $efca0cb2e3ea1e67$var$tt(Start, "`", $efca0cb2e3ea1e67$var$BACKTICK);
    $efca0cb2e3ea1e67$var$tt(Start, "^", $efca0cb2e3ea1e67$var$CARET);
    $efca0cb2e3ea1e67$var$tt(Start, ":", $efca0cb2e3ea1e67$var$COLON);
    $efca0cb2e3ea1e67$var$tt(Start, ",", $efca0cb2e3ea1e67$var$COMMA);
    $efca0cb2e3ea1e67$var$tt(Start, "$", $efca0cb2e3ea1e67$var$DOLLAR);
    $efca0cb2e3ea1e67$var$tt(Start, ".", $efca0cb2e3ea1e67$var$DOT);
    $efca0cb2e3ea1e67$var$tt(Start, "=", $efca0cb2e3ea1e67$var$EQUALS);
    $efca0cb2e3ea1e67$var$tt(Start, "!", $efca0cb2e3ea1e67$var$EXCLAMATION);
    $efca0cb2e3ea1e67$var$tt(Start, "-", $efca0cb2e3ea1e67$var$HYPHEN);
    $efca0cb2e3ea1e67$var$tt(Start, "%", $efca0cb2e3ea1e67$var$PERCENT);
    $efca0cb2e3ea1e67$var$tt(Start, "|", $efca0cb2e3ea1e67$var$PIPE);
    $efca0cb2e3ea1e67$var$tt(Start, "+", $efca0cb2e3ea1e67$var$PLUS);
    $efca0cb2e3ea1e67$var$tt(Start, "#", $efca0cb2e3ea1e67$var$POUND);
    $efca0cb2e3ea1e67$var$tt(Start, "?", $efca0cb2e3ea1e67$var$QUERY);
    $efca0cb2e3ea1e67$var$tt(Start, '"', $efca0cb2e3ea1e67$var$QUOTE);
    $efca0cb2e3ea1e67$var$tt(Start, "/", $efca0cb2e3ea1e67$var$SLASH);
    $efca0cb2e3ea1e67$var$tt(Start, ";", $efca0cb2e3ea1e67$var$SEMI);
    $efca0cb2e3ea1e67$var$tt(Start, "~", $efca0cb2e3ea1e67$var$TILDE);
    $efca0cb2e3ea1e67$var$tt(Start, "_", $efca0cb2e3ea1e67$var$UNDERSCORE);
    $efca0cb2e3ea1e67$var$tt(Start, "\\", $efca0cb2e3ea1e67$var$BACKSLASH);
    const Num = $efca0cb2e3ea1e67$var$tr(Start, $efca0cb2e3ea1e67$var$DIGIT, $efca0cb2e3ea1e67$var$NUM, {
        [$efca0cb2e3ea1e67$var$numeric]: true
    });
    $efca0cb2e3ea1e67$var$tr(Num, $efca0cb2e3ea1e67$var$DIGIT, Num);
    // State which emits a word token
    const Word = $efca0cb2e3ea1e67$var$tr(Start, $efca0cb2e3ea1e67$var$ASCII_LETTER, $efca0cb2e3ea1e67$var$WORD, {
        [$efca0cb2e3ea1e67$var$ascii]: true
    });
    $efca0cb2e3ea1e67$var$tr(Word, $efca0cb2e3ea1e67$var$ASCII_LETTER, Word);
    // Same as previous, but specific to non-fsm.ascii alphabet words
    const UWord = $efca0cb2e3ea1e67$var$tr(Start, $efca0cb2e3ea1e67$var$LETTER, $efca0cb2e3ea1e67$var$UWORD, {
        [$efca0cb2e3ea1e67$var$alpha]: true
    });
    $efca0cb2e3ea1e67$var$tr(UWord, $efca0cb2e3ea1e67$var$ASCII_LETTER); // Non-accepting
    $efca0cb2e3ea1e67$var$tr(UWord, $efca0cb2e3ea1e67$var$LETTER, UWord);
    // Whitespace jumps
    // Tokens of only non-newline whitespace are arbitrarily long
    // If any whitespace except newline, more whitespace!
    const Ws = $efca0cb2e3ea1e67$var$tr(Start, $efca0cb2e3ea1e67$var$SPACE, $efca0cb2e3ea1e67$var$WS, {
        [$efca0cb2e3ea1e67$var$whitespace]: true
    });
    $efca0cb2e3ea1e67$var$tt(Start, $efca0cb2e3ea1e67$var$NL, $efca0cb2e3ea1e67$var$NL$1, {
        [$efca0cb2e3ea1e67$var$whitespace]: true
    });
    $efca0cb2e3ea1e67$var$tt(Ws, $efca0cb2e3ea1e67$var$NL); // non-accepting state to avoid mixing whitespaces
    $efca0cb2e3ea1e67$var$tr(Ws, $efca0cb2e3ea1e67$var$SPACE, Ws);
    // Emoji tokens. They are not grouped by the scanner except in cases where a
    // zero-width joiner is present
    const Emoji = $efca0cb2e3ea1e67$var$tr(Start, $efca0cb2e3ea1e67$var$EMOJI, $efca0cb2e3ea1e67$var$EMOJI$1, {
        [$efca0cb2e3ea1e67$var$emoji]: true
    });
    $efca0cb2e3ea1e67$var$tr(Emoji, $efca0cb2e3ea1e67$var$EMOJI, Emoji);
    $efca0cb2e3ea1e67$var$tt(Emoji, $efca0cb2e3ea1e67$var$EMOJI_VARIATION, Emoji);
    // tt(Start, EMOJI_VARIATION, Emoji); // This one is sketchy
    const EmojiJoiner = $efca0cb2e3ea1e67$var$tt(Emoji, $efca0cb2e3ea1e67$var$EMOJI_JOINER);
    $efca0cb2e3ea1e67$var$tr(EmojiJoiner, $efca0cb2e3ea1e67$var$EMOJI, Emoji);
    // tt(EmojiJoiner, EMOJI_VARIATION, Emoji); // also sketchy
    // Generates states for top-level domains
    // Note that this is most accurate when tlds are in alphabetical order
    const wordjr = [
        [
            $efca0cb2e3ea1e67$var$ASCII_LETTER,
            Word
        ]
    ];
    const uwordjr = [
        [
            $efca0cb2e3ea1e67$var$ASCII_LETTER,
            null
        ],
        [
            $efca0cb2e3ea1e67$var$LETTER,
            UWord
        ]
    ];
    for(let i = 0; i < $efca0cb2e3ea1e67$var$tlds.length; i++)$efca0cb2e3ea1e67$var$fastts(Start, $efca0cb2e3ea1e67$var$tlds[i], $efca0cb2e3ea1e67$var$TLD, $efca0cb2e3ea1e67$var$WORD, wordjr);
    for(let i = 0; i < $efca0cb2e3ea1e67$var$utlds.length; i++)$efca0cb2e3ea1e67$var$fastts(Start, $efca0cb2e3ea1e67$var$utlds[i], $efca0cb2e3ea1e67$var$UTLD, $efca0cb2e3ea1e67$var$UWORD, uwordjr);
    $efca0cb2e3ea1e67$var$addToGroups($efca0cb2e3ea1e67$var$TLD, {
        tld: true,
        ascii: true
    }, groups);
    $efca0cb2e3ea1e67$var$addToGroups($efca0cb2e3ea1e67$var$UTLD, {
        utld: true,
        alpha: true
    }, groups);
    // Collect the states generated by different protocols. NOTE: If any new TLDs
    // get added that are also protocols, set the token to be the same as the
    // protocol to ensure parsing works as expected.
    $efca0cb2e3ea1e67$var$fastts(Start, "file", $efca0cb2e3ea1e67$var$SCHEME, $efca0cb2e3ea1e67$var$WORD, wordjr);
    $efca0cb2e3ea1e67$var$fastts(Start, "mailto", $efca0cb2e3ea1e67$var$SCHEME, $efca0cb2e3ea1e67$var$WORD, wordjr);
    $efca0cb2e3ea1e67$var$fastts(Start, "http", $efca0cb2e3ea1e67$var$SLASH_SCHEME, $efca0cb2e3ea1e67$var$WORD, wordjr);
    $efca0cb2e3ea1e67$var$fastts(Start, "https", $efca0cb2e3ea1e67$var$SLASH_SCHEME, $efca0cb2e3ea1e67$var$WORD, wordjr);
    $efca0cb2e3ea1e67$var$fastts(Start, "ftp", $efca0cb2e3ea1e67$var$SLASH_SCHEME, $efca0cb2e3ea1e67$var$WORD, wordjr);
    $efca0cb2e3ea1e67$var$fastts(Start, "ftps", $efca0cb2e3ea1e67$var$SLASH_SCHEME, $efca0cb2e3ea1e67$var$WORD, wordjr);
    $efca0cb2e3ea1e67$var$addToGroups($efca0cb2e3ea1e67$var$SCHEME, {
        scheme: true,
        ascii: true
    }, groups);
    $efca0cb2e3ea1e67$var$addToGroups($efca0cb2e3ea1e67$var$SLASH_SCHEME, {
        slashscheme: true,
        ascii: true
    }, groups);
    // Register custom schemes. Assumes each scheme is asciinumeric with hyphens
    customSchemes = customSchemes.sort((a, b)=>a[0] > b[0] ? 1 : -1);
    for(let i = 0; i < customSchemes.length; i++){
        const sch = customSchemes[i][0];
        const optionalSlashSlash = customSchemes[i][1];
        const flags = optionalSlashSlash ? {
            [$efca0cb2e3ea1e67$var$scheme]: true
        } : {
            [$efca0cb2e3ea1e67$var$slashscheme]: true
        };
        if (sch.indexOf("-") >= 0) flags[$efca0cb2e3ea1e67$var$domain] = true;
        else if (!$efca0cb2e3ea1e67$var$ASCII_LETTER.test(sch)) flags[$efca0cb2e3ea1e67$var$numeric] = true; // numbers only
        else if ($efca0cb2e3ea1e67$var$DIGIT.test(sch)) flags[$efca0cb2e3ea1e67$var$asciinumeric] = true;
        else flags[$efca0cb2e3ea1e67$var$ascii] = true;
        $efca0cb2e3ea1e67$var$ts(Start, sch, sch, flags);
    }
    // Localhost token
    $efca0cb2e3ea1e67$var$ts(Start, "localhost", $efca0cb2e3ea1e67$var$LOCALHOST, {
        ascii: true
    });
    // Set default transition for start state (some symbol)
    Start.jd = new $efca0cb2e3ea1e67$export$7254cc27399e90bd($efca0cb2e3ea1e67$var$SYM);
    return {
        start: Start,
        tokens: $efca0cb2e3ea1e67$var$assign({
            groups: groups
        }, $efca0cb2e3ea1e67$var$tk)
    };
}
/**
	Given a string, returns an array of TOKEN instances representing the
	composition of that string.

	@method run
	@param {State<string>} start scanner starting state
	@param {string} str input string to scan
	@return {Token[]} list of tokens, each with a type and value
*/ function $efca0cb2e3ea1e67$var$run$1(start, str) {
    // State machine is not case sensitive, so input is tokenized in lowercased
    // form (still returns regular case). Uses selective `toLowerCase` because
    // lowercasing the entire string causes the length and character position to
    // vary in some non-English strings with V8-based runtimes.
    const iterable = $efca0cb2e3ea1e67$export$b9ca061da17f2d30(str.replace(/[A-Z]/g, (c)=>c.toLowerCase()));
    const charCount = iterable.length; // <= len if there are emojis, etc
    const tokens = []; // return value
    // cursor through the string itself, accounting for characters that have
    // width with length 2 such as emojis
    let cursor = 0;
    // Cursor through the array-representation of the string
    let charCursor = 0;
    // Tokenize the string
    while(charCursor < charCount){
        let state = start;
        let nextState = null;
        let tokenLength = 0;
        let latestAccepting = null;
        let sinceAccepts = -1;
        let charsSinceAccepts = -1;
        while(charCursor < charCount && (nextState = state.go(iterable[charCursor]))){
            state = nextState;
            // Keep track of the latest accepting state
            if (state.accepts()) {
                sinceAccepts = 0;
                charsSinceAccepts = 0;
                latestAccepting = state;
            } else if (sinceAccepts >= 0) {
                sinceAccepts += iterable[charCursor].length;
                charsSinceAccepts++;
            }
            tokenLength += iterable[charCursor].length;
            cursor += iterable[charCursor].length;
            charCursor++;
        }
        // Roll back to the latest accepting state
        cursor -= sinceAccepts;
        charCursor -= charsSinceAccepts;
        tokenLength -= sinceAccepts;
        // No more jumps, just make a new token from the last accepting one
        tokens.push({
            t: latestAccepting.t,
            // token type/name
            v: str.slice(cursor - tokenLength, cursor),
            // string value
            s: cursor - tokenLength,
            // start index
            e: cursor // end index (excluding)
        });
    }
    return tokens;
}
/**
 * Convert a String to an Array of characters, taking into account that some
 * characters like emojis take up two string indexes.
 *
 * Adapted from core-js (MIT license)
 * https://github.com/zloirock/core-js/blob/2d69cf5f99ab3ea3463c395df81e5a15b68f49d9/packages/core-js/internals/string-multibyte.js
 *
 * @function stringToArray
 * @param {string} str
 * @returns {string[]}
 */ function $efca0cb2e3ea1e67$export$b9ca061da17f2d30(str) {
    const result = [];
    const len = str.length;
    let index = 0;
    while(index < len){
        let first = str.charCodeAt(index);
        let second;
        let char = first < 0xd800 || first > 0xdbff || index + 1 === len || (second = str.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? str[index] // single character
         : str.slice(index, index + 2); // two-index characters
        result.push(char);
        index += char.length;
    }
    return result;
}
/**
 * Fast version of ts function for when transition defaults are well known
 * @param {State<string>} state
 * @param {string} input
 * @param {string} t
 * @param {string} defaultt
 * @param {[RegExp, State<string>][]} jr
 * @returns {State<string>}
 */ function $efca0cb2e3ea1e67$var$fastts(state, input, t, defaultt, jr) {
    let next;
    const len = input.length;
    for(let i = 0; i < len - 1; i++){
        const char = input[i];
        if (state.j[char]) next = state.j[char];
        else {
            next = new $efca0cb2e3ea1e67$export$7254cc27399e90bd(defaultt);
            next.jr = jr.slice();
            state.j[char] = next;
        }
        state = next;
    }
    next = new $efca0cb2e3ea1e67$export$7254cc27399e90bd(t);
    next.jr = jr.slice();
    state.j[input[len - 1]] = next;
    return next;
}
/**
 * Converts a string of Top-Level Domain names encoded in update-tlds.js back
 * into a list of strings.
 * @param {str} encoded encoded TLDs string
 * @returns {str[]} original TLDs list
 */ function $efca0cb2e3ea1e67$var$decodeTlds(encoded) {
    const words = [];
    const stack = [];
    let i = 0;
    let digits = "0123456789";
    while(i < encoded.length){
        let popDigitCount = 0;
        while(digits.indexOf(encoded[i + popDigitCount]) >= 0)popDigitCount++; // encountered some digits, have to pop to go one level up trie
        if (popDigitCount > 0) {
            words.push(stack.join("")); // whatever preceded the pop digits must be a word
            for(let popCount = parseInt(encoded.substring(i, i + popDigitCount), 10); popCount > 0; popCount--)stack.pop();
            i += popDigitCount;
        } else {
            stack.push(encoded[i]); // drop down a level into the trie
            i++;
        }
    }
    return words;
}
/**
 * An object where each key is a valid DOM Event Name such as `click` or `focus`
 * and each value is an event handler function.
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/Element#events
 * @typedef {?{ [event: string]: Function }} EventListeners
 */ /**
 * All formatted properties required to render a link, including `tagName`,
 * `attributes`, `content` and `eventListeners`.
 * @typedef {{ tagName: any, attributes: {[attr: string]: any}, content: string,
 * eventListeners: EventListeners }} IntermediateRepresentation
 */ /**
 * Specify either an object described by the template type `O` or a function.
 *
 * The function takes a string value (usually the link's href attribute), the
 * link type (`'url'`, `'hashtag`', etc.) and an internal token representation
 * of the link. It should return an object of the template type `O`
 * @template O
 * @typedef {O | ((value: string, type: string, token: MultiToken) => O)} OptObj
 */ /**
 * Specify either a function described by template type `F` or an object.
 *
 * Each key in the object should be a link type (`'url'`, `'hashtag`', etc.). Each
 * value should be a function with template type `F` that is called when the
 * corresponding link type is encountered.
 * @template F
 * @typedef {F | { [type: string]: F}} OptFn
 */ /**
 * Specify either a value with template type `V`, a function that returns `V` or
 * an object where each value resolves to `V`.
 *
 * The function takes a string value (usually the link's href attribute), the
 * link type (`'url'`, `'hashtag`', etc.) and an internal token representation
 * of the link. It should return an object of the template type `V`
 *
 * For the object, each key should be a link type (`'url'`, `'hashtag`', etc.).
 * Each value should either have type `V` or a function that returns V. This
 * function similarly takes a string value and a token.
 *
 * Example valid types for `Opt<string>`:
 *
 * ```js
 * 'hello'
 * (value, type, token) => 'world'
 * { url: 'hello', email: (value, token) => 'world'}
 * ```
 * @template V
 * @typedef {V | ((value: string, type: string, token: MultiToken) => V) | { [type: string]: V | ((value: string, token: MultiToken) => V) }} Opt
 */ /**
 * See available options: https://linkify.js.org/docs/options.html
 * @typedef {{
 * 	defaultProtocol?: string,
 *  events?: OptObj<EventListeners>,
 * 	format?: Opt<string>,
 * 	formatHref?: Opt<string>,
 * 	nl2br?: boolean,
 * 	tagName?: Opt<any>,
 * 	target?: Opt<string>,
 * 	rel?: Opt<string>,
 * 	validate?: Opt<boolean>,
 * 	truncate?: Opt<number>,
 * 	className?: Opt<string>,
 * 	attributes?: OptObj<({ [attr: string]: any })>,
 *  ignoreTags?: string[],
 * 	render?: OptFn<((ir: IntermediateRepresentation) => any)>
 * }} Opts
 */ /**
 * @type Required<Opts>
 */ const $efca0cb2e3ea1e67$var$defaults = {
    defaultProtocol: "http",
    events: null,
    format: $efca0cb2e3ea1e67$var$noop,
    formatHref: $efca0cb2e3ea1e67$var$noop,
    nl2br: false,
    tagName: "a",
    target: null,
    rel: null,
    validate: true,
    truncate: Infinity,
    className: null,
    attributes: null,
    ignoreTags: [],
    render: null
};
/**
 * Utility class for linkify interfaces to apply specified
 * {@link Opts formatting and rendering options}.
 *
 * @param {Opts | Options} [opts] Option value overrides.
 * @param {(ir: IntermediateRepresentation) => any} [defaultRender] (For
 *   internal use) default render function that determines how to generate an
 *   HTML element based on a link token's derived tagName, attributes and HTML.
 *   Similar to render option
 */ function $efca0cb2e3ea1e67$export$c019608e5b5bb4cb(opts, defaultRender) {
    if (defaultRender === void 0) defaultRender = null;
    let o = $efca0cb2e3ea1e67$var$assign({}, $efca0cb2e3ea1e67$var$defaults);
    if (opts) o = $efca0cb2e3ea1e67$var$assign(o, opts instanceof $efca0cb2e3ea1e67$export$c019608e5b5bb4cb ? opts.o : opts);
    // Ensure all ignored tags are uppercase
    const ignoredTags = o.ignoreTags;
    const uppercaseIgnoredTags = [];
    for(let i = 0; i < ignoredTags.length; i++)uppercaseIgnoredTags.push(ignoredTags[i].toUpperCase());
    /** @protected */ this.o = o;
    if (defaultRender) this.defaultRender = defaultRender;
    this.ignoreTags = uppercaseIgnoredTags;
}
$efca0cb2e3ea1e67$export$c019608e5b5bb4cb.prototype = {
    o: $efca0cb2e3ea1e67$var$defaults,
    /**
   * @type string[]
   */ ignoreTags: [],
    /**
   * @param {IntermediateRepresentation} ir
   * @returns {any}
   */ defaultRender (ir) {
        return ir;
    },
    /**
   * Returns true or false based on whether a token should be displayed as a
   * link based on the user options.
   * @param {MultiToken} token
   * @returns {boolean}
   */ check (token) {
        return this.get("validate", token.toString(), token);
    },
    // Private methods
    /**
   * Resolve an option's value based on the value of the option and the given
   * params. If operator and token are specified and the target option is
   * callable, automatically calls the function with the given argument.
   * @template {keyof Opts} K
   * @param {K} key Name of option to use
   * @param {string} [operator] will be passed to the target option if it's a
   * function. If not specified, RAW function value gets returned
   * @param {MultiToken} [token] The token from linkify.tokenize
   * @returns {Opts[K] | any}
   */ get (key, operator, token) {
        const isCallable = operator != null;
        let option = this.o[key];
        if (!option) return option;
        if (typeof option === "object") {
            option = token.t in option ? option[token.t] : $efca0cb2e3ea1e67$var$defaults[key];
            if (typeof option === "function" && isCallable) option = option(operator, token);
        } else if (typeof option === "function" && isCallable) option = option(operator, token.t, token);
        return option;
    },
    /**
   * @template {keyof Opts} L
   * @param {L} key Name of options object to use
   * @param {string} [operator]
   * @param {MultiToken} [token]
   * @returns {Opts[L] | any}
   */ getObj (key, operator, token) {
        let obj = this.o[key];
        if (typeof obj === "function" && operator != null) obj = obj(operator, token.t, token);
        return obj;
    },
    /**
   * Convert the given token to a rendered element that may be added to the
   * calling-interface's DOM
   * @param {MultiToken} token Token to render to an HTML element
   * @returns {any} Render result; e.g., HTML string, DOM element, React
   *   Component, etc.
   */ render (token) {
        const ir = token.render(this); // intermediate representation
        const renderFn = this.get("render", null, token) || this.defaultRender;
        return renderFn(ir, token.t, token);
    }
};
function $efca0cb2e3ea1e67$var$noop(val) {
    return val;
}
var $efca0cb2e3ea1e67$export$41c562ebe57d11e2 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaults: $efca0cb2e3ea1e67$var$defaults,
    Options: $efca0cb2e3ea1e67$export$c019608e5b5bb4cb,
    assign: $efca0cb2e3ea1e67$var$assign
});
/******************************************************************************
	Multi-Tokens
	Tokens composed of arrays of TextTokens
******************************************************************************/ /**
 * @param {string} value
 * @param {Token[]} tokens
 */ function $efca0cb2e3ea1e67$export$28075db42e06f164(value, tokens) {
    this.t = "token";
    this.v = value;
    this.tk = tokens;
}
/**
 * Abstract class used for manufacturing tokens of text tokens. That is rather
 * than the value for a token being a small string of text, it's value an array
 * of text tokens.
 *
 * Used for grouping together URLs, emails, hashtags, and other potential
 * creations.
 * @class MultiToken
 * @property {string} t
 * @property {string} v
 * @property {Token[]} tk
 * @abstract
 */ $efca0cb2e3ea1e67$export$28075db42e06f164.prototype = {
    isLink: false,
    /**
   * Return the string this token represents.
   * @return {string}
   */ toString () {
        return this.v;
    },
    /**
   * What should the value for this token be in the `href` HTML attribute?
   * Returns the `.toString` value by default.
   * @param {string} [scheme]
   * @return {string}
  */ toHref (scheme) {
        return this.toString();
    },
    /**
   * @param {Options} options Formatting options
   * @returns {string}
   */ toFormattedString (options) {
        const val = this.toString();
        const truncate = options.get("truncate", val, this);
        const formatted = options.get("format", val, this);
        return truncate && formatted.length > truncate ? formatted.substring(0, truncate) + "\u2026" : formatted;
    },
    /**
   *
   * @param {Options} options
   * @returns {string}
   */ toFormattedHref (options) {
        return options.get("formatHref", this.toHref(options.get("defaultProtocol")), this);
    },
    /**
   * The start index of this token in the original input string
   * @returns {number}
   */ startIndex () {
        return this.tk[0].s;
    },
    /**
   * The end index of this token in the original input string (up to this
   * index but not including it)
   * @returns {number}
   */ endIndex () {
        return this.tk[this.tk.length - 1].e;
    },
    /**
  	Returns an object  of relevant values for this token, which includes keys
  	* type - Kind of token ('url', 'email', etc.)
  	* value - Original text
  	* href - The value that should be added to the anchor tag's href
  		attribute
  		@method toObject
  	@param {string} [protocol] `'http'` by default
  */ toObject (protocol) {
        if (protocol === void 0) protocol = $efca0cb2e3ea1e67$var$defaults.defaultProtocol;
        return {
            type: this.t,
            value: this.toString(),
            isLink: this.isLink,
            href: this.toHref(protocol),
            start: this.startIndex(),
            end: this.endIndex()
        };
    },
    /**
   *
   * @param {Options} options Formatting option
   */ toFormattedObject (options) {
        return {
            type: this.t,
            value: this.toFormattedString(options),
            isLink: this.isLink,
            href: this.toFormattedHref(options),
            start: this.startIndex(),
            end: this.endIndex()
        };
    },
    /**
   * Whether this token should be rendered as a link according to the given options
   * @param {Options} options
   * @returns {boolean}
   */ validate (options) {
        return options.get("validate", this.toString(), this);
    },
    /**
   * Return an object that represents how this link should be rendered.
   * @param {Options} options Formattinng options
   */ render (options) {
        const token = this;
        const href = this.toHref(options.get("defaultProtocol"));
        const formattedHref = options.get("formatHref", href, this);
        const tagName = options.get("tagName", href, token);
        const content = this.toFormattedString(options);
        const attributes = {};
        const className = options.get("className", href, token);
        const target = options.get("target", href, token);
        const rel = options.get("rel", href, token);
        const attrs = options.getObj("attributes", href, token);
        const eventListeners = options.getObj("events", href, token);
        attributes.href = formattedHref;
        if (className) attributes.class = className;
        if (target) attributes.target = target;
        if (rel) attributes.rel = rel;
        if (attrs) $efca0cb2e3ea1e67$var$assign(attributes, attrs);
        return {
            tagName: tagName,
            attributes: attributes,
            content: content,
            eventListeners: eventListeners
        };
    }
};
/**
 * Create a new token that can be emitted by the parser state machine
 * @param {string} type readable type of the token
 * @param {object} props properties to assign or override, including isLink = true or false
 * @returns {new (value: string, tokens: Token[]) => MultiToken} new token class
 */ function $efca0cb2e3ea1e67$export$21042e7280c1baba(type, props) {
    class Token extends $efca0cb2e3ea1e67$export$28075db42e06f164 {
        constructor(value, tokens){
            super(value, tokens);
            this.t = type;
        }
    }
    for(const p in props)Token.prototype[p] = props[p];
    Token.t = type;
    return Token;
}
/**
	Represents a list of tokens making up a valid email address
*/ const $efca0cb2e3ea1e67$var$Email = $efca0cb2e3ea1e67$export$21042e7280c1baba("email", {
    isLink: true,
    toHref () {
        return "mailto:" + this.toString();
    }
});
/**
	Represents some plain text
*/ const $efca0cb2e3ea1e67$var$Text = $efca0cb2e3ea1e67$export$21042e7280c1baba("text");
/**
	Multi-linebreak token - represents a line break
	@class Nl
*/ const $efca0cb2e3ea1e67$var$Nl = $efca0cb2e3ea1e67$export$21042e7280c1baba("nl");
/**
	Represents a list of text tokens making up a valid URL
	@class Url
*/ const $efca0cb2e3ea1e67$var$Url = $efca0cb2e3ea1e67$export$21042e7280c1baba("url", {
    isLink: true,
    /**
  	Lowercases relevant parts of the domain and adds the protocol if
  	required. Note that this will not escape unsafe HTML characters in the
  	URL.
  		@param {string} [scheme] default scheme (e.g., 'https')
  	@return {string} the full href
  */ toHref (scheme) {
        if (scheme === void 0) scheme = $efca0cb2e3ea1e67$var$defaults.defaultProtocol;
        // Check if already has a prefix scheme
        return this.hasProtocol() ? this.v : `${scheme}://${this.v}`;
    },
    /**
   * Check whether this URL token has a protocol
   * @return {boolean}
   */ hasProtocol () {
        const tokens = this.tk;
        return tokens.length >= 2 && tokens[0].t !== $efca0cb2e3ea1e67$var$LOCALHOST && tokens[1].t === $efca0cb2e3ea1e67$var$COLON;
    }
});
var $efca0cb2e3ea1e67$export$13e2537ceeaf8a3a = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    MultiToken: $efca0cb2e3ea1e67$export$28075db42e06f164,
    Base: $efca0cb2e3ea1e67$export$28075db42e06f164,
    createTokenClass: $efca0cb2e3ea1e67$export$21042e7280c1baba,
    Email: $efca0cb2e3ea1e67$var$Email,
    Text: $efca0cb2e3ea1e67$var$Text,
    Nl: $efca0cb2e3ea1e67$var$Nl,
    Url: $efca0cb2e3ea1e67$var$Url
});
/**
	Not exactly parser, more like the second-stage scanner (although we can
	theoretically hotswap the code here with a real parser in the future... but
	for a little URL-finding utility abstract syntax trees may be a little
	overkill).

	URL format: http://en.wikipedia.org/wiki/URI_scheme
	Email format: http://en.wikipedia.org/wiki/EmailAddress (links to RFC in
	reference)

	@module linkify
	@submodule parser
	@main run
*/ const $efca0cb2e3ea1e67$var$makeState = (arg)=>new $efca0cb2e3ea1e67$export$7254cc27399e90bd(arg);
/**
 * Generate the parser multi token-based state machine
 * @param {{ groups: Collections<string> }} tokens
 */ function $efca0cb2e3ea1e67$var$init$1(_ref) {
    let { groups: groups } = _ref;
    // Types of characters the URL can definitely end in
    const qsAccepting = groups.domain.concat([
        $efca0cb2e3ea1e67$var$AMPERSAND,
        $efca0cb2e3ea1e67$var$ASTERISK,
        $efca0cb2e3ea1e67$var$AT,
        $efca0cb2e3ea1e67$var$BACKSLASH,
        $efca0cb2e3ea1e67$var$BACKTICK,
        $efca0cb2e3ea1e67$var$CARET,
        $efca0cb2e3ea1e67$var$DOLLAR,
        $efca0cb2e3ea1e67$var$EQUALS,
        $efca0cb2e3ea1e67$var$HYPHEN,
        $efca0cb2e3ea1e67$var$NUM,
        $efca0cb2e3ea1e67$var$PERCENT,
        $efca0cb2e3ea1e67$var$PIPE,
        $efca0cb2e3ea1e67$var$PLUS,
        $efca0cb2e3ea1e67$var$POUND,
        $efca0cb2e3ea1e67$var$SLASH,
        $efca0cb2e3ea1e67$var$SYM,
        $efca0cb2e3ea1e67$var$TILDE,
        $efca0cb2e3ea1e67$var$UNDERSCORE
    ]);
    // Types of tokens that can follow a URL and be part of the query string
    // but cannot be the very last characters
    // Characters that cannot appear in the URL at all should be excluded
    const qsNonAccepting = [
        $efca0cb2e3ea1e67$var$APOSTROPHE,
        $efca0cb2e3ea1e67$var$COLON,
        $efca0cb2e3ea1e67$var$COMMA,
        $efca0cb2e3ea1e67$var$DOT,
        $efca0cb2e3ea1e67$var$EXCLAMATION,
        $efca0cb2e3ea1e67$var$QUERY,
        $efca0cb2e3ea1e67$var$QUOTE,
        $efca0cb2e3ea1e67$var$SEMI,
        $efca0cb2e3ea1e67$var$OPENANGLEBRACKET,
        $efca0cb2e3ea1e67$var$CLOSEANGLEBRACKET,
        $efca0cb2e3ea1e67$var$OPENBRACE,
        $efca0cb2e3ea1e67$var$CLOSEBRACE,
        $efca0cb2e3ea1e67$var$CLOSEBRACKET,
        $efca0cb2e3ea1e67$var$OPENBRACKET,
        $efca0cb2e3ea1e67$var$OPENPAREN,
        $efca0cb2e3ea1e67$var$CLOSEPAREN,
        $efca0cb2e3ea1e67$var$FULLWIDTHLEFTPAREN,
        $efca0cb2e3ea1e67$var$FULLWIDTHRIGHTPAREN,
        $efca0cb2e3ea1e67$var$LEFTCORNERBRACKET,
        $efca0cb2e3ea1e67$var$RIGHTCORNERBRACKET,
        $efca0cb2e3ea1e67$var$LEFTWHITECORNERBRACKET,
        $efca0cb2e3ea1e67$var$RIGHTWHITECORNERBRACKET,
        $efca0cb2e3ea1e67$var$FULLWIDTHLESSTHAN,
        $efca0cb2e3ea1e67$var$FULLWIDTHGREATERTHAN
    ];
    // For addresses without the mailto prefix
    // Tokens allowed in the localpart of the email
    const localpartAccepting = [
        $efca0cb2e3ea1e67$var$AMPERSAND,
        $efca0cb2e3ea1e67$var$APOSTROPHE,
        $efca0cb2e3ea1e67$var$ASTERISK,
        $efca0cb2e3ea1e67$var$BACKSLASH,
        $efca0cb2e3ea1e67$var$BACKTICK,
        $efca0cb2e3ea1e67$var$CARET,
        $efca0cb2e3ea1e67$var$DOLLAR,
        $efca0cb2e3ea1e67$var$EQUALS,
        $efca0cb2e3ea1e67$var$HYPHEN,
        $efca0cb2e3ea1e67$var$OPENBRACE,
        $efca0cb2e3ea1e67$var$CLOSEBRACE,
        $efca0cb2e3ea1e67$var$PERCENT,
        $efca0cb2e3ea1e67$var$PIPE,
        $efca0cb2e3ea1e67$var$PLUS,
        $efca0cb2e3ea1e67$var$POUND,
        $efca0cb2e3ea1e67$var$QUERY,
        $efca0cb2e3ea1e67$var$SLASH,
        $efca0cb2e3ea1e67$var$SYM,
        $efca0cb2e3ea1e67$var$TILDE,
        $efca0cb2e3ea1e67$var$UNDERSCORE
    ];
    // The universal starting state.
    /**
   * @type State<Token>
   */ const Start = $efca0cb2e3ea1e67$var$makeState();
    const Localpart = $efca0cb2e3ea1e67$var$tt(Start, $efca0cb2e3ea1e67$var$TILDE); // Local part of the email address
    $efca0cb2e3ea1e67$var$ta(Localpart, localpartAccepting, Localpart);
    $efca0cb2e3ea1e67$var$ta(Localpart, groups.domain, Localpart);
    const Domain = $efca0cb2e3ea1e67$var$makeState(), Scheme = $efca0cb2e3ea1e67$var$makeState(), SlashScheme = $efca0cb2e3ea1e67$var$makeState();
    $efca0cb2e3ea1e67$var$ta(Start, groups.domain, Domain); // parsed string ends with a potential domain name (A)
    $efca0cb2e3ea1e67$var$ta(Start, groups.scheme, Scheme); // e.g., 'mailto'
    $efca0cb2e3ea1e67$var$ta(Start, groups.slashscheme, SlashScheme); // e.g., 'http'
    $efca0cb2e3ea1e67$var$ta(Domain, localpartAccepting, Localpart);
    $efca0cb2e3ea1e67$var$ta(Domain, groups.domain, Domain);
    const LocalpartAt = $efca0cb2e3ea1e67$var$tt(Domain, $efca0cb2e3ea1e67$var$AT); // Local part of the email address plus @
    $efca0cb2e3ea1e67$var$tt(Localpart, $efca0cb2e3ea1e67$var$AT, LocalpartAt); // close to an email address now
    // Local part of an email address can be e.g. 'http' or 'mailto'
    $efca0cb2e3ea1e67$var$tt(Scheme, $efca0cb2e3ea1e67$var$AT, LocalpartAt);
    $efca0cb2e3ea1e67$var$tt(SlashScheme, $efca0cb2e3ea1e67$var$AT, LocalpartAt);
    const LocalpartDot = $efca0cb2e3ea1e67$var$tt(Localpart, $efca0cb2e3ea1e67$var$DOT); // Local part of the email address plus '.' (localpart cannot end in .)
    $efca0cb2e3ea1e67$var$ta(LocalpartDot, localpartAccepting, Localpart);
    $efca0cb2e3ea1e67$var$ta(LocalpartDot, groups.domain, Localpart);
    const EmailDomain = $efca0cb2e3ea1e67$var$makeState();
    $efca0cb2e3ea1e67$var$ta(LocalpartAt, groups.domain, EmailDomain); // parsed string starts with local email info + @ with a potential domain name
    $efca0cb2e3ea1e67$var$ta(EmailDomain, groups.domain, EmailDomain);
    const EmailDomainDot = $efca0cb2e3ea1e67$var$tt(EmailDomain, $efca0cb2e3ea1e67$var$DOT); // domain followed by DOT
    $efca0cb2e3ea1e67$var$ta(EmailDomainDot, groups.domain, EmailDomain);
    const Email$1 = $efca0cb2e3ea1e67$var$makeState($efca0cb2e3ea1e67$var$Email); // Possible email address (could have more tlds)
    $efca0cb2e3ea1e67$var$ta(EmailDomainDot, groups.tld, Email$1);
    $efca0cb2e3ea1e67$var$ta(EmailDomainDot, groups.utld, Email$1);
    $efca0cb2e3ea1e67$var$tt(LocalpartAt, $efca0cb2e3ea1e67$var$LOCALHOST, Email$1);
    // Hyphen can jump back to a domain name
    const EmailDomainHyphen = $efca0cb2e3ea1e67$var$tt(EmailDomain, $efca0cb2e3ea1e67$var$HYPHEN); // parsed string starts with local email info + @ with a potential domain name
    $efca0cb2e3ea1e67$var$ta(EmailDomainHyphen, groups.domain, EmailDomain);
    $efca0cb2e3ea1e67$var$ta(Email$1, groups.domain, EmailDomain);
    $efca0cb2e3ea1e67$var$tt(Email$1, $efca0cb2e3ea1e67$var$DOT, EmailDomainDot);
    $efca0cb2e3ea1e67$var$tt(Email$1, $efca0cb2e3ea1e67$var$HYPHEN, EmailDomainHyphen);
    // Final possible email states
    const EmailColon = $efca0cb2e3ea1e67$var$tt(Email$1, $efca0cb2e3ea1e67$var$COLON); // URL followed by colon (potential port number here)
    /*const EmailColonPort = */ $efca0cb2e3ea1e67$var$ta(EmailColon, groups.numeric, $efca0cb2e3ea1e67$var$Email); // URL followed by colon and port number
    // Account for dots and hyphens. Hyphens are usually parts of domain names
    // (but not TLDs)
    const DomainHyphen = $efca0cb2e3ea1e67$var$tt(Domain, $efca0cb2e3ea1e67$var$HYPHEN); // domain followed by hyphen
    const DomainDot = $efca0cb2e3ea1e67$var$tt(Domain, $efca0cb2e3ea1e67$var$DOT); // domain followed by DOT
    $efca0cb2e3ea1e67$var$ta(DomainHyphen, groups.domain, Domain);
    $efca0cb2e3ea1e67$var$ta(DomainDot, localpartAccepting, Localpart);
    $efca0cb2e3ea1e67$var$ta(DomainDot, groups.domain, Domain);
    const DomainDotTld = $efca0cb2e3ea1e67$var$makeState($efca0cb2e3ea1e67$var$Url); // Simplest possible URL with no query string
    $efca0cb2e3ea1e67$var$ta(DomainDot, groups.tld, DomainDotTld);
    $efca0cb2e3ea1e67$var$ta(DomainDot, groups.utld, DomainDotTld);
    $efca0cb2e3ea1e67$var$ta(DomainDotTld, groups.domain, Domain);
    $efca0cb2e3ea1e67$var$ta(DomainDotTld, localpartAccepting, Localpart);
    $efca0cb2e3ea1e67$var$tt(DomainDotTld, $efca0cb2e3ea1e67$var$DOT, DomainDot);
    $efca0cb2e3ea1e67$var$tt(DomainDotTld, $efca0cb2e3ea1e67$var$HYPHEN, DomainHyphen);
    $efca0cb2e3ea1e67$var$tt(DomainDotTld, $efca0cb2e3ea1e67$var$AT, LocalpartAt);
    const DomainDotTldColon = $efca0cb2e3ea1e67$var$tt(DomainDotTld, $efca0cb2e3ea1e67$var$COLON); // URL followed by colon (potential port number here)
    const DomainDotTldColonPort = $efca0cb2e3ea1e67$var$makeState($efca0cb2e3ea1e67$var$Url); // TLD followed by a port number
    $efca0cb2e3ea1e67$var$ta(DomainDotTldColon, groups.numeric, DomainDotTldColonPort);
    // Long URL with optional port and maybe query string
    const Url$1 = $efca0cb2e3ea1e67$var$makeState($efca0cb2e3ea1e67$var$Url);
    // URL with extra symbols at the end, followed by an opening bracket
    const UrlNonaccept = $efca0cb2e3ea1e67$var$makeState(); // URL followed by some symbols (will not be part of the final URL)
    // Query strings
    $efca0cb2e3ea1e67$var$ta(Url$1, qsAccepting, Url$1);
    $efca0cb2e3ea1e67$var$ta(Url$1, qsNonAccepting, UrlNonaccept);
    $efca0cb2e3ea1e67$var$ta(UrlNonaccept, qsAccepting, Url$1);
    $efca0cb2e3ea1e67$var$ta(UrlNonaccept, qsNonAccepting, UrlNonaccept);
    // Become real URLs after `SLASH` or `COLON NUM SLASH`
    // Here works with or without scheme:// prefix
    $efca0cb2e3ea1e67$var$tt(DomainDotTld, $efca0cb2e3ea1e67$var$SLASH, Url$1);
    $efca0cb2e3ea1e67$var$tt(DomainDotTldColonPort, $efca0cb2e3ea1e67$var$SLASH, Url$1);
    // Note that domains that begin with schemes are treated slighly differently
    const SchemeColon = $efca0cb2e3ea1e67$var$tt(Scheme, $efca0cb2e3ea1e67$var$COLON); // e.g., 'mailto:'
    const SlashSchemeColon = $efca0cb2e3ea1e67$var$tt(SlashScheme, $efca0cb2e3ea1e67$var$COLON); // e.g., 'http:'
    const SlashSchemeColonSlash = $efca0cb2e3ea1e67$var$tt(SlashSchemeColon, $efca0cb2e3ea1e67$var$SLASH); // e.g., 'http:/'
    const UriPrefix = $efca0cb2e3ea1e67$var$tt(SlashSchemeColonSlash, $efca0cb2e3ea1e67$var$SLASH); // e.g., 'http://'
    // Scheme states can transition to domain states
    $efca0cb2e3ea1e67$var$ta(Scheme, groups.domain, Domain);
    $efca0cb2e3ea1e67$var$tt(Scheme, $efca0cb2e3ea1e67$var$DOT, DomainDot);
    $efca0cb2e3ea1e67$var$tt(Scheme, $efca0cb2e3ea1e67$var$HYPHEN, DomainHyphen);
    $efca0cb2e3ea1e67$var$ta(SlashScheme, groups.domain, Domain);
    $efca0cb2e3ea1e67$var$tt(SlashScheme, $efca0cb2e3ea1e67$var$DOT, DomainDot);
    $efca0cb2e3ea1e67$var$tt(SlashScheme, $efca0cb2e3ea1e67$var$HYPHEN, DomainHyphen);
    // Force URL with scheme prefix followed by anything sane
    $efca0cb2e3ea1e67$var$ta(SchemeColon, groups.domain, Url$1);
    $efca0cb2e3ea1e67$var$tt(SchemeColon, $efca0cb2e3ea1e67$var$SLASH, Url$1);
    $efca0cb2e3ea1e67$var$ta(UriPrefix, groups.domain, Url$1);
    $efca0cb2e3ea1e67$var$ta(UriPrefix, qsAccepting, Url$1);
    $efca0cb2e3ea1e67$var$tt(UriPrefix, $efca0cb2e3ea1e67$var$SLASH, Url$1);
    const bracketPairs = [
        [
            $efca0cb2e3ea1e67$var$OPENBRACE,
            $efca0cb2e3ea1e67$var$CLOSEBRACE
        ],
        // {}
        [
            $efca0cb2e3ea1e67$var$OPENBRACKET,
            $efca0cb2e3ea1e67$var$CLOSEBRACKET
        ],
        // []
        [
            $efca0cb2e3ea1e67$var$OPENPAREN,
            $efca0cb2e3ea1e67$var$CLOSEPAREN
        ],
        // ()
        [
            $efca0cb2e3ea1e67$var$OPENANGLEBRACKET,
            $efca0cb2e3ea1e67$var$CLOSEANGLEBRACKET
        ],
        // <>
        [
            $efca0cb2e3ea1e67$var$FULLWIDTHLEFTPAREN,
            $efca0cb2e3ea1e67$var$FULLWIDTHRIGHTPAREN
        ],
        // （）
        [
            $efca0cb2e3ea1e67$var$LEFTCORNERBRACKET,
            $efca0cb2e3ea1e67$var$RIGHTCORNERBRACKET
        ],
        // 「」
        [
            $efca0cb2e3ea1e67$var$LEFTWHITECORNERBRACKET,
            $efca0cb2e3ea1e67$var$RIGHTWHITECORNERBRACKET
        ],
        // 『』
        [
            $efca0cb2e3ea1e67$var$FULLWIDTHLESSTHAN,
            $efca0cb2e3ea1e67$var$FULLWIDTHGREATERTHAN
        ] // ＜＞
    ];
    for(let i = 0; i < bracketPairs.length; i++){
        const [OPEN, CLOSE] = bracketPairs[i];
        const UrlOpen = $efca0cb2e3ea1e67$var$tt(Url$1, OPEN); // URL followed by open bracket
        // Continue not accepting for open brackets
        $efca0cb2e3ea1e67$var$tt(UrlNonaccept, OPEN, UrlOpen);
        // Closing bracket component. This character WILL be included in the URL
        $efca0cb2e3ea1e67$var$tt(UrlOpen, CLOSE, Url$1);
        // URL that beings with an opening bracket, followed by a symbols.
        // Note that the final state can still be `UrlOpen` (if the URL has a
        // single opening bracket for some reason).
        const UrlOpenQ = $efca0cb2e3ea1e67$var$makeState($efca0cb2e3ea1e67$var$Url);
        $efca0cb2e3ea1e67$var$ta(UrlOpen, qsAccepting, UrlOpenQ);
        const UrlOpenSyms = $efca0cb2e3ea1e67$var$makeState(); // UrlOpen followed by some symbols it cannot end it
        $efca0cb2e3ea1e67$var$ta(UrlOpen, qsNonAccepting);
        // URL that begins with an opening bracket, followed by some symbols
        $efca0cb2e3ea1e67$var$ta(UrlOpenQ, qsAccepting, UrlOpenQ);
        $efca0cb2e3ea1e67$var$ta(UrlOpenQ, qsNonAccepting, UrlOpenSyms);
        $efca0cb2e3ea1e67$var$ta(UrlOpenSyms, qsAccepting, UrlOpenQ);
        $efca0cb2e3ea1e67$var$ta(UrlOpenSyms, qsNonAccepting, UrlOpenSyms);
        // Close brace/bracket to become regular URL
        $efca0cb2e3ea1e67$var$tt(UrlOpenQ, CLOSE, Url$1);
        $efca0cb2e3ea1e67$var$tt(UrlOpenSyms, CLOSE, Url$1);
    }
    $efca0cb2e3ea1e67$var$tt(Start, $efca0cb2e3ea1e67$var$LOCALHOST, DomainDotTld); // localhost is a valid URL state
    $efca0cb2e3ea1e67$var$tt(Start, $efca0cb2e3ea1e67$var$NL$1, $efca0cb2e3ea1e67$var$Nl); // single new line
    return {
        start: Start,
        tokens: $efca0cb2e3ea1e67$var$tk
    };
}
/**
 * Run the parser state machine on a list of scanned string-based tokens to
 * create a list of multi tokens, each of which represents a URL, email address,
 * plain text, etc.
 *
 * @param {State<MultiToken>} start parser start state
 * @param {string} input the original input used to generate the given tokens
 * @param {Token[]} tokens list of scanned tokens
 * @returns {MultiToken[]}
 */ function $efca0cb2e3ea1e67$var$run(start, input, tokens) {
    let len = tokens.length;
    let cursor = 0;
    let multis = [];
    let textTokens = [];
    while(cursor < len){
        let state = start;
        let secondState = null;
        let nextState = null;
        let multiLength = 0;
        let latestAccepting = null;
        let sinceAccepts = -1;
        while(cursor < len && !(secondState = state.go(tokens[cursor].t)))// Starting tokens with nowhere to jump to.
        // Consider these to be just plain text
        textTokens.push(tokens[cursor++]);
        while(cursor < len && (nextState = secondState || state.go(tokens[cursor].t))){
            // Get the next state
            secondState = null;
            state = nextState;
            // Keep track of the latest accepting state
            if (state.accepts()) {
                sinceAccepts = 0;
                latestAccepting = state;
            } else if (sinceAccepts >= 0) sinceAccepts++;
            cursor++;
            multiLength++;
        }
        if (sinceAccepts < 0) {
            // No accepting state was found, part of a regular text token add
            // the first text token to the text tokens array and try again from
            // the next
            cursor -= multiLength;
            if (cursor < len) {
                textTokens.push(tokens[cursor]);
                cursor++;
            }
        } else {
            // Accepting state!
            // First close off the textTokens (if available)
            if (textTokens.length > 0) {
                multis.push($efca0cb2e3ea1e67$var$initMultiToken($efca0cb2e3ea1e67$var$Text, input, textTokens));
                textTokens = [];
            }
            // Roll back to the latest accepting state
            cursor -= sinceAccepts;
            multiLength -= sinceAccepts;
            // Create a new multitoken
            const Multi = latestAccepting.t;
            const subtokens = tokens.slice(cursor - multiLength, cursor);
            multis.push($efca0cb2e3ea1e67$var$initMultiToken(Multi, input, subtokens));
        }
    }
    // Finally close off the textTokens (if available)
    if (textTokens.length > 0) multis.push($efca0cb2e3ea1e67$var$initMultiToken($efca0cb2e3ea1e67$var$Text, input, textTokens));
    return multis;
}
/**
 * Utility function for instantiating a new multitoken with all the relevant
 * fields during parsing.
 * @param {new (value: string, tokens: Token[]) => MultiToken} Multi class to instantiate
 * @param {string} input original input string
 * @param {Token[]} tokens consecutive tokens scanned from input string
 * @returns {MultiToken}
 */ function $efca0cb2e3ea1e67$var$initMultiToken(Multi, input, tokens) {
    const startIdx = tokens[0].s;
    const endIdx = tokens[tokens.length - 1].e;
    const value = input.slice(startIdx, endIdx);
    return new Multi(value, tokens);
}
const $efca0cb2e3ea1e67$var$warn = typeof console !== "undefined" && console && console.warn || (()=>{});
const $efca0cb2e3ea1e67$var$warnAdvice = "until manual call of linkify.init(). Register all schemes and plugins before invoking linkify the first time.";
// Side-effect initialization state
const $efca0cb2e3ea1e67$var$INIT = {
    scanner: null,
    parser: null,
    tokenQueue: [],
    pluginQueue: [],
    customSchemes: [],
    initialized: false
};
/**
 * @typedef {{
 * 	start: State<string>,
 * 	tokens: { groups: Collections<string> } & typeof tk
 * }} ScannerInit
 */ /**
 * @typedef {{
 * 	start: State<MultiToken>,
 * 	tokens: typeof multi
 * }} ParserInit
 */ /**
 * @typedef {(arg: { scanner: ScannerInit }) => void} TokenPlugin
 */ /**
 * @typedef {(arg: { scanner: ScannerInit, parser: ParserInit }) => void} Plugin
 */ /**
 * De-register all plugins and reset the internal state-machine. Used for
 * testing; not required in practice.
 * @private
 */ function $efca0cb2e3ea1e67$export$aad8462122ac592b() {
    $efca0cb2e3ea1e67$export$7254cc27399e90bd.groups = {};
    $efca0cb2e3ea1e67$var$INIT.scanner = null;
    $efca0cb2e3ea1e67$var$INIT.parser = null;
    $efca0cb2e3ea1e67$var$INIT.tokenQueue = [];
    $efca0cb2e3ea1e67$var$INIT.pluginQueue = [];
    $efca0cb2e3ea1e67$var$INIT.customSchemes = [];
    $efca0cb2e3ea1e67$var$INIT.initialized = false;
}
/**
 * Register a token plugin to allow the scanner to recognize additional token
 * types before the parser state machine is constructed from the results.
 * @param {string} name of plugin to register
 * @param {TokenPlugin} plugin function that accepts the scanner state machine
 * and available scanner tokens and collections and extends the state machine to
 * recognize additional tokens or groups.
 */ function $efca0cb2e3ea1e67$export$56d1f1cb1f3c0e96(name, plugin) {
    if (typeof plugin !== "function") throw new Error(`linkifyjs: Invalid token plugin ${plugin} (expects function)`);
    for(let i = 0; i < $efca0cb2e3ea1e67$var$INIT.tokenQueue.length; i++)if (name === $efca0cb2e3ea1e67$var$INIT.tokenQueue[i][0]) {
        $efca0cb2e3ea1e67$var$warn(`linkifyjs: token plugin "${name}" already registered - will be overwritten`);
        $efca0cb2e3ea1e67$var$INIT.tokenQueue[i] = [
            name,
            plugin
        ];
        return;
    }
    $efca0cb2e3ea1e67$var$INIT.tokenQueue.push([
        name,
        plugin
    ]);
    if ($efca0cb2e3ea1e67$var$INIT.initialized) $efca0cb2e3ea1e67$var$warn(`linkifyjs: already initialized - will not register token plugin "${name}" ${$efca0cb2e3ea1e67$var$warnAdvice}`);
}
/**
 * Register a linkify plugin
 * @param {string} name of plugin to register
 * @param {Plugin} plugin function that accepts the parser state machine and
 * extends the parser to recognize additional link types
 */ function $efca0cb2e3ea1e67$export$7612db19fb8beb1e(name, plugin) {
    if (typeof plugin !== "function") throw new Error(`linkifyjs: Invalid plugin ${plugin} (expects function)`);
    for(let i = 0; i < $efca0cb2e3ea1e67$var$INIT.pluginQueue.length; i++)if (name === $efca0cb2e3ea1e67$var$INIT.pluginQueue[i][0]) {
        $efca0cb2e3ea1e67$var$warn(`linkifyjs: plugin "${name}" already registered - will be overwritten`);
        $efca0cb2e3ea1e67$var$INIT.pluginQueue[i] = [
            name,
            plugin
        ];
        return;
    }
    $efca0cb2e3ea1e67$var$INIT.pluginQueue.push([
        name,
        plugin
    ]);
    if ($efca0cb2e3ea1e67$var$INIT.initialized) $efca0cb2e3ea1e67$var$warn(`linkifyjs: already initialized - will not register plugin "${name}" ${$efca0cb2e3ea1e67$var$warnAdvice}`);
}
/**
 * Detect URLs with the following additional protocol. Anything with format
 * "protocol://..." will be considered a link. If `optionalSlashSlash` is set to
 * `true`, anything with format "protocol:..." will be considered a link.
 * @param {string} protocol
 * @param {boolean} [optionalSlashSlash]
 */ function $efca0cb2e3ea1e67$export$821627edc2d26f5f(scheme, optionalSlashSlash) {
    if (optionalSlashSlash === void 0) optionalSlashSlash = false;
    if ($efca0cb2e3ea1e67$var$INIT.initialized) $efca0cb2e3ea1e67$var$warn(`linkifyjs: already initialized - will not register custom scheme "${scheme}" ${$efca0cb2e3ea1e67$var$warnAdvice}`);
    if (!/^[0-9a-z]+(-[0-9a-z]+)*$/.test(scheme)) throw new Error(`linkifyjs: incorrect scheme format.
1. Must only contain digits, lowercase ASCII letters or "-"
2. Cannot start or end with "-"
3. "-" cannot repeat`);
    $efca0cb2e3ea1e67$var$INIT.customSchemes.push([
        scheme,
        optionalSlashSlash
    ]);
}
/**
 * Initialize the linkify state machine. Called automatically the first time
 * linkify is called on a string, but may be called manually as well.
 */ function $efca0cb2e3ea1e67$export$2cd8252107eb640b() {
    // Initialize scanner state machine and plugins
    $efca0cb2e3ea1e67$var$INIT.scanner = $efca0cb2e3ea1e67$var$init$2($efca0cb2e3ea1e67$var$INIT.customSchemes);
    for(let i = 0; i < $efca0cb2e3ea1e67$var$INIT.tokenQueue.length; i++)$efca0cb2e3ea1e67$var$INIT.tokenQueue[i][1]({
        scanner: $efca0cb2e3ea1e67$var$INIT.scanner
    });
    // Initialize parser state machine and plugins
    $efca0cb2e3ea1e67$var$INIT.parser = $efca0cb2e3ea1e67$var$init$1($efca0cb2e3ea1e67$var$INIT.scanner.tokens);
    for(let i = 0; i < $efca0cb2e3ea1e67$var$INIT.pluginQueue.length; i++)$efca0cb2e3ea1e67$var$INIT.pluginQueue[i][1]({
        scanner: $efca0cb2e3ea1e67$var$INIT.scanner,
        parser: $efca0cb2e3ea1e67$var$INIT.parser
    });
    $efca0cb2e3ea1e67$var$INIT.initialized = true;
}
/**
 * Parse a string into tokens that represent linkable and non-linkable sub-components
 * @param {string} str
 * @return {MultiToken[]} tokens
 */ function $efca0cb2e3ea1e67$export$660b2ee2d4fb4eff(str) {
    if (!$efca0cb2e3ea1e67$var$INIT.initialized) $efca0cb2e3ea1e67$export$2cd8252107eb640b();
    return $efca0cb2e3ea1e67$var$run($efca0cb2e3ea1e67$var$INIT.parser.start, str, $efca0cb2e3ea1e67$var$run$1($efca0cb2e3ea1e67$var$INIT.scanner.start, str));
}
/**
 * Find a list of linkable items in the given string.
 * @param {string} str string to find links in
 * @param {string | Opts} [type] either formatting options or specific type of
 * links to find, e.g., 'url' or 'email'
 * @param {Opts} [opts] formatting options for final output. Cannot be specified
 * if opts already provided in `type` argument
 */ function $efca0cb2e3ea1e67$export$71aa6c912b956294(str, type, opts) {
    if (type === void 0) type = null;
    if (opts === void 0) opts = null;
    if (type && typeof type === "object") {
        if (opts) throw Error(`linkifyjs: Invalid link type ${type}; must be a string`);
        opts = type;
        type = null;
    }
    const options = new $efca0cb2e3ea1e67$export$c019608e5b5bb4cb(opts);
    const tokens = $efca0cb2e3ea1e67$export$660b2ee2d4fb4eff(str);
    const filtered = [];
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        if (token.isLink && (!type || token.t === type) && options.check(token)) filtered.push(token.toFormattedObject(options));
    }
    return filtered;
}
/**
 * Is the given string valid linkable text of some sort. Note that this does not
 * trim the text for you.
 *
 * Optionally pass in a second `type` param, which is the type of link to test
 * for.
 *
 * For example,
 *
 *     linkify.test(str, 'email');
 *
 * Returns `true` if str is a valid email.
 * @param {string} str string to test for links
 * @param {string} [type] optional specific link type to look for
 * @returns boolean true/false
 */ function $efca0cb2e3ea1e67$export$e0969da9b8fb378d(str, type) {
    if (type === void 0) type = null;
    const tokens = $efca0cb2e3ea1e67$export$660b2ee2d4fb4eff(str);
    return tokens.length === 1 && tokens[0].isLink && (!type || tokens[0].t === type);
}


const $3bbe59931da17a80$export$c0bb0b647f701bb5 = (0, $ea6c2efa7087cd4a$export$2e2bcd8739ae039).bind((0, $b2a774aae58c7b4e$export$c8a8987d4410bf2d));


// RFC 1459
const $bd3c59ab25aed5ca$export$cac9ca3596de2b3a = "001";
const $bd3c59ab25aed5ca$export$533b33f42abb0931 = "002";
const $bd3c59ab25aed5ca$export$ad367ba3102df7fd = "003";
const $bd3c59ab25aed5ca$export$31b0bce566d09826 = "004";
const $bd3c59ab25aed5ca$export$1d0c7ae9b6b17819 = "005";
const $bd3c59ab25aed5ca$export$6184319b67962807 = "221";
const $bd3c59ab25aed5ca$export$5075048a1d9ba016 = "263";
const $bd3c59ab25aed5ca$export$cfb24fa60294f9b1 = "301";
const $bd3c59ab25aed5ca$export$9514b1191eaefcec = "311";
const $bd3c59ab25aed5ca$export$5fb4b19390213db9 = "312";
const $bd3c59ab25aed5ca$export$ed3b11a38dbfed2c = "313";
const $bd3c59ab25aed5ca$export$322843849bf6282 = "317";
const $bd3c59ab25aed5ca$export$ec20f8e9d0ad5539 = "318";
const $bd3c59ab25aed5ca$export$1982ce771bb0f0ea = "319";
const $bd3c59ab25aed5ca$export$1ea987b9a16ea266 = "315";
const $bd3c59ab25aed5ca$export$8e826dfe9edc5be1 = "324";
const $bd3c59ab25aed5ca$export$a675057415015158 = "331";
const $bd3c59ab25aed5ca$export$c233ee342453910 = "332";
const $bd3c59ab25aed5ca$export$b1fa6c92095fdab1 = "333";
const $bd3c59ab25aed5ca$export$6bc24f4e6578b579 = "341";
const $bd3c59ab25aed5ca$export$cf24d3ab5a850c9f = "346";
const $bd3c59ab25aed5ca$export$edbdd9cee2ab5be8 = "347";
const $bd3c59ab25aed5ca$export$a1ba792f52c3a77c = "348";
const $bd3c59ab25aed5ca$export$385b5d59fd211cdd = "349";
const $bd3c59ab25aed5ca$export$ea7f3a22477f88c4 = "352";
const $bd3c59ab25aed5ca$export$18c4a4c5c97dce9b = "353";
const $bd3c59ab25aed5ca$export$f45306e17f085f4e = "354";
const $bd3c59ab25aed5ca$export$698923df90b7ea6d = "366";
const $bd3c59ab25aed5ca$export$15ba3f1b034be103 = "367";
const $bd3c59ab25aed5ca$export$1766db7a19d745c = "368";
const $bd3c59ab25aed5ca$export$3db4cc949c7e95b3 = "372";
const $bd3c59ab25aed5ca$export$dc8b28cc395fae80 = "375";
const $bd3c59ab25aed5ca$export$cad5f2640c65ad1e = "376";
const $bd3c59ab25aed5ca$export$f0fc9feb21c3ef1b = "400";
const $bd3c59ab25aed5ca$export$7ea30511ef6ec211 = "401";
const $bd3c59ab25aed5ca$export$b889507e4da9d85b = "403";
const $bd3c59ab25aed5ca$export$d9dd0c5028129ffb = "405";
const $bd3c59ab25aed5ca$export$da101e59b60ec32a = "421";
const $bd3c59ab25aed5ca$export$7e8b5ab33a021d11 = "422";
const $bd3c59ab25aed5ca$export$4743685aa8150ce0 = "432";
const $bd3c59ab25aed5ca$export$8b9229ff310aa80f = "433";
const $bd3c59ab25aed5ca$export$7610afb40d396829 = "436";
const $bd3c59ab25aed5ca$export$e9c321b4bd63421d = "461";
const $bd3c59ab25aed5ca$export$3ae3da5f6b8010ab = "463";
const $bd3c59ab25aed5ca$export$9d6a3a6ab4c58e66 = "464";
const $bd3c59ab25aed5ca$export$1e0e84545800b47a = "465";
const $bd3c59ab25aed5ca$export$6ce9c178695ddc97 = "471";
const $bd3c59ab25aed5ca$export$1750cbcab1b05667 = "473";
const $bd3c59ab25aed5ca$export$30b572b38bbeae93 = "474";
const $bd3c59ab25aed5ca$export$cc57fea2b719b6fa = "475";
const $bd3c59ab25aed5ca$export$2b6618e870672e76 = "437";
const $bd3c59ab25aed5ca$export$7304bc4447b68935 = "328";
const $bd3c59ab25aed5ca$export$110395ee82c419bd = "329";
const $bd3c59ab25aed5ca$export$903bdc290bba373b = "728";
const $bd3c59ab25aed5ca$export$e4ff1ea9594cfaf7 = "729";
const $bd3c59ab25aed5ca$export$b3c89fff1b2cdce3 = "730";
const $bd3c59ab25aed5ca$export$69132af27147d725 = "731";
const $bd3c59ab25aed5ca$export$4cefb1e79b9679ac = "732";
const $bd3c59ab25aed5ca$export$1a821ef70562463 = "733";
const $bd3c59ab25aed5ca$export$4263d790dc849b7 = "734";
const $bd3c59ab25aed5ca$export$97b01f8c0b76e599 = "900";
const $bd3c59ab25aed5ca$export$3ae55a67359785dc = "901";
const $bd3c59ab25aed5ca$export$37e8d81e1e359f6e = "902";
const $bd3c59ab25aed5ca$export$cba31abc2138b15e = "903";
const $bd3c59ab25aed5ca$export$724018c6aa2adbd0 = "904";
const $bd3c59ab25aed5ca$export$47bb6ff9e6eba14f = "905";
const $bd3c59ab25aed5ca$export$aae27a063aae3a16 = "906";
const $bd3c59ab25aed5ca$export$a74ae703a035d4a0 = "907";
const $bd3c59ab25aed5ca$export$23f1deb5c0b73a8d = "~&@%+";
const $bd3c59ab25aed5ca$export$85cfa99a207ea7bc = "#&+!";
const $bd3c59ab25aed5ca$var$tagEscapeMap = {
    ";": "\\:",
    " ": "\\s",
    "\\": "\\\\",
    "\r": "\\r",
    "\n": "\\n"
};
const $bd3c59ab25aed5ca$var$tagUnescapeMap = Object.fromEntries(Object.entries($bd3c59ab25aed5ca$var$tagEscapeMap).map(([from, to])=>[
        to,
        from
    ]));
function $bd3c59ab25aed5ca$var$escapeTag(s) {
    return String(s).replace(/[; \\\r\n]/g, (ch)=>$bd3c59ab25aed5ca$var$tagEscapeMap[ch]);
}
function $bd3c59ab25aed5ca$var$unescapeTag(s) {
    return s.replace(/\\[:s\\rn]/g, (seq)=>$bd3c59ab25aed5ca$var$tagUnescapeMap[seq]);
}
function $bd3c59ab25aed5ca$export$ede4b2e0172bbdb1(s) {
    let tags = {};
    s.split(";").forEach((s)=>{
        if (!s) return;
        let parts = s.split("=", 2);
        let k = parts[0];
        let v = null;
        if (parts.length == 2) {
            v = $bd3c59ab25aed5ca$var$unescapeTag(parts[1]);
            if (v.endsWith("\\")) v = v.slice(0, v.length - 1);
        }
        tags[k] = v;
    });
    return tags;
}
function $bd3c59ab25aed5ca$export$c27de7dba30c634a(tags) {
    let l = [];
    for(let k in tags){
        if (tags[k] === undefined || tags[k] === null) {
            l.push(k);
            continue;
        }
        let v = $bd3c59ab25aed5ca$var$escapeTag(tags[k]);
        l.push(k + "=" + v);
    }
    return l.join(";");
}
function $bd3c59ab25aed5ca$export$3059e96a5fe807c3(s) {
    let prefix = {
        name: null,
        user: null,
        host: null
    };
    let host = null;
    let i = s.indexOf("@");
    if (i > 0) {
        host = s.slice(i + 1);
        s = s.slice(0, i);
    }
    let user = null;
    i = s.indexOf("!");
    if (i > 0) {
        user = s.slice(i + 1);
        s = s.slice(0, i);
    }
    return {
        name: s,
        user: user,
        host: host
    };
}
function $bd3c59ab25aed5ca$var$formatPrefix(prefix) {
    let s = prefix.name;
    if (prefix.user) s += "!" + prefix.user;
    if (prefix.host) s += "@" + prefix.host;
    return s;
}
function $bd3c59ab25aed5ca$export$f2f615077a189f21(s) {
    if (s.endsWith("\r\n")) s = s.slice(0, s.length - 2);
    let msg = {
        tags: {},
        prefix: null,
        command: null,
        params: []
    };
    if (s.startsWith("@")) {
        let i = s.indexOf(" ");
        if (i < 0) throw new Error("expected a space after tags");
        msg.tags = $bd3c59ab25aed5ca$export$ede4b2e0172bbdb1(s.slice(1, i));
        s = s.slice(i + 1);
    }
    if (s.startsWith(":")) {
        let i = s.indexOf(" ");
        if (i < 0) throw new Error("expected a space after prefix");
        msg.prefix = $bd3c59ab25aed5ca$export$3059e96a5fe807c3(s.slice(1, i));
        s = s.slice(i + 1);
    }
    let i = s.indexOf(" ");
    if (i < 0) {
        msg.command = s;
        return msg;
    }
    msg.command = s.slice(0, i);
    s = s.slice(i + 1);
    while(true){
        if (s.startsWith(":")) {
            msg.params.push(s.slice(1));
            break;
        }
        i = s.indexOf(" ");
        if (i < 0) {
            msg.params.push(s);
            break;
        }
        msg.params.push(s.slice(0, i));
        s = s.slice(i + 1);
    }
    return msg;
}
function $bd3c59ab25aed5ca$export$25868d1e8e76735f(msg) {
    let s = "";
    if (msg.tags && Object.keys(msg.tags).length > 0) s += "@" + $bd3c59ab25aed5ca$export$c27de7dba30c634a(msg.tags) + " ";
    if (msg.prefix) s += ":" + $bd3c59ab25aed5ca$var$formatPrefix(msg.prefix) + " ";
    s += msg.command;
    if (msg.params && msg.params.length > 0) {
        for(let i = 0; i < msg.params.length - 1; i++)s += " " + msg.params[i];
        let last = String(msg.params[msg.params.length - 1]);
        if (last.length === 0 || last.startsWith(":") || last.indexOf(" ") >= 0) s += " :" + last;
        else s += " " + last;
    }
    return s;
}
function $bd3c59ab25aed5ca$export$4812b7165edd26af(s, allowedPrefixes = $bd3c59ab25aed5ca$export$23f1deb5c0b73a8d) {
    let i;
    for(i = 0; i < s.length; i++){
        if (allowedPrefixes.indexOf(s[i]) < 0) break;
    }
    return {
        prefix: s.slice(0, i),
        name: s.slice(i)
    };
}
const $bd3c59ab25aed5ca$var$alphaNum = (()=>{
    try {
        return new RegExp(/^[\p{L}0-9]$/, "u");
    } catch (e) {
        return new RegExp(/^[a-zA-Z0-9]$/, "u");
    }
})();
const $bd3c59ab25aed5ca$var$space = new RegExp(/^\s$/);
function $bd3c59ab25aed5ca$var$isWordBoundary(ch) {
    switch(ch){
        case "-":
        case "_":
        case "|":
            return false;
        default:
            return !$bd3c59ab25aed5ca$var$alphaNum.test(ch);
    }
}
function $bd3c59ab25aed5ca$var$isURIPrefix(text) {
    for(let i = text.length - 1; i >= 0; i--)if ($bd3c59ab25aed5ca$var$space.test(text[i])) {
        text = text.slice(i);
        break;
    }
    let i = text.indexOf("://");
    if (i <= 0) return false;
    // See RFC 3986 section 3
    let ch = text[i - 1];
    switch(ch){
        case "+":
        case "-":
        case ".":
            return true;
        default:
            return $bd3c59ab25aed5ca$var$alphaNum.test(ch);
    }
}
function $bd3c59ab25aed5ca$export$fdd47ba7a4ecfeff(msg, nick, cm) {
    if (msg.command != "PRIVMSG" && msg.command != "NOTICE") return false;
    nick = cm(nick);
    if (msg.prefix && cm(msg.prefix.name) == nick) return false; // Our own messages aren't highlights
    let text = cm(msg.params[1]);
    while(true){
        let i = text.indexOf(nick);
        if (i < 0) return false;
        // Detect word boundaries
        let left = "\0", right = "\0";
        if (i > 0) left = text[i - 1];
        if (i + nick.length < text.length) right = text[i + nick.length];
        if ($bd3c59ab25aed5ca$var$isWordBoundary(left) && $bd3c59ab25aed5ca$var$isWordBoundary(right) && !$bd3c59ab25aed5ca$var$isURIPrefix(text.slice(0, i))) return true;
        text = text.slice(i + nick.length);
    }
}
function $bd3c59ab25aed5ca$export$8b29011f3cb5e124(msg) {
    if (msg.command != "PRIVMSG" && msg.command != "NOTICE") return false;
    return msg.params[0].startsWith("$");
}
function $bd3c59ab25aed5ca$export$e6127cc7fe7395c3(cmd) {
    if (cmd >= "400" && cmd <= "568") return true;
    switch(cmd){
        case $bd3c59ab25aed5ca$export$37e8d81e1e359f6e:
        case $bd3c59ab25aed5ca$export$724018c6aa2adbd0:
        case $bd3c59ab25aed5ca$export$47bb6ff9e6eba14f:
        case $bd3c59ab25aed5ca$export$aae27a063aae3a16:
        case $bd3c59ab25aed5ca$export$a74ae703a035d4a0:
        case $bd3c59ab25aed5ca$export$4263d790dc849b7:
            return true;
        case "FAIL":
            return true;
        default:
            return false;
    }
}
function $bd3c59ab25aed5ca$export$3ae94a2503e890a1(date) {
    // ISO 8601
    let YYYY = date.getUTCFullYear().toString().padStart(4, "0");
    let MM = (date.getUTCMonth() + 1).toString().padStart(2, "0");
    let DD = date.getUTCDate().toString().padStart(2, "0");
    let hh = date.getUTCHours().toString().padStart(2, "0");
    let mm = date.getUTCMinutes().toString().padStart(2, "0");
    let ss = date.getUTCSeconds().toString().padStart(2, "0");
    let sss = date.getUTCMilliseconds().toString().padStart(3, "0");
    return `${YYYY}-${MM}-${DD}T${hh}:${mm}:${ss}.${sss}Z`;
}
function $bd3c59ab25aed5ca$export$60937d95e568734f(msg) {
    if (msg.command != "PRIVMSG" && msg.command != "NOTICE") return null;
    let text = msg.params[1];
    if (!text.startsWith("\x01")) return null;
    text = text.slice(1);
    if (text.endsWith("\x01")) text = text.slice(0, -1);
    let ctcp;
    let i = text.indexOf(" ");
    if (i >= 0) ctcp = {
        command: text.slice(0, i),
        param: text.slice(i + 1)
    };
    else ctcp = {
        command: text,
        param: ""
    };
    ctcp.command = ctcp.command.toUpperCase();
    return ctcp;
}
function $bd3c59ab25aed5ca$var$unescapeISUPPORTValue(s) {
    return s.replace(/\\x[0-9A-Z]{2}/gi, (esc)=>{
        let hex = esc.slice(2);
        return String.fromCharCode(parseInt(hex, 16));
    });
}
class $bd3c59ab25aed5ca$export$23c4b2cbd0633e6b {
    raw = new Map();
    parse(tokens) {
        tokens.forEach((tok)=>{
            if (tok.startsWith("-")) {
                let k = tok.slice(1);
                this.raw.delete(k.toUpperCase());
                return;
            }
            let i = tok.indexOf("=");
            let k = tok, v = "";
            if (i >= 0) {
                k = tok.slice(0, i);
                v = $bd3c59ab25aed5ca$var$unescapeISUPPORTValue(tok.slice(i + 1));
            }
            k = k.toUpperCase();
            this.raw.set(k, v);
        });
    }
    caseMapping() {
        let name = this.raw.get("CASEMAPPING");
        if (!name) return $bd3c59ab25aed5ca$export$39aea81548242927.RFC1459;
        let cm = $bd3c59ab25aed5ca$export$39aea81548242927.byName(name);
        if (!cm) {
            console.error("Unsupported case-mapping '" + name + "', falling back to RFC 1459");
            return $bd3c59ab25aed5ca$export$39aea81548242927.RFC1459;
        }
        return cm;
    }
    monitor() {
        if (!this.raw.has("MONITOR")) return 0;
        let v = this.raw.get("MONITOR");
        if (v === "") return Infinity;
        return parseInt(v, 10);
    }
    whox() {
        return this.raw.has("WHOX");
    }
    prefix() {
        return this.raw.get("PREFIX") || "";
    }
    chanTypes() {
        return this.raw.get("CHANTYPES") || $bd3c59ab25aed5ca$export$85cfa99a207ea7bc;
    }
    statusMsg() {
        return this.raw.get("STATUSMSG");
    }
    network() {
        return this.raw.get("NETWORK");
    }
    chatHistory() {
        if (!this.raw.has("CHATHISTORY")) return 0;
        let n = parseInt(this.raw.get("CHATHISTORY"), 10);
        if (n <= 0) return Infinity;
        return n;
    }
    bouncerNetID() {
        return this.raw.get("BOUNCER_NETID");
    }
    chanModes() {
        const stdChanModes = [
            "beI",
            "k",
            "l",
            "imnst"
        ];
        if (!this.raw.has("CHANMODES")) return stdChanModes;
        let chanModes = this.raw.get("CHANMODES").split(",");
        if (chanModes.length != 4) {
            console.error("Invalid CHANMODES: ", this.raw.get("CHANMODES"));
            return stdChanModes;
        }
        return chanModes;
    }
    bot() {
        return this.raw.get("BOT");
    }
    userLen() {
        if (!this.raw.has("USERLEN")) return 20;
        return parseInt(this.raw.get("USERLEN"), 10);
    }
    hostLen() {
        if (!this.raw.has("HOSTLEN")) return 63;
        return parseInt(this.raw.get("HOSTLEN"), 10);
    }
    lineLen() {
        if (!this.raw.has("LINELEN")) return 512;
        return parseInt(this.raw.get("LINELEN"), 10);
    }
    filehost() {
        return this.raw.get("SOJU.IM/FILEHOST");
    }
}
function $bd3c59ab25aed5ca$export$feed2f17626e5168(isupport, nick, target) {
    let user = "_".repeat(isupport.userLen());
    let host = "_".repeat(isupport.hostLen());
    let prefix = {
        name: nick,
        user: user,
        host: host
    };
    let msg = {
        prefix: prefix,
        command: "PRIVMSG",
        params: [
            target,
            ""
        ]
    };
    let raw = $bd3c59ab25aed5ca$export$25868d1e8e76735f(msg) + "\r\n";
    return isupport.lineLen() - raw.length;
}
const $bd3c59ab25aed5ca$export$39aea81548242927 = {
    ASCII (str) {
        let out = "";
        for(let i = 0; i < str.length; i++){
            let ch = str[i];
            if ("A" <= ch && ch <= "Z") ch = ch.toLowerCase();
            out += ch;
        }
        return out;
    },
    RFC1459 (str) {
        let out = "";
        for(let i = 0; i < str.length; i++){
            let ch = str[i];
            if ("A" <= ch && ch <= "Z") ch = ch.toLowerCase();
            else if (ch == "{") ch = "[";
            else if (ch == "}") ch = "]";
            else if (ch == "\\") ch = "|";
            else if (ch == "~") ch = "^";
            out += ch;
        }
        return out;
    },
    RFC1459Strict (str) {
        let out = "";
        for(let i = 0; i < str.length; i++){
            let ch = str[i];
            if ("A" <= ch && ch <= "Z") ch = ch.toLowerCase();
            else if (ch == "{") ch = "[";
            else if (ch == "}") ch = "]";
            else if (ch == "\\") ch = "|";
            out += ch;
        }
        return out;
    },
    byName (name) {
        switch(name){
            case "ascii":
                return $bd3c59ab25aed5ca$export$39aea81548242927.ASCII;
            case "rfc1459":
                return $bd3c59ab25aed5ca$export$39aea81548242927.RFC1459;
            case "rfc1459-strict":
                return $bd3c59ab25aed5ca$export$39aea81548242927.RFC1459Strict;
        }
        return null;
    }
};
function $bd3c59ab25aed5ca$var$createIterator(next) {
    let it = {
        next: next
    };
    // Not defining this can lead to surprises when feeding the iterator
    // to e.g. Array.from
    it[Symbol.iterator] = ()=>it;
    return it;
}
function $bd3c59ab25aed5ca$var$mapIterator(it, f) {
    return $bd3c59ab25aed5ca$var$createIterator(()=>{
        let { value: value, done: done } = it.next();
        if (done) return {
            done: true
        };
        return {
            value: f(value),
            done: false
        };
    });
}
class $bd3c59ab25aed5ca$export$6296a711f00288b1 {
    caseMap = null;
    map = null;
    constructor(iterable, cm){
        if (iterable instanceof $bd3c59ab25aed5ca$export$6296a711f00288b1 && (iterable.caseMap === cm || !cm)) {
            // Fast-path if we're just cloning another CaseMapMap
            this.caseMap = iterable.caseMap;
            this.map = new Map(iterable.map);
        } else {
            if (!cm) throw new Error("Missing case-mapping when creating CaseMapMap");
            this.caseMap = cm;
            this.map = new Map();
            if (iterable) for (let [key, value] of iterable)this.set(key, value);
        }
    }
    get size() {
        return this.map.size;
    }
    has(key) {
        return this.map.has(this.caseMap(key));
    }
    get(key) {
        let kv = this.map.get(this.caseMap(key));
        if (kv) return kv.value;
        return undefined;
    }
    set(key, value) {
        this.map.set(this.caseMap(key), {
            key: key,
            value: value
        });
    }
    delete(key) {
        this.map.delete(this.caseMap(key));
    }
    entries() {
        let it = this.map.values();
        return $bd3c59ab25aed5ca$var$mapIterator(it, (kv)=>{
            return [
                kv.key,
                kv.value
            ];
        });
    }
    keys() {
        let it = this.map.values();
        return $bd3c59ab25aed5ca$var$mapIterator(it, (kv)=>{
            return kv.key;
        });
    }
    values() {
        let it = this.map.values();
        return $bd3c59ab25aed5ca$var$mapIterator(it, (kv)=>{
            return kv.value;
        });
    }
    [Symbol.iterator]() {
        return this.entries();
    }
}
function $bd3c59ab25aed5ca$export$3b27c9ff97cdb350(str) {
    if (str[0] !== "(") throw new Error("malformed ISUPPORT PREFIX value: expected opening parenthesis");
    let sep = str.indexOf(")");
    if (sep < 0) throw new Error("malformed ISUPPORT PREFIX value: expected closing parenthesis");
    let n = str.length - sep - 1;
    let memberships = [];
    for(let i = 0; i < n; i++){
        let mode = str[i + 1];
        let prefix = str[sep + i + 1];
        memberships.push({
            mode: mode,
            prefix: prefix
        });
    }
    return memberships;
}
function $bd3c59ab25aed5ca$export$f4751a564f6d84a3(msg, type) {
    let batch = msg.batch;
    while(batch){
        if (batch.type === type) return batch;
        batch = batch.parent;
    }
    return null;
}
function $bd3c59ab25aed5ca$export$ec840f96613effe2(msg) {
    if (msg.tags.label) return msg.tags.label;
    let batch = msg.batch;
    while(batch){
        if (batch.tags.label) return batch.tags.label;
        batch = batch.parent;
    }
    return null;
}
function $bd3c59ab25aed5ca$export$6115b92b9c2241a7(msg, isupport, callback) {
    let [a, b, c, d] = isupport.chanModes();
    let prefix = isupport.prefix();
    let typeByMode = new Map();
    Array.from(a).forEach((mode)=>typeByMode.set(mode, "A"));
    Array.from(b).forEach((mode)=>typeByMode.set(mode, "B"));
    Array.from(c).forEach((mode)=>typeByMode.set(mode, "C"));
    Array.from(d).forEach((mode)=>typeByMode.set(mode, "D"));
    $bd3c59ab25aed5ca$export$3b27c9ff97cdb350(prefix).forEach((membership)=>typeByMode.set(membership.mode, "B"));
    if (msg.command !== "MODE") throw new Error("Expected a MODE message");
    let change = msg.params[1];
    let args = msg.params.slice(2);
    let plusMinus = null;
    let j = 0;
    for(let i = 0; i < change.length; i++){
        if (change[i] === "+" || change[i] === "-") {
            plusMinus = change[i];
            continue;
        }
        if (!plusMinus) throw new Error("malformed mode string: missing plus/minus");
        let mode = change[i];
        let add = plusMinus === "+";
        let modeType = typeByMode.get(mode);
        if (!modeType) continue;
        let arg = null;
        if (modeType === "A" || modeType === "B" || modeType === "C" && add) {
            arg = args[j];
            j++;
        }
        callback(mode, add, arg);
    }
}
function $bd3c59ab25aed5ca$export$64ec8def5466157c(realname, nick) {
    if (!realname || realname === nick) return false;
    if (realname.toLowerCase() === "realname" || realname.toLowerCase() === "unknown" || realname.toLowerCase() === "fullname") return false;
    // TODO: add more quirks
    return true;
}
function $bd3c59ab25aed5ca$export$4b3d9a5bae55976(str) {
    if (!str.startsWith("irc://") && !str.startsWith("ircs://")) return null;
    str = str.slice(str.indexOf(":") + 3);
    let loc;
    let i = str.indexOf("/");
    if (i < 0) {
        loc = str;
        str = "";
    } else {
        loc = str.slice(0, i);
        str = str.slice(i + 1);
    }
    let host = loc;
    i = loc.indexOf("@");
    if (i >= 0) host = loc.slice(i + 1);
    i = str.indexOf("?");
    if (i >= 0) str = str.slice(0, i);
    let enttype;
    i = str.indexOf(",");
    if (i >= 0) {
        let flags = str.slice(i + 1).split(",");
        str = str.slice(0, i);
        if (flags.indexOf("isuser") >= 0) enttype = "user";
        else if (flags.indexOf("ischannel") >= 0) enttype = "channel";
    // TODO: parse hosttype
    }
    let entity = decodeURIComponent(str);
    if (!enttype) // TODO: technically we should use the PREFIX ISUPPORT here
    enttype = entity.startsWith("#") ? "channel" : "user";
    return {
        host: host,
        enttype: enttype,
        entity: entity
    };
}
function $bd3c59ab25aed5ca$export$b1ef46223b559f9d({ host: host, enttype: enttype, entity: entity } = {}) {
    host = host || "";
    entity = entity || "";
    let s = "irc://" + host + "/" + encodeURIComponent(entity);
    if (enttype) s += ",is" + enttype;
    return s;
}
class $bd3c59ab25aed5ca$export$e3d1e02a8f18f40e {
    available = new Map();
    enabled = new Set();
    addAvailable(s) {
        let l = s.split(" ");
        l.forEach((s)=>{
            let i = s.indexOf("=");
            let k = s, v = "";
            if (i >= 0) {
                k = s.slice(0, i);
                v = s.slice(i + 1);
            }
            this.available.set(k.toLowerCase(), v);
        });
    }
    parse(msg) {
        if (msg.command !== "CAP") return;
        let subCmd = msg.params[1];
        let args = msg.params.slice(2);
        switch(subCmd){
            case "LS":
                this.addAvailable(args[args.length - 1]);
                break;
            case "NEW":
                this.addAvailable(args[0]);
                break;
            case "DEL":
                args[0].split(" ").forEach((cap)=>{
                    cap = cap.toLowerCase();
                    this.available.delete(cap);
                    this.enabled.delete(cap);
                });
                break;
            case "ACK":
                args[0].split(" ").forEach((cap)=>{
                    cap = cap.toLowerCase();
                    if (cap.startsWith("-")) this.enabled.delete(cap.slice(1));
                    else this.enabled.add(cap);
                });
                break;
        }
    }
    requestAvailable(l) {
        l = l.filter((cap)=>{
            return this.available.has(cap) && !this.enabled.has(cap);
        });
        if (l.length === 0) return null;
        return {
            command: "CAP",
            params: [
                "REQ",
                l.join(" ")
            ]
        };
    }
}



const $71e07b0506970322$var$alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
function $71e07b0506970322$export$c564cdbbe6da493(data) {
    if (!window.TextEncoder) return btoa(data);
    var encoder = new TextEncoder();
    var bytes = encoder.encode(data);
    var trailing = bytes.length % 3;
    var out = "";
    for(var i = 0; i < bytes.length - trailing; i += 3){
        var u24 = (bytes[i] << 16) + (bytes[i + 1] << 8) + bytes[i + 2];
        out += $71e07b0506970322$var$alphabet[u24 >> 18 & 0x3F];
        out += $71e07b0506970322$var$alphabet[u24 >> 12 & 0x3F];
        out += $71e07b0506970322$var$alphabet[u24 >> 6 & 0x3F];
        out += $71e07b0506970322$var$alphabet[u24 & 0x3F];
    }
    if (trailing == 1) {
        var u8 = bytes[bytes.length - 1];
        out += $71e07b0506970322$var$alphabet[u8 >> 2];
        out += $71e07b0506970322$var$alphabet[u8 << 4 & 0x3F];
        out += "==";
    } else if (trailing == 2) {
        var u16 = (bytes[bytes.length - 2] << 8) + bytes[bytes.length - 1];
        out += $71e07b0506970322$var$alphabet[u16 >> 10];
        out += $71e07b0506970322$var$alphabet[u16 >> 4 & 0x3F];
        out += $71e07b0506970322$var$alphabet[u16 << 2 & 0x3F];
        out += "=";
    }
    return out;
}


// Static list of capabilities that are always requested when supported by the
// server
const $6796cfbd59091fe3$var$permanentCaps = [
    "account-notify",
    "away-notify",
    "batch",
    "chghost",
    "echo-message",
    "extended-join",
    "extended-monitor",
    "invite-notify",
    "labeled-response",
    "message-tags",
    "multi-prefix",
    "sasl",
    "server-time",
    "setname",
    "draft/account-registration",
    "draft/chathistory",
    "draft/extended-monitor",
    "draft/read-marker",
    "soju.im/bouncer-networks"
];
const $6796cfbd59091fe3$var$RECONNECT_MIN_DELAY_MSEC = 10000; // 10s
const $6796cfbd59091fe3$var$RECONNECT_MAX_DELAY_MSEC = 600000; // 10min
// WebSocket status codes
// https://www.rfc-editor.org/rfc/rfc6455.html#section-7.4.1
const $6796cfbd59091fe3$var$NORMAL_CLOSURE = 1000;
const $6796cfbd59091fe3$var$GOING_AWAY = 1001;
const $6796cfbd59091fe3$var$UNSUPPORTED_DATA = 1003;
// See https://github.com/quakenet/snircd/blob/master/doc/readme.who
// Sorted by order of appearance in RPL_WHOSPCRPL
const $6796cfbd59091fe3$var$WHOX_FIELDS = {
    "channel": "c",
    "username": "u",
    "hostname": "h",
    "server": "s",
    "nick": "n",
    "flags": "f",
    "account": "a",
    "realname": "r"
};
const $6796cfbd59091fe3$var$FALLBACK_SERVER_PREFIX = {
    name: "*"
};
let $6796cfbd59091fe3$var$lastLabel = 0;
let $6796cfbd59091fe3$var$lastWhoxToken = 0;
class $6796cfbd59091fe3$var$IRCError extends Error {
    constructor(msg){
        let text;
        if (msg.params.length > 0) // IRC errors have a human-readable message as last param
        text = msg.params[msg.params.length - 1];
        else text = `unknown error (${msg.command})`;
        super(text);
        this.msg = msg;
    }
}
/**
 * Implements a simple exponential backoff.
 */ class $6796cfbd59091fe3$var$Backoff {
    n = 0;
    constructor(min, max){
        this.min = min;
        this.max = max;
    }
    reset() {
        this.n = 0;
    }
    next() {
        if (this.n === 0) {
            this.n = 1;
            return this.min;
        }
        let dur = this.n * this.min;
        if (dur > this.max) dur = this.max;
        else this.n *= 2;
        return dur;
    }
}
class $6796cfbd59091fe3$export$2e2bcd8739ae039 extends EventTarget {
    static Status = {
        DISCONNECTED: "disconnected",
        CONNECTING: "connecting",
        REGISTERING: "registering",
        REGISTERED: "registered"
    };
    status = $6796cfbd59091fe3$export$2e2bcd8739ae039.Status.DISCONNECTED;
    serverPrefix = $6796cfbd59091fe3$var$FALLBACK_SERVER_PREFIX;
    nick = null;
    supportsCap = false;
    caps = new $bd3c59ab25aed5ca$export$e3d1e02a8f18f40e();
    isupport = new $bd3c59ab25aed5ca$export$23c4b2cbd0633e6b();
    ws = null;
    params = {
        url: null,
        username: null,
        realname: null,
        nick: null,
        pass: null,
        saslPlain: null,
        saslExternal: false,
        saslOauthBearer: null,
        bouncerNetwork: null,
        ping: 0,
        eventPlayback: true
    };
    debug = false;
    batches = new Map();
    autoReconnect = true;
    reconnectTimeoutID = null;
    reconnectBackoff = new $6796cfbd59091fe3$var$Backoff($6796cfbd59091fe3$var$RECONNECT_MIN_DELAY_MSEC, $6796cfbd59091fe3$var$RECONNECT_MAX_DELAY_MSEC);
    pingIntervalID = null;
    pendingCmds = {
        WHO: Promise.resolve(null),
        CHATHISTORY: Promise.resolve(null)
    };
    cm = $bd3c59ab25aed5ca$export$39aea81548242927.RFC1459;
    monitored = new $bd3c59ab25aed5ca$export$6296a711f00288b1(null, $bd3c59ab25aed5ca$export$39aea81548242927.RFC1459);
    pendingLists = new $bd3c59ab25aed5ca$export$6296a711f00288b1(null, $bd3c59ab25aed5ca$export$39aea81548242927.RFC1459);
    whoxQueries = new Map();
    constructor(params){
        super();
        this.params = {
            ...this.params,
            ...params
        };
        this.reconnect();
    }
    reconnect() {
        let autoReconnect = this.autoReconnect;
        this.disconnect();
        this.autoReconnect = autoReconnect;
        console.log("Connecting to " + this.params.url);
        this.setStatus($6796cfbd59091fe3$export$2e2bcd8739ae039.Status.CONNECTING);
        try {
            this.ws = new WebSocket(this.params.url);
        } catch (err) {
            console.error("Failed to create connection:", err);
            setTimeout(()=>{
                this.dispatchError(new Error("Failed to create connection", {
                    cause: err
                }));
                this.setStatus($6796cfbd59091fe3$export$2e2bcd8739ae039.Status.DISCONNECTED);
            }, 0);
            return;
        }
        this.ws.addEventListener("open", this.handleOpen.bind(this));
        this.ws.addEventListener("message", (event)=>{
            try {
                this.handleMessage(event);
            } catch (err) {
                this.dispatchError(err);
                this.disconnect();
            }
        });
        this.ws.addEventListener("close", (event)=>{
            console.log("Connection closed (code: " + event.code + ")");
            if (event.code !== $6796cfbd59091fe3$var$NORMAL_CLOSURE && event.code !== $6796cfbd59091fe3$var$GOING_AWAY) this.dispatchError(new Error("Connection error"));
            this.ws = null;
            this.setStatus($6796cfbd59091fe3$export$2e2bcd8739ae039.Status.DISCONNECTED);
            this.nick = null;
            this.serverPrefix = $6796cfbd59091fe3$var$FALLBACK_SERVER_PREFIX;
            this.caps = new $bd3c59ab25aed5ca$export$e3d1e02a8f18f40e();
            this.batches = new Map();
            Object.keys(this.pendingCmds).forEach((k)=>{
                this.pendingCmds[k] = Promise.resolve(null);
            });
            this.isupport = new $bd3c59ab25aed5ca$export$23c4b2cbd0633e6b();
            this.monitored = new $bd3c59ab25aed5ca$export$6296a711f00288b1(null, $bd3c59ab25aed5ca$export$39aea81548242927.RFC1459);
            if (this.autoReconnect) {
                if (!navigator.onLine) {
                    console.info("Waiting for network to go back online");
                    const handleOnline = ()=>{
                        window.removeEventListener("online", handleOnline);
                        this.reconnect();
                    };
                    window.addEventListener("online", handleOnline);
                } else {
                    let delay = this.reconnectBackoff.next();
                    console.info("Reconnecting to server in " + delay / 1000 + " seconds");
                    clearTimeout(this.reconnectTimeoutID);
                    this.reconnectTimeoutID = setTimeout(()=>{
                        this.reconnect();
                    }, delay);
                }
            }
        });
    }
    disconnect() {
        this.autoReconnect = false;
        clearTimeout(this.reconnectTimeoutID);
        this.reconnectTimeoutID = null;
        this.setPingInterval(0);
        if (this.ws) this.ws.close($6796cfbd59091fe3$var$NORMAL_CLOSURE);
    }
    setStatus(status) {
        if (this.status === status) return;
        this.status = status;
        this.dispatchEvent(new CustomEvent("status"));
    }
    dispatchError(err) {
        this.dispatchEvent(new CustomEvent("error", {
            detail: err
        }));
    }
    handleOpen() {
        console.log("Connection opened");
        this.setStatus($6796cfbd59091fe3$export$2e2bcd8739ae039.Status.REGISTERING);
        this.reconnectBackoff.reset();
        this.setPingInterval(this.params.ping);
        this.nick = this.params.nick;
        this.send({
            command: "CAP",
            params: [
                "LS",
                "302"
            ]
        });
        if (this.params.pass) this.send({
            command: "PASS",
            params: [
                this.params.pass
            ]
        });
        this.send({
            command: "NICK",
            params: [
                this.nick
            ]
        });
        this.send({
            command: "USER",
            params: [
                this.params.username,
                "0",
                "*",
                this.params.realname
            ]
        });
    }
    pushPendingList(k, msg) {
        let l = this.pendingLists.get(k);
        if (!l) {
            l = [];
            this.pendingLists.set(k, l);
        }
        l.push(msg);
    }
    endPendingList(k, msg) {
        msg.list = this.pendingLists.get(k) || [];
        this.pendingLists.delete(k);
    }
    handleMessage(event) {
        if (typeof event.data !== "string") {
            console.error("Received unsupported data type:", event.data);
            this.ws.close($6796cfbd59091fe3$var$UNSUPPORTED_DATA);
            return;
        }
        let raw = event.data;
        if (this.debug) console.debug("Received:", raw);
        let msg = $bd3c59ab25aed5ca$export$f2f615077a189f21(raw);
        // If the prefix is missing, assume it's coming from the server on the
        // other end of the connection
        if (!msg.prefix) msg.prefix = this.serverPrefix;
        if (!msg.tags) msg.tags = {};
        let msgBatch = null;
        if (msg.tags["batch"]) {
            msgBatch = this.batches.get(msg.tags["batch"]);
            if (msgBatch) msg.batch = msgBatch;
        }
        let deleteBatch = null;
        let k;
        switch(msg.command){
            case $bd3c59ab25aed5ca$export$cac9ca3596de2b3a:
                if (this.params.saslPlain && !this.supportsCap) {
                    this.dispatchError(new Error("Server doesn't support SASL PLAIN"));
                    this.disconnect();
                    return;
                }
                if (msg.prefix) this.serverPrefix = msg.prefix;
                this.nick = msg.params[0];
                console.log("Registration complete");
                this.setStatus($6796cfbd59091fe3$export$2e2bcd8739ae039.Status.REGISTERED);
                break;
            case $bd3c59ab25aed5ca$export$1d0c7ae9b6b17819:
                let prevMaxMonitorTargets = this.isupport.monitor();
                let tokens = msg.params.slice(1, -1);
                this.isupport.parse(tokens);
                this.updateCaseMapping();
                let maxMonitorTargets = this.isupport.monitor();
                if (prevMaxMonitorTargets === 0 && this.monitored.size > 0 && maxMonitorTargets > 0) {
                    let targets = Array.from(this.monitored.keys()).slice(0, maxMonitorTargets);
                    this.send({
                        command: "MONITOR",
                        params: [
                            "+",
                            targets.join(",")
                        ]
                    });
                }
                break;
            case $bd3c59ab25aed5ca$export$cad5f2640c65ad1e:
            case $bd3c59ab25aed5ca$export$7e8b5ab33a021d11:
                // These messages are used to indicate the end of the ISUPPORT list
                if (!this.isupport.raw.has("CASEMAPPING")) // Server didn't send any CASEMAPPING token, assume RFC 1459
                this.updateCaseMapping();
                break;
            case "CAP":
                this.handleCap(msg);
                break;
            case "AUTHENTICATE":
                // Both PLAIN and EXTERNAL expect an empty challenge
                let challengeStr = msg.params[0];
                if (challengeStr != "+") {
                    this.dispatchError(new Error("Expected an empty challenge, got: " + challengeStr));
                    this.send({
                        command: "AUTHENTICATE",
                        params: [
                            "*"
                        ]
                    });
                }
                break;
            case $bd3c59ab25aed5ca$export$97b01f8c0b76e599:
                console.log("Logged in");
                break;
            case $bd3c59ab25aed5ca$export$3ae55a67359785dc:
                console.log("Logged out");
                break;
            case $bd3c59ab25aed5ca$export$18c4a4c5c97dce9b:
                this.pushPendingList("NAMES " + msg.params[2], msg);
                break;
            case $bd3c59ab25aed5ca$export$698923df90b7ea6d:
                this.endPendingList("NAMES " + msg.params[1], msg);
                break;
            case $bd3c59ab25aed5ca$export$9514b1191eaefcec:
            case $bd3c59ab25aed5ca$export$5fb4b19390213db9:
            case $bd3c59ab25aed5ca$export$ed3b11a38dbfed2c:
            case $bd3c59ab25aed5ca$export$322843849bf6282:
            case $bd3c59ab25aed5ca$export$1982ce771bb0f0ea:
                this.pushPendingList("WHOIS " + msg.params[1], msg);
                break;
            case $bd3c59ab25aed5ca$export$ec20f8e9d0ad5539:
                this.endPendingList("WHOIS " + msg.params[1], msg);
                break;
            case $bd3c59ab25aed5ca$export$ea7f3a22477f88c4:
            case $bd3c59ab25aed5ca$export$f45306e17f085f4e:
                this.pushPendingList("WHO", msg);
                break;
            case $bd3c59ab25aed5ca$export$1ea987b9a16ea266:
                this.endPendingList("WHO", msg);
                break;
            case "PING":
                this.send({
                    command: "PONG",
                    params: [
                        msg.params[0]
                    ]
                });
                break;
            case "NICK":
                let newNick = msg.params[0];
                if (this.isMyNick(msg.prefix.name)) this.nick = newNick;
                break;
            case "BATCH":
                let enter = msg.params[0].startsWith("+");
                let name = msg.params[0].slice(1);
                if (enter) {
                    let batch = {
                        name: name,
                        type: msg.params[1],
                        params: msg.params.slice(2),
                        tags: msg.tags,
                        parent: msgBatch
                    };
                    this.batches.set(name, batch);
                } else deleteBatch = name;
                break;
            case "ERROR":
                this.dispatchError(new $6796cfbd59091fe3$var$IRCError(msg));
                this.disconnect();
                break;
            case $bd3c59ab25aed5ca$export$9d6a3a6ab4c58e66:
            case $bd3c59ab25aed5ca$export$4743685aa8150ce0:
            case $bd3c59ab25aed5ca$export$8b9229ff310aa80f:
            case $bd3c59ab25aed5ca$export$7610afb40d396829:
            case $bd3c59ab25aed5ca$export$2b6618e870672e76:
            case $bd3c59ab25aed5ca$export$3ae3da5f6b8010ab:
            case $bd3c59ab25aed5ca$export$1e0e84545800b47a:
                this.dispatchError(new $6796cfbd59091fe3$var$IRCError(msg));
                if (this.status != $6796cfbd59091fe3$export$2e2bcd8739ae039.Status.REGISTERED) this.disconnect();
                break;
            case "FAIL":
                if (this.status === $6796cfbd59091fe3$export$2e2bcd8739ae039.Status.REGISTERED) break;
                let reason = msg.params[msg.params.length - 1];
                if (msg.params[0] === "BOUNCER" && msg.params[2] === "BIND") {
                    this.dispatchError(new Error("Failed to bind to bouncer network", {
                        cause: new $6796cfbd59091fe3$var$IRCError(msg)
                    }));
                    this.disconnect();
                }
                if (msg.params[1] === "ACCOUNT_REQUIRED") {
                    this.dispatchError(new $6796cfbd59091fe3$var$IRCError(msg));
                    this.disconnect();
                }
                break;
        }
        this.dispatchEvent(new CustomEvent("message", {
            detail: {
                message: msg,
                batch: msgBatch
            }
        }));
        // Delete after firing the message event so that handlers can access
        // the batch
        if (deleteBatch) this.batches.delete(deleteBatch);
    }
    authenticate(mechanism, params) {
        if (!this.supportsSASL(mechanism)) throw new Error(`${mechanism} authentication not supported by the server`);
        console.log(`Starting SASL ${mechanism} authentication`);
        // Send the first SASL response immediately to avoid a roundtrip
        let initialResp = null;
        switch(mechanism){
            case "PLAIN":
                let respStr = $71e07b0506970322$export$c564cdbbe6da493("\0" + params.username + "\0" + params.password);
                initialResp = {
                    command: "AUTHENTICATE",
                    params: [
                        respStr
                    ]
                };
                break;
            case "EXTERNAL":
                initialResp = {
                    command: "AUTHENTICATE",
                    params: [
                        "+"
                    ]
                };
                break;
            case "OAUTHBEARER":
                let raw = "n,,\x01auth=Bearer " + params.token + "\x01\x01";
                initialResp = {
                    command: "AUTHENTICATE",
                    params: [
                        $71e07b0506970322$export$c564cdbbe6da493(raw)
                    ]
                };
                break;
            default:
                throw new Error(`Unknown authentication mechanism '${mechanism}'`);
        }
        let startMsg = {
            command: "AUTHENTICATE",
            params: [
                mechanism
            ]
        };
        let promise = this.roundtrip(startMsg, (msg)=>{
            switch(msg.command){
                case $bd3c59ab25aed5ca$export$cba31abc2138b15e:
                    return true;
                case $bd3c59ab25aed5ca$export$37e8d81e1e359f6e:
                case $bd3c59ab25aed5ca$export$724018c6aa2adbd0:
                case $bd3c59ab25aed5ca$export$47bb6ff9e6eba14f:
                case $bd3c59ab25aed5ca$export$aae27a063aae3a16:
                case $bd3c59ab25aed5ca$export$a74ae703a035d4a0:
                    throw new $6796cfbd59091fe3$var$IRCError(msg);
            }
        });
        this.send(initialResp);
        return promise;
    }
    who(mask, options) {
        let params = [
            mask
        ];
        let fields = "", token = "";
        if (options && this.isupport.whox()) {
            let match = ""; // Matches exact channel or nick
            fields = "t"; // Always include token in reply
            if (options.fields) options.fields.forEach((k)=>{
                if (!$6796cfbd59091fe3$var$WHOX_FIELDS[k]) throw new Error(`Unknown WHOX field ${k}`);
                fields += $6796cfbd59091fe3$var$WHOX_FIELDS[k];
            });
            token = String($6796cfbd59091fe3$var$lastWhoxToken % 1000);
            $6796cfbd59091fe3$var$lastWhoxToken++;
            params.push(`${match}%${fields},${token}`);
            this.whoxQueries.set(token, fields);
        }
        let msg = {
            command: "WHO",
            params: params
        };
        let l = [];
        let promise = this.pendingCmds.WHO.then(()=>{
            return this.roundtrip(msg, (msg)=>{
                switch(msg.command){
                    case $bd3c59ab25aed5ca$export$ea7f3a22477f88c4:
                        msg.internal = true;
                        l.push(this.parseWhoReply(msg));
                        break;
                    case $bd3c59ab25aed5ca$export$f45306e17f085f4e:
                        if (msg.params.length !== fields.length + 1 || msg.params[1] !== token) break;
                        msg.internal = true;
                        l.push(this.parseWhoReply(msg));
                        break;
                    case $bd3c59ab25aed5ca$export$1ea987b9a16ea266:
                        if (msg.params[1] === mask) {
                            msg.internal = true;
                            return l;
                        }
                        break;
                }
            }).finally(()=>{
                this.whoxQueries.delete(token);
            });
        });
        this.pendingCmds.WHO = promise.catch(()=>{});
        return promise;
    }
    parseWhoReply(msg) {
        switch(msg.command){
            case $bd3c59ab25aed5ca$export$ea7f3a22477f88c4:
                let last = msg.params[msg.params.length - 1];
                return {
                    username: msg.params[2],
                    hostname: msg.params[3],
                    server: msg.params[4],
                    nick: msg.params[5],
                    flags: msg.params[6],
                    realname: last.slice(last.indexOf(" ") + 1)
                };
            case $bd3c59ab25aed5ca$export$f45306e17f085f4e:
                let token = msg.params[1];
                let fields = this.whoxQueries.get(token);
                if (!fields) throw new Error("Unknown WHOX token: " + token);
                let who = {};
                let i = 0;
                Object.keys($6796cfbd59091fe3$var$WHOX_FIELDS).forEach((k)=>{
                    if (fields.indexOf($6796cfbd59091fe3$var$WHOX_FIELDS[k]) < 0) return;
                    who[k] = msg.params[2 + i];
                    i++;
                });
                if (who.account === "0") // WHOX uses "0" to mean "no account"
                who.account = null;
                return who;
            default:
                throw new Error("Not a WHO reply: " + msg.command);
        }
    }
    whois(target) {
        let targetCM = this.cm(target);
        let msg = {
            command: "WHOIS",
            params: [
                target
            ]
        };
        return this.roundtrip(msg, (msg)=>{
            let nick;
            switch(msg.command){
                case $bd3c59ab25aed5ca$export$ec20f8e9d0ad5539:
                    nick = msg.params[1];
                    if (this.cm(nick) === targetCM) {
                        let whois = {};
                        msg.list.forEach((reply)=>{
                            whois[reply.command] = reply;
                        });
                        return whois;
                    }
                    break;
                case $bd3c59ab25aed5ca$export$7ea30511ef6ec211:
                    nick = msg.params[1];
                    if (this.cm(nick) === targetCM) throw new $6796cfbd59091fe3$var$IRCError(msg);
                    break;
            }
        });
    }
    supportsSASL(mech) {
        let saslCap = this.caps.available.get("sasl");
        if (saslCap === undefined) return false;
        return saslCap.split(",").includes(mech);
    }
    checkAccountRegistrationCap(k) {
        let v = this.caps.available.get("draft/account-registration");
        if (v === undefined) return false;
        return v.split(",").includes(k);
    }
    requestCaps() {
        let wantCaps = [].concat($6796cfbd59091fe3$var$permanentCaps);
        if (!this.params.bouncerNetwork) wantCaps.push("soju.im/bouncer-networks-notify");
        if (this.params.eventPlayback) wantCaps.push("draft/event-playback");
        let msg = this.caps.requestAvailable(wantCaps);
        if (msg) this.send(msg);
    }
    handleCap(msg) {
        this.caps.parse(msg);
        let subCmd = msg.params[1];
        let args = msg.params.slice(2);
        switch(subCmd){
            case "LS":
                this.supportsCap = true;
                if (args[0] == "*") break;
                console.log("Available server caps:", this.caps.available);
                this.requestCaps();
                if (this.status !== $6796cfbd59091fe3$export$2e2bcd8739ae039.Status.REGISTERED) {
                    if (this.caps.available.has("sasl")) {
                        let promise;
                        if (this.params.saslPlain) promise = this.authenticate("PLAIN", this.params.saslPlain);
                        else if (this.params.saslExternal) promise = this.authenticate("EXTERNAL");
                        else if (this.params.saslOauthBearer) promise = this.authenticate("OAUTHBEARER", this.params.saslOauthBearer);
                        (promise || Promise.resolve()).catch((err)=>{
                            this.dispatchError(err);
                            this.disconnect();
                        });
                    }
                    if (this.caps.available.has("soju.im/bouncer-networks") && this.params.bouncerNetwork) this.send({
                        command: "BOUNCER",
                        params: [
                            "BIND",
                            this.params.bouncerNetwork
                        ]
                    });
                    this.send({
                        command: "CAP",
                        params: [
                            "END"
                        ]
                    });
                }
                break;
            case "NEW":
                console.log("Server added available caps:", args[0]);
                this.requestCaps();
                break;
            case "DEL":
                console.log("Server removed available caps:", args[0]);
                break;
            case "ACK":
                console.log("Server ack'ed caps:", args[0]);
                break;
            case "NAK":
                console.log("Server nak'ed caps:", args[0]);
                if (this.status !== $6796cfbd59091fe3$export$2e2bcd8739ae039.Status.REGISTERED) this.send({
                    command: "CAP",
                    params: [
                        "END"
                    ]
                });
                break;
        }
    }
    send(msg) {
        if (!this.ws) throw new Error("Failed to send IRC message " + msg.command + ": socket is closed");
        let raw = $bd3c59ab25aed5ca$export$25868d1e8e76735f(msg);
        this.ws.send(raw);
        if (this.debug) console.debug("Sent:", raw);
    }
    updateCaseMapping() {
        this.cm = this.isupport.caseMapping();
        this.pendingLists = new $bd3c59ab25aed5ca$export$6296a711f00288b1(this.pendingLists, this.cm);
        this.monitored = new $bd3c59ab25aed5ca$export$6296a711f00288b1(this.monitored, this.cm);
    }
    isServer(name) {
        return name === "*" || this.cm(name) === this.cm(this.serverPrefix.name);
    }
    isMyNick(nick) {
        return this.cm(nick) == this.cm(this.nick);
    }
    isChannel(name) {
        let chanTypes = this.isupport.chanTypes();
        return chanTypes.indexOf(name[0]) >= 0;
    }
    isNick(name) {
        // A dollar sign is used for server-wide broadcasts
        return !this.isServer(name) && !this.isChannel(name) && !name.startsWith("$");
    }
    setPingInterval(sec) {
        clearInterval(this.pingIntervalID);
        this.pingIntervalID = null;
        if (sec <= 0) return;
        this.pingIntervalID = setInterval(()=>{
            if (this.ws) this.send({
                command: "PING",
                params: [
                    "gamja"
                ]
            });
        }, sec * 1000);
    }
    /* Execute a command that expects a response. `done` is called with message
	 * events until it returns a truthy value. */ roundtrip(msg, done) {
        let cmd = msg.command;
        let label;
        if (this.caps.enabled.has("labeled-response")) {
            $6796cfbd59091fe3$var$lastLabel++;
            label = String($6796cfbd59091fe3$var$lastLabel);
            msg.tags = {
                ...msg.tags,
                label: label
            };
        }
        return new Promise((resolve, reject)=>{
            let removeEventListeners;
            let handleMessage = (event)=>{
                let msg = event.detail.message;
                let msgLabel = $bd3c59ab25aed5ca$export$ec840f96613effe2(msg);
                if (msgLabel && msgLabel != label) return;
                let isError = false;
                switch(msg.command){
                    case "FAIL":
                        isError = msg.params[0] === cmd;
                        break;
                    case $bd3c59ab25aed5ca$export$f0fc9feb21c3ef1b:
                    case $bd3c59ab25aed5ca$export$da101e59b60ec32a:
                    case $bd3c59ab25aed5ca$export$e9c321b4bd63421d:
                    case $bd3c59ab25aed5ca$export$5075048a1d9ba016:
                        isError = msg.params[1] === cmd;
                        break;
                }
                if (isError) {
                    removeEventListeners();
                    reject(new $6796cfbd59091fe3$var$IRCError(msg));
                    return;
                }
                let result;
                try {
                    result = done(msg);
                } catch (err) {
                    removeEventListeners();
                    reject(err);
                }
                if (result) {
                    removeEventListeners();
                    resolve(result);
                }
            // TODO: handle end of labeled response somehow
            };
            let handleStatus = ()=>{
                if (this.status === $6796cfbd59091fe3$export$2e2bcd8739ae039.Status.DISCONNECTED) {
                    removeEventListeners();
                    reject(new Error("Connection closed"));
                }
            };
            removeEventListeners = ()=>{
                this.removeEventListener("message", handleMessage);
                this.removeEventListener("status", handleStatus);
            };
            // Turn on capture to handle messages before external users and
            // have the opportunity to set the "internal" flag
            this.addEventListener("message", handleMessage, {
                capture: true
            });
            this.addEventListener("status", handleStatus);
            this.send(msg);
        });
    }
    join(channel, password) {
        let params = [
            channel
        ];
        if (password) params.push(password);
        let msg = {
            command: "JOIN",
            params: params
        };
        return this.roundtrip(msg, (msg)=>{
            switch(msg.command){
                case $bd3c59ab25aed5ca$export$b889507e4da9d85b:
                case $bd3c59ab25aed5ca$export$d9dd0c5028129ffb:
                case $bd3c59ab25aed5ca$export$cc57fea2b719b6fa:
                case $bd3c59ab25aed5ca$export$30b572b38bbeae93:
                case $bd3c59ab25aed5ca$export$6ce9c178695ddc97:
                case $bd3c59ab25aed5ca$export$1750cbcab1b05667:
                    if (this.cm(msg.params[1]) === this.cm(channel)) throw new $6796cfbd59091fe3$var$IRCError(msg);
                    break;
                case "JOIN":
                    if (this.isMyNick(msg.prefix.name) && this.cm(msg.params[0]) === this.cm(channel)) return true;
                    break;
            }
        });
    }
    fetchBatch(msg, batchType) {
        let batchName = null;
        let messages = [];
        let cmd = msg.command;
        return this.roundtrip(msg, (msg)=>{
            if (batchName) {
                let batch = msg.batch;
                while(batch){
                    if (batch.name === batchName) {
                        messages.push(msg);
                        break;
                    }
                    batch = batch.parent;
                }
            }
            if (msg.command !== "BATCH") return;
            let enter = msg.params[0].startsWith("+");
            let name = msg.params[0].slice(1);
            if (enter && msg.params[1] === batchType) {
                batchName = name;
                return;
            }
            if (!enter && name === batchName) return {
                ...this.batches.get(name),
                messages: messages
            };
        });
    }
    roundtripChatHistory(params) {
        // Don't send multiple CHATHISTORY commands in parallel, we can't
        // properly handle batches and errors.
        let promise = this.pendingCmds.CHATHISTORY.then(()=>{
            let msg = {
                command: "CHATHISTORY",
                params: params
            };
            return this.fetchBatch(msg, "chathistory").then((batch)=>batch.messages);
        });
        this.pendingCmds.CHATHISTORY = promise.catch(()=>{});
        return promise;
    }
    /* Fetch one page of history before the given date. */ async fetchHistoryBefore(target, before, limit) {
        let max = Math.min(limit, this.isupport.chatHistory());
        let params = [
            "BEFORE",
            target,
            "timestamp=" + before,
            max
        ];
        let messages = await this.roundtripChatHistory(params);
        return {
            messages: messages,
            more: messages.length >= max
        };
    }
    /* Fetch history in ascending order. */ async fetchHistoryBetween(target, after, before, limit) {
        let max = Math.min(limit, this.isupport.chatHistory());
        let params = [
            "AFTER",
            target,
            "timestamp=" + after.time,
            max
        ];
        let messages = await this.roundtripChatHistory(params);
        limit -= messages.length;
        if (limit <= 0) throw new Error("Cannot fetch all chat history: too many messages");
        if (messages.length >= max) {
            // There are still more messages to fetch
            after.time = messages[messages.length - 1].tags.time;
            return await this.fetchHistoryBetween(target, after, before, limit);
        }
        return {
            messages: messages
        };
    }
    async fetchHistoryTargets(t1, t2) {
        let msg = {
            command: "CHATHISTORY",
            params: [
                "TARGETS",
                "timestamp=" + t1,
                "timestamp=" + t2,
                1000
            ]
        };
        let batch = await this.fetchBatch(msg, "draft/chathistory-targets");
        return batch.messages.map((msg)=>{
            console.assert(msg.command === "CHATHISTORY" && msg.params[0] === "TARGETS");
            return {
                name: msg.params[1],
                latestMessage: msg.params[2]
            };
        });
    }
    async listBouncerNetworks() {
        let req = {
            command: "BOUNCER",
            params: [
                "LISTNETWORKS"
            ]
        };
        let batch = await this.fetchBatch(req, "soju.im/bouncer-networks");
        let networks = new Map();
        for (let msg of batch.messages){
            console.assert(msg.command === "BOUNCER" && msg.params[0] === "NETWORK");
            let id = msg.params[1];
            let params = $bd3c59ab25aed5ca$export$ede4b2e0172bbdb1(msg.params[2]);
            networks.set(id, params);
        }
        return networks;
    }
    monitor(target) {
        if (this.monitored.has(target)) return;
        this.monitored.set(target, true);
        // TODO: add poll-based fallback when MONITOR is not supported
        if (this.monitored.size + 1 > this.isupport.monitor()) return;
        this.send({
            command: "MONITOR",
            params: [
                "+",
                target
            ]
        });
    }
    unmonitor(target) {
        if (!this.monitored.has(target)) return;
        this.monitored.delete(target);
        if (this.isupport.monitor() <= 0) return;
        this.send({
            command: "MONITOR",
            params: [
                "-",
                target
            ]
        });
    }
    createBouncerNetwork(attrs) {
        let msg = {
            command: "BOUNCER",
            params: [
                "ADDNETWORK",
                $bd3c59ab25aed5ca$export$c27de7dba30c634a(attrs)
            ]
        };
        return this.roundtrip(msg, (msg)=>{
            if (msg.command === "BOUNCER" && msg.params[0] === "ADDNETWORK") return msg.params[1];
        });
    }
    registerAccount(email, password) {
        let msg = {
            command: "REGISTER",
            params: [
                "*",
                email || "*",
                password
            ]
        };
        return this.roundtrip(msg, (msg)=>{
            if (msg.command !== "REGISTER") return;
            let result = msg.params[0];
            return {
                verificationRequired: result === "VERIFICATION_REQUIRED",
                account: msg.params[1],
                message: msg.params[2]
            };
        });
    }
    verifyAccount(account, code) {
        let msg = {
            command: "VERIFY",
            params: [
                account,
                code
            ]
        };
        return this.roundtrip(msg, (msg)=>{
            if (msg.command !== "VERIFY") return;
            return {
                message: msg.params[2]
            };
        });
    }
    supportsReadMarker() {
        return this.caps.enabled.has("draft/read-marker");
    }
    fetchReadMarker(target) {
        this.send({
            command: "MARKREAD",
            params: [
                target
            ]
        });
    }
    setReadMarker(target, t) {
        this.send({
            command: "MARKREAD",
            params: [
                target,
                "timestamp=" + t
            ]
        });
    }
}


function $572a887a57d3418e$var$formatQueryString(params) {
    let l = [];
    for(let k in params)l.push(encodeURIComponent(k) + "=" + encodeURIComponent(params[k]));
    return l.join("&");
}
async function $572a887a57d3418e$export$9326d7767c1b7bbc(url) {
    // TODO: handle path in config.oauth2.url
    let resp;
    try {
        resp = await fetch(url + "/.well-known/oauth-authorization-server");
        if (!resp.ok) throw new Error(`HTTP error: ${resp.status} ${resp.statusText}`);
    } catch (err) {
        console.warn("OAuth 2.0 server doesn't support Authorization Server Metadata (retrying with OpenID Connect Discovery): ", err);
        resp = await fetch(url + "/.well-known/openid-configuration");
        if (!resp.ok) throw new Error(`HTTP error: ${resp.status} ${resp.statusText}`);
    }
    let data = await resp.json();
    if (!data.issuer) throw new Error("Missing issuer in response");
    if (!data.authorization_endpoint) throw new Error("Missing authorization_endpoint in response");
    if (!data.token_endpoint) throw new Error("Missing authorization_endpoint in response");
    if (!data.response_types_supported.includes("code")) throw new Error("Server doesn't support authorization code response type");
    return data;
}
function $572a887a57d3418e$export$425e62132119a96f({ serverMetadata: serverMetadata, clientId: clientId, redirectUri: redirectUri, scope: scope }) {
    // TODO: move fragment to query string in redirect_uri
    // TODO: use the state param to prevent cross-site request
    // forgery
    let params = {
        response_type: "code",
        client_id: clientId,
        redirect_uri: redirectUri
    };
    if (scope) params.scope = scope;
    window.location.assign(serverMetadata.authorization_endpoint + "?" + $572a887a57d3418e$var$formatQueryString(params));
}
function $572a887a57d3418e$var$buildPostHeaders(clientId, clientSecret) {
    let headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        "Accept": "application/json"
    };
    if (clientSecret) headers["Authorization"] = "Basic " + btoa(encodeURIComponent(clientId) + ":" + encodeURIComponent(clientSecret));
    return headers;
}
async function $572a887a57d3418e$export$97e44d582df4b68f({ serverMetadata: serverMetadata, redirectUri: redirectUri, code: code, clientId: clientId, clientSecret: clientSecret }) {
    let data = {
        grant_type: "authorization_code",
        code: code,
        redirect_uri: redirectUri
    };
    if (!clientSecret) data.client_id = clientId;
    let resp = await fetch(serverMetadata.token_endpoint, {
        method: "POST",
        headers: $572a887a57d3418e$var$buildPostHeaders(clientId, clientSecret),
        body: $572a887a57d3418e$var$formatQueryString(data)
    });
    if (!resp.ok) throw new Error(`HTTP error: ${resp.status} ${resp.statusText}`);
    data = await resp.json();
    if (data.error) throw new Error("Authentication failed: " + (data.error_description || data.error));
    return data;
}
async function $572a887a57d3418e$export$e03aeda7cfb66622({ serverMetadata: serverMetadata, token: token, clientId: clientId, clientSecret: clientSecret }) {
    let resp = await fetch(serverMetadata.introspection_endpoint, {
        method: "POST",
        headers: $572a887a57d3418e$var$buildPostHeaders(clientId, clientSecret),
        body: $572a887a57d3418e$var$formatQueryString({
            token: token
        })
    });
    if (!resp.ok) throw new Error(`HTTP error: ${resp.status} ${resp.statusText}`);
    let data = await resp.json();
    if (!data.active) throw new Error("Expired token");
    return data;
}




(0, $efca0cb2e3ea1e67$exports).options.defaults.defaultProtocol = "https";
(0, $efca0cb2e3ea1e67$exports).registerCustomProtocol("irc");
(0, $efca0cb2e3ea1e67$exports).registerCustomProtocol("ircs");
(0, $efca0cb2e3ea1e67$exports).registerCustomProtocol("geo", true);
const $37d24d778c2f247c$var$IRCChannelToken = (0, $efca0cb2e3ea1e67$exports).createTokenClass("ircChannel", {
    isLink: true,
    toHref () {
        return "irc:///" + this.v;
    }
});
(0, $efca0cb2e3ea1e67$exports).registerPlugin("ircChannel", ({ scanner: scanner, parser: parser })=>{
    const { POUND: POUND, UNDERSCORE: UNDERSCORE, DOT: DOT, HYPHEN: HYPHEN } = scanner.tokens;
    const { alphanumeric: alphanumeric } = scanner.tokens.groups;
    const Prefix = parser.start.tt(POUND);
    const Channel = new (0, $efca0cb2e3ea1e67$exports).State($37d24d778c2f247c$var$IRCChannelToken);
    const Divider = Channel.tt(DOT);
    Prefix.ta(alphanumeric, Channel);
    Prefix.tt(POUND, Channel);
    Prefix.tt(UNDERSCORE, Channel);
    Prefix.tt(DOT, Divider);
    Prefix.tt(HYPHEN, Channel);
    Channel.ta(alphanumeric, Channel);
    Channel.tt(POUND, Channel);
    Channel.tt(UNDERSCORE, Channel);
    Channel.tt(HYPHEN, Channel);
    Divider.ta(alphanumeric, Channel);
});
function $37d24d778c2f247c$export$2e2bcd8739ae039(text, onClick) {
    let links = (0, $efca0cb2e3ea1e67$exports).find(text);
    let children = [];
    let last = 0;
    links.forEach((match)=>{
        if (!match.isLink) return;
        const prefix = text.substring(last, match.start);
        children.push(prefix);
        children.push((0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
			<a
				href=${match.href}
				target="_blank"
				rel="noreferrer noopener"
				onClick=${onClick}
			>${match.value}</a>
		`);
        last = match.end;
    });
    const suffix = text.substring(last);
    children.push(suffix);
    return children;
}



// See https://modern.ircdocs.horse/formatting.html
const $803ef401580605c5$var$BOLD = "\x02";
const $803ef401580605c5$var$ITALIC = "\x1d";
const $803ef401580605c5$var$UNDERLINE = "\x1f";
const $803ef401580605c5$var$STRIKETHROUGH = "\x1e";
const $803ef401580605c5$var$MONOSPACE = "\x11";
const $803ef401580605c5$var$COLOR = "\x03";
const $803ef401580605c5$var$COLOR_HEX = "\x04";
const $803ef401580605c5$var$REVERSE_COLOR = "\x16";
const $803ef401580605c5$var$RESET = "\x0f";
const $803ef401580605c5$var$HEX_COLOR_LENGTH = 6;
function $803ef401580605c5$var$isDigit(ch) {
    return ch >= "0" && ch <= "9";
}
function $803ef401580605c5$var$isHexColor(text) {
    if (text.length < $803ef401580605c5$var$HEX_COLOR_LENGTH) return false;
    for(let i = 0; i < $803ef401580605c5$var$HEX_COLOR_LENGTH; i++){
        let ch = text[i].toUpperCase();
        let ok = ch >= "0" && ch <= "9" || ch >= "A" && ch <= "F";
        if (!ok) return false;
    }
    return true;
}
function $803ef401580605c5$export$6a0f863afc2134d8(text) {
    let out = "";
    for(let i = 0; i < text.length; i++){
        let ch = text[i];
        switch(ch){
            case $803ef401580605c5$var$BOLD:
            case $803ef401580605c5$var$ITALIC:
            case $803ef401580605c5$var$UNDERLINE:
            case $803ef401580605c5$var$STRIKETHROUGH:
            case $803ef401580605c5$var$MONOSPACE:
            case $803ef401580605c5$var$REVERSE_COLOR:
            case $803ef401580605c5$var$RESET:
                break; // skip
            case $803ef401580605c5$var$COLOR:
                if (!$803ef401580605c5$var$isDigit(text[i + 1])) break;
                i++;
                if ($803ef401580605c5$var$isDigit(text[i + 1])) i++;
                if (text[i + 1] == "," && $803ef401580605c5$var$isDigit(text[i + 2])) {
                    i += 2;
                    if ($803ef401580605c5$var$isDigit(text[i + 1])) i++;
                }
                break;
            case $803ef401580605c5$var$COLOR_HEX:
                if (!$803ef401580605c5$var$isHexColor(text.slice(i + 1))) break;
                i += $803ef401580605c5$var$HEX_COLOR_LENGTH;
                if (text[i + 1] == "," && $803ef401580605c5$var$isHexColor(text.slice(i + 2))) i += 1 + $803ef401580605c5$var$HEX_COLOR_LENGTH;
                break;
            default:
                out += ch;
        }
    }
    return out;
}





const $fca64bf918d5638f$export$50f2960994553271 = "*";
const $fca64bf918d5638f$export$a9b603917c4d9863 = {
    SERVER: "server",
    CHANNEL: "channel",
    NICK: "nick"
};
const $fca64bf918d5638f$export$ac0b13ba2bbce4d5 = (0, $6796cfbd59091fe3$export$2e2bcd8739ae039).Status;
const $fca64bf918d5638f$export$9be0a2424da959ae = {
    NONE: "",
    MESSAGE: "message",
    HIGHLIGHT: "highlight",
    compare (a, b) {
        const priority = {
            [$fca64bf918d5638f$export$9be0a2424da959ae.NONE]: 0,
            [$fca64bf918d5638f$export$9be0a2424da959ae.MESSAGE]: 1,
            [$fca64bf918d5638f$export$9be0a2424da959ae.HIGHLIGHT]: 2
        };
        return priority[a] - priority[b];
    },
    union (a, b) {
        return $fca64bf918d5638f$export$9be0a2424da959ae.compare(a, b) > 0 ? a : b;
    }
};
const $fca64bf918d5638f$export$c49c54eaac29b59a = {
    DELIVERED: "delivered",
    READ: "read"
};
const $fca64bf918d5638f$export$3ee12e3d13dfa897 = {
    FOLD: "fold",
    EXPAND: "expand",
    HIDE: "hide"
};
const $fca64bf918d5638f$export$8fa45c82eddfe270 = (0, $b2a774aae58c7b4e$export$fd42f52fd3ae1109)("settings");
function $fca64bf918d5638f$export$64b0f097aebd4e10(buf) {
    switch(buf.type){
        case $fca64bf918d5638f$export$a9b603917c4d9863.SERVER:
            return $bd3c59ab25aed5ca$export$b1ef46223b559f9d();
        case $fca64bf918d5638f$export$a9b603917c4d9863.CHANNEL:
            return $bd3c59ab25aed5ca$export$b1ef46223b559f9d({
                entity: buf.name
            });
        case $fca64bf918d5638f$export$a9b603917c4d9863.NICK:
            return $bd3c59ab25aed5ca$export$b1ef46223b559f9d({
                entity: buf.name,
                enttype: "user"
            });
    }
    throw new Error("Unknown buffer type: " + buf.type);
}
function $fca64bf918d5638f$export$8499bd1ed7c872c2(buf, msg) {
    let bufURL = $fca64bf918d5638f$export$64b0f097aebd4e10(buf);
    if (msg.tags.msgid) return bufURL + "?msgid=" + encodeURIComponent(msg.tags.msgid);
    else return bufURL + "?timestamp=" + encodeURIComponent(msg.tags.time);
}
function $fca64bf918d5638f$export$53e73e095c2ac1e2(server, bouncerNetwork) {
    let netName = server.name;
    if (bouncerNetwork && bouncerNetwork.name && bouncerNetwork.name !== bouncerNetwork.host) // User has picked a custom name for the network, use that
    return bouncerNetwork.name;
    if (netName) // Server has specified a name
    return netName;
    if (bouncerNetwork) return bouncerNetwork.name || bouncerNetwork.host || "server";
    else if (server.isBouncer) return "bouncer";
    else return "server";
}
function $fca64bf918d5638f$export$1274528beb7cd977(msg) {
    // At this point all messages are supposed to have a time tag.
    // App.addMessage ensures this is the case even if the server doesn't
    // support server-time.
    if (!msg.tags.time) throw new Error("Missing time message tag");
    return {
        time: msg.tags.time
    };
}
function $fca64bf918d5638f$export$4f7e80d679306a83(a, b) {
    if (!b) return false;
    if (!a) return true;
    if (!a.time || !b.time) throw new Error("Missing receipt time");
    return a.time <= b.time;
}
function $fca64bf918d5638f$export$23261bae4c963bb3(msg, receipt) {
    if (!receipt) return false;
    if (!msg.tags.time) throw new Error("Missing time message tag");
    if (!receipt.time) throw new Error("Missing receipt time");
    return msg.tags.time <= receipt.time;
}
function $fca64bf918d5638f$var$updateState(state, updater) {
    let updated;
    if (typeof updater === "function") updated = updater(state, state);
    else updated = updater;
    if (state === updated || !updated) return;
    return {
        ...state,
        ...updated
    };
}
function $fca64bf918d5638f$var$isServerBuffer(buf) {
    return buf.type == $fca64bf918d5638f$export$a9b603917c4d9863.SERVER;
}
/* Returns 1 if a should appear after b, -1 if a should appear before b, or
 * 0 otherwise. */ function $fca64bf918d5638f$var$compareBuffers(a, b) {
    if (a.server != b.server) return a.server > b.server ? 1 : -1;
    if ($fca64bf918d5638f$var$isServerBuffer(a) != $fca64bf918d5638f$var$isServerBuffer(b)) return $fca64bf918d5638f$var$isServerBuffer(b) ? 1 : -1;
    if (a.name != b.name) return a.name.localeCompare(b.name);
    return 0;
}
function $fca64bf918d5638f$var$updateMembership(membership, letter, add, client) {
    let prefix = client.isupport.prefix();
    let prefixPrivs = new Map($bd3c59ab25aed5ca$export$3b27c9ff97cdb350(prefix).map((membership, i)=>{
        return [
            membership.prefix,
            i
        ];
    }));
    if (add) {
        let i = membership.indexOf(letter);
        if (i < 0) {
            membership += letter;
            membership = Array.from(membership).sort((a, b)=>{
                return prefixPrivs.get(a) - prefixPrivs.get(b);
            }).join("");
        }
    } else membership = membership.replace(letter, "");
    return membership;
}
/* Insert a message in an immutable list of sorted messages. */ function $fca64bf918d5638f$var$insertMessage(list, msg) {
    if (list.length == 0) return [
        msg
    ];
    else if (!$bd3c59ab25aed5ca$export$f4751a564f6d84a3(msg, "chathistory") || list[list.length - 1].tags.time <= msg.tags.time) return list.concat(msg);
    let insertBefore = -1;
    for(let i = 0; i < list.length; i++){
        let other = list[i];
        if (msg.tags.time < other.tags.time) {
            insertBefore = i;
            break;
        }
    }
    console.assert(insertBefore >= 0, "");
    list = [
        ...list
    ];
    list.splice(insertBefore, 0, msg);
    return list;
}
let $fca64bf918d5638f$var$lastServerID = 0;
let $fca64bf918d5638f$var$lastBufferID = 0;
let $fca64bf918d5638f$var$lastMessageKey = 0;
const $fca64bf918d5638f$export$7254cc27399e90bd = {
    create () {
        return {
            servers: new Map(),
            buffers: new Map(),
            activeBuffer: null,
            bouncerNetworks: new Map(),
            settings: {
                secondsInTimestamps: true,
                bufferEvents: $fca64bf918d5638f$export$3ee12e3d13dfa897.FOLD
            }
        };
    },
    updateServer (state, id, updater) {
        let server = state.servers.get(id);
        if (!server) return;
        let updated = $fca64bf918d5638f$var$updateState(server, updater);
        if (!updated) return;
        let servers = new Map(state.servers);
        servers.set(id, updated);
        return {
            servers: servers
        };
    },
    updateBuffer (state, id, updater) {
        let buf = $fca64bf918d5638f$export$7254cc27399e90bd.getBuffer(state, id);
        if (!buf) return;
        let updated = $fca64bf918d5638f$var$updateState(buf, updater);
        if (!updated) return;
        let buffers = new Map(state.buffers);
        buffers.set(buf.id, updated);
        return {
            buffers: buffers
        };
    },
    getActiveServerID (state) {
        let buf = state.buffers.get(state.activeBuffer);
        if (!buf) return null;
        return buf.server;
    },
    getBuffer (state, id) {
        switch(typeof id){
            case "number":
                return state.buffers.get(id);
            case "object":
                if (id.id) return state.buffers.get(id.id);
                let serverID = id.server, name = id.name;
                if (!serverID) serverID = $fca64bf918d5638f$export$7254cc27399e90bd.getActiveServerID(state);
                if (!name) name = $fca64bf918d5638f$export$50f2960994553271;
                let cm = $bd3c59ab25aed5ca$export$39aea81548242927.RFC1459;
                let server = state.servers.get(serverID);
                if (server) cm = server.cm;
                let nameCM = cm(name);
                for (let buf of state.buffers.values()){
                    if (buf.server === serverID && cm(buf.name) === nameCM) return buf;
                }
                return null;
            default:
                throw new Error("Invalid buffer ID type: " + typeof id);
        }
    },
    createServer (state) {
        $fca64bf918d5638f$var$lastServerID++;
        let id = $fca64bf918d5638f$var$lastServerID;
        let servers = new Map(state.servers);
        servers.set(id, {
            id: id,
            name: null,
            status: $fca64bf918d5638f$export$ac0b13ba2bbce4d5.DISCONNECTED,
            cm: $bd3c59ab25aed5ca$export$39aea81548242927.RFC1459,
            users: new $bd3c59ab25aed5ca$export$6296a711f00288b1(null, $bd3c59ab25aed5ca$export$39aea81548242927.RFC1459),
            account: null,
            supportsSASLPlain: false,
            supportsAccountRegistration: false,
            reliableUserAccounts: false,
            statusMsg: null,
            isBouncer: false,
            bouncerNetID: null
        });
        return [
            id,
            {
                servers: servers
            }
        ];
    },
    createBuffer (state, name, serverID, client) {
        let buf = $fca64bf918d5638f$export$7254cc27399e90bd.getBuffer(state, {
            server: serverID,
            name: name
        });
        if (buf) return [
            buf.id,
            null
        ];
        $fca64bf918d5638f$var$lastBufferID++;
        let id = $fca64bf918d5638f$var$lastBufferID;
        let type;
        if (name == $fca64bf918d5638f$export$50f2960994553271) type = $fca64bf918d5638f$export$a9b603917c4d9863.SERVER;
        else if (client.isChannel(name)) type = $fca64bf918d5638f$export$a9b603917c4d9863.CHANNEL;
        else type = $fca64bf918d5638f$export$a9b603917c4d9863.NICK;
        let bufferList = Array.from(state.buffers.values());
        bufferList.push({
            id: id,
            name: name,
            type: type,
            server: serverID,
            serverInfo: null,
            joined: false,
            topic: null,
            hasInitialWho: false,
            members: new $bd3c59ab25aed5ca$export$6296a711f00288b1(null, client.cm),
            messages: [],
            unread: $fca64bf918d5638f$export$9be0a2424da959ae.NONE,
            prevReadReceipt: null
        });
        bufferList = bufferList.sort($fca64bf918d5638f$var$compareBuffers);
        let buffers = new Map(bufferList.map((buf)=>[
                buf.id,
                buf
            ]));
        return [
            id,
            {
                buffers: buffers
            }
        ];
    },
    storeBouncerNetwork (state, id, attrs) {
        let bouncerNetworks = new Map(state.bouncerNetworks);
        bouncerNetworks.set(id, {
            ...bouncerNetworks.get(id),
            ...attrs
        });
        return {
            bouncerNetworks: bouncerNetworks
        };
    },
    deleteBouncerNetwork (state, id) {
        let bouncerNetworks = new Map(state.bouncerNetworks);
        bouncerNetworks.delete(id);
        return {
            bouncerNetworks: bouncerNetworks
        };
    },
    handleMessage (state, msg, serverID, client) {
        function updateServer(updater) {
            return $fca64bf918d5638f$export$7254cc27399e90bd.updateServer(state, serverID, updater);
        }
        function updateBuffer(name, updater) {
            return $fca64bf918d5638f$export$7254cc27399e90bd.updateBuffer(state, {
                server: serverID,
                name: name
            }, updater);
        }
        function updateUser(name, updater) {
            return updateServer((server)=>{
                let users = new $bd3c59ab25aed5ca$export$6296a711f00288b1(server.users);
                let updated = $fca64bf918d5638f$var$updateState(users.get(name), updater);
                if (!updated) return;
                users.set(name, updated);
                return {
                    users: users
                };
            });
        }
        // Don't update our internal state if it's a chat history message
        if ($bd3c59ab25aed5ca$export$f4751a564f6d84a3(msg, "chathistory")) return;
        let target, channel, topic, targets, who, update, buffers;
        switch(msg.command){
            case $bd3c59ab25aed5ca$export$31b0bce566d09826:
                // TODO: parse available modes
                let serverInfo = {
                    name: msg.params[1],
                    version: msg.params[2]
                };
                return updateBuffer($fca64bf918d5638f$export$50f2960994553271, {
                    serverInfo: serverInfo
                });
            case $bd3c59ab25aed5ca$export$1d0c7ae9b6b17819:
                buffers = new Map(state.buffers);
                state.buffers.forEach((buf)=>{
                    if (buf.server != serverID) return;
                    let members = new $bd3c59ab25aed5ca$export$6296a711f00288b1(buf.members, client.cm);
                    buffers.set(buf.id, {
                        ...buf,
                        members: members
                    });
                });
                return {
                    buffers: buffers,
                    ...updateServer((server)=>{
                        return {
                            name: client.isupport.network(),
                            cm: client.cm,
                            users: new $bd3c59ab25aed5ca$export$6296a711f00288b1(server.users, client.cm),
                            reliableUserAccounts: client.isupport.monitor() > 0 && client.isupport.whox(),
                            statusMsg: client.isupport.statusMsg(),
                            bouncerNetID: client.isupport.bouncerNetID()
                        };
                    })
                };
            case "CAP":
                return updateServer({
                    supportsSASLPlain: client.supportsSASL("PLAIN"),
                    supportsAccountRegistration: client.caps.enabled.has("draft/account-registration"),
                    isBouncer: client.caps.enabled.has("soju.im/bouncer-networks")
                });
            case $bd3c59ab25aed5ca$export$97b01f8c0b76e599:
                return updateServer({
                    account: msg.params[2]
                });
            case $bd3c59ab25aed5ca$export$3ae55a67359785dc:
                return updateServer({
                    account: null
                });
            case "REGISTER":
            case "VERIFY":
                if (msg.params[0] === "SUCCESS") return updateServer({
                    account: msg.params[1]
                });
                break;
            case $bd3c59ab25aed5ca$export$a675057415015158:
                channel = msg.params[1];
                return updateBuffer(channel, {
                    topic: null
                });
            case $bd3c59ab25aed5ca$export$c233ee342453910:
                channel = msg.params[1];
                topic = msg.params[2];
                return updateBuffer(channel, {
                    topic: topic
                });
            case $bd3c59ab25aed5ca$export$b1fa6c92095fdab1:
                break;
            case $bd3c59ab25aed5ca$export$698923df90b7ea6d:
                channel = msg.params[1];
                return updateBuffer(channel, (buf)=>{
                    let members = new $bd3c59ab25aed5ca$export$6296a711f00288b1(null, buf.members.caseMap);
                    msg.list.forEach((namreply)=>{
                        let membersList = namreply.params[3].split(" ");
                        membersList.forEach((s)=>{
                            let member = $bd3c59ab25aed5ca$export$4812b7165edd26af(s);
                            members.set(member.name, member.prefix);
                        });
                    });
                    return {
                        members: members
                    };
                });
            case $bd3c59ab25aed5ca$export$1ea987b9a16ea266:
                target = msg.params[1];
                if (msg.list.length == 0 && !client.isChannel(target) && target.indexOf("*") < 0) // Not a channel nor a mask, likely a nick
                return updateUser(target, (user)=>{
                    return {
                        offline: true
                    };
                });
                else return updateServer((server)=>{
                    let users = new $bd3c59ab25aed5ca$export$6296a711f00288b1(server.users);
                    for (let reply of msg.list){
                        let who = client.parseWhoReply(reply);
                        if (who.flags !== undefined) {
                            who.away = who.flags.indexOf("G") >= 0; // H for here, G for gone
                            who.operator = who.flags.indexOf("*") >= 0;
                            let botFlag = client.isupport.bot();
                            if (botFlag) who.bot = who.flags.indexOf(botFlag) >= 0;
                            delete who.flags;
                        }
                        who.offline = false;
                        users.set(who.nick, who);
                    }
                    return {
                        users: users
                    };
                });
                break;
            case "JOIN":
                channel = msg.params[0];
                if (client.isMyNick(msg.prefix.name)) {
                    let [id, update] = $fca64bf918d5638f$export$7254cc27399e90bd.createBuffer(state, channel, serverID, client);
                    state = {
                        ...state,
                        ...update
                    };
                }
                update = updateBuffer(channel, (buf)=>{
                    let members = new $bd3c59ab25aed5ca$export$6296a711f00288b1(buf.members);
                    members.set(msg.prefix.name, "");
                    let joined = buf.joined || client.isMyNick(msg.prefix.name);
                    return {
                        members: members,
                        joined: joined
                    };
                });
                state = {
                    ...state,
                    ...update
                };
                who = {
                    nick: msg.prefix.name,
                    offline: false
                };
                if (msg.prefix.user) who.username = msg.prefix.user;
                if (msg.prefix.host) who.hostname = msg.prefix.host;
                if (msg.params.length > 2) {
                    who.account = msg.params[1];
                    if (who.account === "*") who.account = null;
                    who.realname = msg.params[2];
                }
                update = updateUser(msg.prefix.name, who);
                state = {
                    ...state,
                    ...update
                };
                return state;
            case "PART":
                channel = msg.params[0];
                return updateBuffer(channel, (buf)=>{
                    let members = new $bd3c59ab25aed5ca$export$6296a711f00288b1(buf.members);
                    members.delete(msg.prefix.name);
                    let joined = buf.joined && !client.isMyNick(msg.prefix.name);
                    return {
                        members: members,
                        joined: joined
                    };
                });
            case "KICK":
                channel = msg.params[0];
                let nick = msg.params[1];
                return updateBuffer(channel, (buf)=>{
                    let members = new $bd3c59ab25aed5ca$export$6296a711f00288b1(buf.members);
                    members.delete(nick);
                    let joined = buf.joined && !client.isMyNick(nick);
                    return {
                        members: members,
                        joined: joined
                    };
                });
            case "QUIT":
                buffers = new Map(state.buffers);
                state.buffers.forEach((buf)=>{
                    if (buf.server != serverID) return;
                    if (!buf.members.has(msg.prefix.name)) return;
                    let members = new $bd3c59ab25aed5ca$export$6296a711f00288b1(buf.members);
                    members.delete(msg.prefix.name);
                    buffers.set(buf.id, {
                        ...buf,
                        members: members
                    });
                });
                state = {
                    ...state,
                    buffers: buffers
                };
                update = updateUser(msg.prefix.name, (user)=>{
                    if (!user) return;
                    return {
                        offline: true
                    };
                });
                state = {
                    ...state,
                    ...update
                };
                return state;
            case "NICK":
                let newNick = msg.params[0];
                buffers = new Map(state.buffers);
                state.buffers.forEach((buf)=>{
                    if (buf.server != serverID) return;
                    if (!buf.members.has(msg.prefix.name)) return;
                    let members = new $bd3c59ab25aed5ca$export$6296a711f00288b1(buf.members);
                    members.set(newNick, members.get(msg.prefix.name));
                    members.delete(msg.prefix.name);
                    buffers.set(buf.id, {
                        ...buf,
                        members: members
                    });
                });
                state = {
                    ...state,
                    buffers: buffers
                };
                update = updateServer((server)=>{
                    let users = new $bd3c59ab25aed5ca$export$6296a711f00288b1(server.users);
                    let user = users.get(msg.prefix.name);
                    if (!user) return;
                    users.set(newNick, user);
                    users.delete(msg.prefix.name);
                    return {
                        users: users
                    };
                });
                state = {
                    ...state,
                    ...update
                };
                return state;
            case "SETNAME":
                return updateUser(msg.prefix.name, {
                    realname: msg.params[0]
                });
            case "CHGHOST":
                return updateUser(msg.prefix.name, {
                    username: msg.params[0],
                    hostname: msg.params[1]
                });
            case "ACCOUNT":
                let account = msg.params[0];
                if (account === "*") account = null;
                return updateUser(msg.prefix.name, {
                    account: account
                });
            case "AWAY":
                let awayMessage = msg.params[0];
                return updateUser(msg.prefix.name, {
                    away: !!awayMessage
                });
            case "TOPIC":
                channel = msg.params[0];
                topic = msg.params[1];
                return updateBuffer(channel, {
                    topic: topic
                });
            case "MODE":
                target = msg.params[0];
                if (!client.isChannel(target)) return; // TODO: handle user mode changes too
                let prefix = client.isupport.prefix();
                let prefixByMode = new Map($bd3c59ab25aed5ca$export$3b27c9ff97cdb350(prefix).map((membership)=>{
                    return [
                        membership.mode,
                        membership.prefix
                    ];
                }));
                return updateBuffer(target, (buf)=>{
                    let members = new $bd3c59ab25aed5ca$export$6296a711f00288b1(buf.members);
                    $bd3c59ab25aed5ca$export$6115b92b9c2241a7(msg, client.isupport, (mode, add, arg)=>{
                        if (prefixByMode.has(mode)) {
                            let nick = arg;
                            let membership = members.get(nick);
                            let letter = prefixByMode.get(mode);
                            members.set(nick, $fca64bf918d5638f$var$updateMembership(membership, letter, add, client));
                        }
                    });
                    return {
                        members: members
                    };
                });
            case $bd3c59ab25aed5ca$export$b3c89fff1b2cdce3:
            case $bd3c59ab25aed5ca$export$69132af27147d725:
                targets = msg.params[1].split(",");
                for (let target of targets){
                    let prefix = $bd3c59ab25aed5ca$export$3059e96a5fe807c3(target);
                    let update = updateUser(prefix.name, {
                        offline: msg.command == $bd3c59ab25aed5ca$export$69132af27147d725
                    });
                    state = {
                        ...state,
                        ...update
                    };
                }
                return state;
        }
    },
    addMessage (state, msg, bufID) {
        $fca64bf918d5638f$var$lastMessageKey++;
        msg.key = $fca64bf918d5638f$var$lastMessageKey;
        return $fca64bf918d5638f$export$7254cc27399e90bd.updateBuffer(state, bufID, (buf)=>{
            let messages = $fca64bf918d5638f$var$insertMessage(buf.messages, msg);
            return {
                messages: messages
            };
        });
    }
};



const $740325ae3fd2006f$var$PREFIX = "gamja_";
class $740325ae3fd2006f$var$Item {
    constructor(k){
        this.k = $740325ae3fd2006f$var$PREFIX + k;
    }
    load() {
        let v = localStorage.getItem(this.k);
        if (!v) return null;
        return JSON.parse(v);
    }
    put(v) {
        if (v) localStorage.setItem(this.k, JSON.stringify(v));
        else localStorage.removeItem(this.k);
    }
}
const $740325ae3fd2006f$export$3b637ec8b5dd5146 = new $740325ae3fd2006f$var$Item("autoconnect");
const $740325ae3fd2006f$export$a9ec709c82e011a4 = new $740325ae3fd2006f$var$Item("naggedProtocolHandler");
const $740325ae3fd2006f$export$a5a6e0b888b2c992 = new $740325ae3fd2006f$var$Item("settings");
function $740325ae3fd2006f$var$debounce(f, delay) {
    let timeout = null;
    return (...args)=>{
        clearTimeout(timeout);
        timeout = setTimeout(()=>{
            timeout = null;
            f(...args);
        }, delay);
    };
}
class $740325ae3fd2006f$export$a143d493d941bafc {
    raw = new $740325ae3fd2006f$var$Item("buffers");
    m = null;
    constructor(){
        let obj = this.raw.load();
        this.m = new Map(Object.entries(obj || {}));
        let saveImmediately = this.save.bind(this);
        this.save = $740325ae3fd2006f$var$debounce(saveImmediately, 500);
        document.addEventListener("visibilitychange", ()=>{
            if (document.visibilityState === "hidden") saveImmediately();
        });
    }
    key(buf) {
        // TODO: use case-mapping here somehow
        return JSON.stringify({
            name: buf.name.toLowerCase(),
            server: {
                bouncerNetwork: buf.server.bouncerNetwork
            }
        });
    }
    save() {
        if (this.m.size > 0) this.raw.put(Object.fromEntries(this.m));
        else this.raw.put(null);
    }
    get(buf) {
        return this.m.get(this.key(buf));
    }
    put(buf) {
        let key = this.key(buf);
        let updated = !this.m.has(key);
        let prev = this.m.get(key) || {};
        let unread = prev.unread || (0, $fca64bf918d5638f$export$9be0a2424da959ae).NONE;
        if (buf.unread !== undefined && buf.unread !== prev.unread) {
            unread = buf.unread;
            updated = true;
        }
        let receipts = {
            ...prev.receipts
        };
        if (buf.receipts) {
            Object.keys(buf.receipts).forEach((k)=>{
                // Use a not-equals comparison here so that no-op receipt
                // changes are correctly handled
                if (!receipts[k] || receipts[k].time < buf.receipts[k].time) {
                    receipts[k] = buf.receipts[k];
                    updated = true;
                }
            });
            if (receipts[(0, $fca64bf918d5638f$export$c49c54eaac29b59a).DELIVERED] < receipts[(0, $fca64bf918d5638f$export$c49c54eaac29b59a).READ]) {
                receipts[(0, $fca64bf918d5638f$export$c49c54eaac29b59a).DELIVERED] = receipts[(0, $fca64bf918d5638f$export$c49c54eaac29b59a).READ];
                updated = true;
            }
        }
        let closed = prev.closed || false;
        if (buf.closed !== undefined && buf.closed !== prev.closed) {
            closed = buf.closed;
            updated = true;
        }
        if (!updated) return false;
        this.m.set(this.key(buf), {
            name: buf.name,
            unread: unread,
            receipts: receipts,
            closed: closed,
            server: {
                bouncerNetwork: buf.server.bouncerNetwork
            }
        });
        this.save();
        return true;
    }
    delete(buf) {
        this.m.delete(this.key(buf));
        this.save();
    }
    list(server) {
        // Some gamja versions would store the same buffer multiple times
        let names = new Set();
        let buffers = [];
        for (const buf of this.m.values()){
            if (buf.server.bouncerNetwork !== server.bouncerNetwork) continue;
            if (names.has(buf.name)) continue;
            buffers.push(buf);
            names.add(buf.name);
        }
        return buffers;
    }
    clear(server) {
        if (server) for (const buf of this.list(server))this.m.delete(this.key(buf));
        else this.m = new Map();
        this.save();
    }
}



// XXX: If we were feeling creative we could generate unique colors for
// each item in ISUPPORT CHANMODES. But I am not feeling creative.
const $0bbd5f20273017a0$var$names = {
    "~": "owner",
    "&": "admin",
    "@": "op",
    "%": "halfop",
    "+": "voice"
};
function $0bbd5f20273017a0$export$2e2bcd8739ae039(props) {
    if (!this.props.value) return null;
    const name = $0bbd5f20273017a0$var$names[this.props.value[0]] || "";
    return (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
		<span class="membership ${name}" title=${name}>
			${this.props.value}
		</span>
	`;
}


function $47db4ea8a56fc107$var$djb2(s) {
    let hash = 5381;
    for(let i = 0; i < s.length; i++){
        hash = (hash << 5) + hash + s.charCodeAt(i);
        hash = hash >>> 0; // convert to uint32
    }
    return hash;
}
function $47db4ea8a56fc107$var$Nick(props) {
    function handleClick(event) {
        event.preventDefault();
        props.onClick();
    }
    let title;
    if (props.user && $bd3c59ab25aed5ca$export$64ec8def5466157c(props.user.realname, props.nick)) title = (0, $803ef401580605c5$export$6a0f863afc2134d8)(props.user.realname);
    let colorIndex = $47db4ea8a56fc107$var$djb2(props.nick) % 16 + 1;
    return (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
		<a
			href=${$bd3c59ab25aed5ca$export$b1ef46223b559f9d({
        entity: props.nick
    })}
			title=${title}
			class="nick nick-${colorIndex}"
			onClick=${handleClick}
		>${props.nick}</a>
	`;
}
function $47db4ea8a56fc107$var$_Timestamp({ date: date, url: url, showSeconds: showSeconds }) {
    if (!date) {
        let timestamp = "--:--";
        if (showSeconds) timestamp += ":--";
        return (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`<spam class="timestamp">${timestamp}</span>`;
    }
    let hh = date.getHours().toString().padStart(2, "0");
    let mm = date.getMinutes().toString().padStart(2, "0");
    let timestamp = `${hh}:${mm}`;
    if (showSeconds) {
        let ss = date.getSeconds().toString().padStart(2, "0");
        timestamp += ":" + ss;
    }
    return (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
		<a
			href=${url}
			class="timestamp"
			title=${date.toLocaleString()}
			onClick=${(event)=>event.preventDefault()}
		>
			${timestamp}
		</a>
	`;
}
function $47db4ea8a56fc107$var$Timestamp(props) {
    return (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
		<${(0, $fca64bf918d5638f$export$8fa45c82eddfe270).Consumer}>
			${(settings)=>(0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
				<${$47db4ea8a56fc107$var$_Timestamp} ...${props} showSeconds=${settings.secondsInTimestamps}/>
			`}
		</>
	`;
}
/**
 * Check whether a message can be folded.
 *
 * Unimportant and noisy messages that may clutter the discussion should be
 * folded.
 */ function $47db4ea8a56fc107$var$canFoldMessage(msg) {
    switch(msg.command){
        case "JOIN":
        case "PART":
        case "QUIT":
        case "NICK":
            return true;
    }
    return false;
}
class $47db4ea8a56fc107$var$LogLine extends (0, $b2a774aae58c7b4e$export$16fa2f45be04daa8) {
    shouldComponentUpdate(nextProps) {
        return this.props.message !== nextProps.message;
    }
    render() {
        let msg = this.props.message;
        let buf = this.props.buffer;
        let server = this.props.server;
        let onNickClick = this.props.onNickClick;
        let onChannelClick = this.props.onChannelClick;
        let onVerifyClick = this.props.onVerifyClick;
        function createNick(nick) {
            return (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
				<${$47db4ea8a56fc107$var$Nick}
					nick=${nick}
					user=${server.users.get(nick)}
					onClick=${()=>onNickClick(nick)}
				/>
			`;
        }
        function createChannel(channel) {
            return (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
				<a href=${$bd3c59ab25aed5ca$export$b1ef46223b559f9d({
                entity: channel
            })} onClick=${onChannelClick}>
					${channel}
				</a>
			`;
        }
        let lineClass = "";
        let content;
        let invitee, target, account;
        switch(msg.command){
            case "NOTICE":
            case "PRIVMSG":
                target = msg.params[0];
                let text = msg.params[1];
                let ctcp = $bd3c59ab25aed5ca$export$60937d95e568734f(msg);
                if (ctcp) {
                    if (ctcp.command == "ACTION") {
                        lineClass = "me-tell";
                        content = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`* ${createNick(msg.prefix.name)} ${(0, $37d24d778c2f247c$export$2e2bcd8739ae039)((0, $803ef401580605c5$export$6a0f863afc2134d8)(ctcp.param), onChannelClick)}`;
                    } else content = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
						${createNick(msg.prefix.name)} has sent a CTCP command: ${ctcp.command} ${ctcp.param}
					`;
                } else {
                    lineClass = "talk";
                    let prefix = "<", suffix = ">";
                    if (msg.command == "NOTICE") prefix = suffix = "-";
                    content = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`${prefix}${createNick(msg.prefix.name)}${suffix} ${(0, $37d24d778c2f247c$export$2e2bcd8739ae039)((0, $803ef401580605c5$export$6a0f863afc2134d8)(text), onChannelClick)}`;
                }
                let status = null;
                let allowedPrefixes = server.statusMsg;
                if (target !== buf.name && allowedPrefixes) {
                    let parts = $bd3c59ab25aed5ca$export$4812b7165edd26af(target, allowedPrefixes);
                    if (parts.name === buf.name) content = [
                        (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`(<${(0, $0bbd5f20273017a0$export$2e2bcd8739ae039)} value=${parts.prefix}/>)`,
                        " ",
                        content
                    ];
                }
                if (msg.tags["+draft/channel-context"]) content = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`<em>(only visible to you)</em> ${content}`;
                if (msg.isHighlight) lineClass += " highlight";
                break;
            case "JOIN":
                content = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
				${createNick(msg.prefix.name)} has joined
			`;
                break;
            case "PART":
                content = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
				${createNick(msg.prefix.name)} has left
			`;
                break;
            case "QUIT":
                content = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
				${createNick(msg.prefix.name)} has quit
			`;
                break;
            case "NICK":
                let newNick = msg.params[0];
                content = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
				${createNick(msg.prefix.name)} is now known as ${createNick(newNick)}
			`;
                break;
            case "KICK":
                content = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
				${createNick(msg.params[1])} was kicked by ${createNick(msg.prefix.name)} (${msg.params.slice(2)})
			`;
                break;
            case "MODE":
                target = msg.params[0];
                content = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
				* ${createNick(msg.prefix.name)} sets mode ${msg.params.slice(1).join(" ")}
			`;
                // TODO: case-mapping
                if (buf.name !== target) content = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`${content} on ${target}`;
                break;
            case "TOPIC":
                let topic = msg.params[1];
                content = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
				${createNick(msg.prefix.name)} changed the topic to: ${(0, $37d24d778c2f247c$export$2e2bcd8739ae039)((0, $803ef401580605c5$export$6a0f863afc2134d8)(topic), onChannelClick)}
			`;
                break;
            case "INVITE":
                invitee = msg.params[0];
                let channel = msg.params[1];
                // TODO: instead of checking buffer type, check if invitee is our nick
                if (buf.type === (0, $fca64bf918d5638f$export$a9b603917c4d9863).SERVER) {
                    lineClass = "talk";
                    content = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
					You have been invited to ${createChannel(channel)} by ${createNick(msg.prefix.name)}
				`;
                } else content = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
					${createNick(msg.prefix.name)} has invited ${createNick(invitee)} to the channel
				`;
                break;
            case $bd3c59ab25aed5ca$export$cac9ca3596de2b3a:
                let nick = msg.params[0];
                content = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`Connected to server, your nickname is ${nick}`;
                break;
            case $bd3c59ab25aed5ca$export$6bc24f4e6578b579:
                invitee = msg.params[1];
                content = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`${createNick(invitee)} has been invited to the channel`;
                break;
            case $bd3c59ab25aed5ca$export$3db4cc949c7e95b3:
                lineClass = "motd";
                content = (0, $37d24d778c2f247c$export$2e2bcd8739ae039)((0, $803ef401580605c5$export$6a0f863afc2134d8)(msg.params[1]), onChannelClick);
                break;
            case $bd3c59ab25aed5ca$export$97b01f8c0b76e599:
                account = msg.params[2];
                content = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`You are now authenticated as ${account}`;
                break;
            case $bd3c59ab25aed5ca$export$3ae55a67359785dc:
                content = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`You are now unauthenticated`;
                break;
            case "REGISTER":
                account = msg.params[1];
                let reason = msg.params[2];
                function handleVerifyClick(event) {
                    event.preventDefault();
                    onVerifyClick(account, reason);
                }
                switch(msg.params[0]){
                    case "SUCCESS":
                        content = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`A new account has been created, you are now authenticated as ${account}`;
                        break;
                    case "VERIFICATION_REQUIRED":
                        content = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`A new account has been created, but you need to <a href="#" onClick=${handleVerifyClick}>verify it</a>: ${(0, $37d24d778c2f247c$export$2e2bcd8739ae039)(reason)}`;
                        break;
                }
                break;
            case "VERIFY":
                account = msg.params[1];
                content = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`The new account has been verified, you are now authenticated as ${account}`;
                break;
            case $bd3c59ab25aed5ca$export$6184319b67962807:
                let mode = msg.params[1];
                if (mode) content = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`Your user mode is ${mode}`;
                else content = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`You have no user mode`;
                break;
            case $bd3c59ab25aed5ca$export$8e826dfe9edc5be1:
                content = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`Channel mode is ${msg.params.slice(2).join(" ")}`;
                break;
            case $bd3c59ab25aed5ca$export$110395ee82c419bd:
                let date = new Date(parseInt(msg.params[2], 10) * 1000);
                content = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`Channel was created on ${date.toLocaleString()}`;
                break;
            // MONITOR messages are only displayed in user buffers
            case $bd3c59ab25aed5ca$export$b3c89fff1b2cdce3:
                content = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`${createNick(buf.name)} is online`;
                break;
            case $bd3c59ab25aed5ca$export$69132af27147d725:
                content = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`${createNick(buf.name)} is offline`;
                break;
            default:
                if ($bd3c59ab25aed5ca$export$e6127cc7fe7395c3(msg.command) && msg.command != $bd3c59ab25aed5ca$export$7e8b5ab33a021d11) lineClass = "error";
                content = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`${msg.command} ${(0, $37d24d778c2f247c$export$2e2bcd8739ae039)(msg.params.join(" "))}`;
        }
        if (!content) return null;
        return (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
			<div class="logline ${lineClass}" data-key=${msg.key}>
				<${$47db4ea8a56fc107$var$Timestamp} date=${new Date(msg.tags.time)} url=${(0, $fca64bf918d5638f$export$8499bd1ed7c872c2)(buf, msg)}/>
				${" "}
				${content}
			</div>
		`;
    }
}
function $47db4ea8a56fc107$var$createNickList(nicks, createNick) {
    if (nicks.length === 0) return null;
    else if (nicks.length === 1) return createNick(nicks[0]);
    let l = nicks.slice(0, nicks.length - 1).map((nick, i)=>{
        if (i === 0) return createNick(nick);
        else return [
            ", ",
            createNick(nick)
        ];
    });
    l.push(" and ");
    l.push(createNick(nicks[nicks.length - 1]));
    return l;
}
class $47db4ea8a56fc107$var$FoldGroup extends (0, $b2a774aae58c7b4e$export$16fa2f45be04daa8) {
    shouldComponentUpdate(nextProps) {
        return this.props.messages[0] !== nextProps.messages[0] || this.props.messages[this.props.messages.length - 1] !== nextProps.messages[nextProps.messages.length - 1];
    }
    render() {
        let msgs = this.props.messages;
        let buf = this.props.buffer;
        let server = this.props.server;
        let onNickClick = this.props.onNickClick;
        function createNick(nick) {
            return (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
				<${$47db4ea8a56fc107$var$Nick}
					nick=${nick}
					user=${server.users.get(nick)}
					onClick=${()=>onNickClick(nick)}
				/>
			`;
        }
        let byCommand = {
            "JOIN": [],
            "PART": [],
            "QUIT": [],
            "NICK": []
        };
        msgs.forEach((msg)=>{
            byCommand[msg.command].push(msg);
        });
        let first = true;
        let content = [];
        [
            "JOIN",
            "PART",
            "QUIT"
        ].forEach((cmd)=>{
            if (byCommand[cmd].length === 0) return;
            let nicks = new Set(byCommand[cmd].map((msg)=>msg.prefix.name));
            let plural = nicks.size > 1;
            let action;
            switch(cmd){
                case "JOIN":
                    action = plural ? "have joined" : "has joined";
                    break;
                case "PART":
                    action = plural ? "have left" : "has left";
                    break;
                case "QUIT":
                    action = plural ? "have quit" : "has quit";
                    break;
            }
            if (first) first = false;
            else content.push(", ");
            content.push($47db4ea8a56fc107$var$createNickList([
                ...nicks
            ], createNick));
            content.push(" " + action);
        });
        byCommand["NICK"].forEach((msg)=>{
            if (first) first = false;
            else content.push(", ");
            let newNick = msg.params[0];
            content.push((0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
				${createNick(msg.prefix.name)} is now known as ${createNick(newNick)}
			`);
        });
        let lastMsg = msgs[msgs.length - 1];
        let firstDate = new Date(msgs[0].tags.time);
        let lastDate = new Date(lastMsg.tags.time);
        let timestamp = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
			<${$47db4ea8a56fc107$var$Timestamp} date=${firstDate} url=${(0, $fca64bf918d5638f$export$8499bd1ed7c872c2)(buf, msgs[0])}/>
		`;
        if (lastDate - firstDate > 6000) timestamp = [
            timestamp,
            " \u2014 ",
            (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
					<${$47db4ea8a56fc107$var$Timestamp} date=${lastDate} url=${(0, $fca64bf918d5638f$export$8499bd1ed7c872c2)(buf, lastMsg)}/>
				`
        ];
        return (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
			<div class="logline" data-key=${msgs[0].key}>
				${timestamp}
				${" "}
				${content}
			</div>
		`;
    }
}
// Workaround for https://bugs.chromium.org/p/chromium/issues/detail?id=481856
let $47db4ea8a56fc107$var$notificationsSupported = false;
if (window.Notification) {
    $47db4ea8a56fc107$var$notificationsSupported = true;
    if (Notification.permission === "default") try {
        new Notification("");
    } catch (err) {
        if (err.name === "TypeError") $47db4ea8a56fc107$var$notificationsSupported = false;
    }
}
class $47db4ea8a56fc107$var$NotificationNagger extends (0, $b2a774aae58c7b4e$export$16fa2f45be04daa8) {
    state = {
        nag: false
    };
    constructor(props){
        super(props);
        this.handleClick = this.handleClick.bind(this);
        this.state.nag = this.shouldNag();
    }
    shouldNag() {
        return $47db4ea8a56fc107$var$notificationsSupported && Notification.permission === "default";
    }
    handleClick(event) {
        event.preventDefault();
        Notification.requestPermission((permission)=>{
            this.setState({
                nag: this.shouldNag()
            });
        });
    }
    render() {
        if (!this.state.nag) return null;
        return (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
			<div class="logline">
				<${$47db4ea8a56fc107$var$Timestamp}/>
				${" "}
				<a href="#" onClick=${this.handleClick}>Turn on desktop notifications</a> to get notified about new messages
			</div>
		`;
    }
}
class $47db4ea8a56fc107$var$ProtocolHandlerNagger extends (0, $b2a774aae58c7b4e$export$16fa2f45be04daa8) {
    state = {
        nag: true
    };
    constructor(props){
        super(props);
        this.handleClick = this.handleClick.bind(this);
        this.state.nag = !$740325ae3fd2006f$export$a9ec709c82e011a4.load();
    }
    handleClick(event) {
        event.preventDefault();
        let url = window.location.origin + window.location.pathname + "?open=%s";
        try {
            navigator.registerProtocolHandler("irc", url);
            navigator.registerProtocolHandler("ircs", url);
        } catch (err) {
            console.error("Failed to register protocol handler: ", err);
        }
        $740325ae3fd2006f$export$a9ec709c82e011a4.put(true);
        this.setState({
            nag: false
        });
    }
    render() {
        if (!navigator.registerProtocolHandler || !this.state.nag) return null;
        let name = this.props.bouncerName || "this bouncer";
        return (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
			<div class="logline">
				<${$47db4ea8a56fc107$var$Timestamp}/>
				${" "}
				<a href="#" onClick=${this.handleClick}>Register our protocol handler</a> to open IRC links with ${name}
			</div>
		`;
    }
}
function $47db4ea8a56fc107$var$AccountNagger({ server: server, onAuthClick: onAuthClick, onRegisterClick: onRegisterClick }) {
    let accDesc = "an account on this server";
    if (server.name) accDesc = "a " + server.name + " account";
    function handleAuthClick(event) {
        event.preventDefault();
        onAuthClick();
    }
    function handleRegisterClick(event) {
        event.preventDefault();
        onRegisterClick();
    }
    let msg = [
        (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
		You are unauthenticated on this server,
		${" "}
		<a href="#" onClick=${handleAuthClick}>login</a>
		${" "}
	`
    ];
    if (server.supportsAccountRegistration) msg.push((0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`or <a href="#" onClick=${handleRegisterClick}>register</a> ${accDesc}`);
    else msg.push((0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`if you have ${accDesc}`);
    return (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
		<div class="logline">
			<${$47db4ea8a56fc107$var$Timestamp}/> ${msg}
		</div>
	`;
}
class $47db4ea8a56fc107$var$DateSeparator extends (0, $b2a774aae58c7b4e$export$16fa2f45be04daa8) {
    constructor(props){
        super(props);
    }
    shouldComponentUpdate(nextProps) {
        return this.props.date.getTime() !== nextProps.date.getTime();
    }
    render() {
        let date = this.props.date;
        let text = date.toLocaleDateString([], {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
        });
        return (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
			<div class="separator date-separator">
				${text}
			</div>
		`;
    }
}
function $47db4ea8a56fc107$var$UnreadSeparator(props) {
    return (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`<div class="separator unread-separator">New messages</div>`;
}
function $47db4ea8a56fc107$var$sameDate(d1, d2) {
    return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
}
class $47db4ea8a56fc107$export$2e2bcd8739ae039 extends (0, $b2a774aae58c7b4e$export$16fa2f45be04daa8) {
    shouldComponentUpdate(nextProps) {
        return this.props.buffer !== nextProps.buffer || this.props.settings !== nextProps.settings;
    }
    render() {
        let buf = this.props.buffer;
        if (!buf) return null;
        let server = this.props.server;
        let bouncerNetwork = this.props.bouncerNetwork;
        let settings = this.props.settings;
        let serverName = server.name;
        let children = [];
        if (buf.type == (0, $fca64bf918d5638f$export$a9b603917c4d9863).SERVER) children.push((0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`<${$47db4ea8a56fc107$var$NotificationNagger}/>`);
        if (buf.type == (0, $fca64bf918d5638f$export$a9b603917c4d9863).SERVER && server.isBouncer && !server.bouncerNetID) children.push((0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`<${$47db4ea8a56fc107$var$ProtocolHandlerNagger} bouncerName=${serverName}/>`);
        if (buf.type == (0, $fca64bf918d5638f$export$a9b603917c4d9863).SERVER && server.status == (0, $fca64bf918d5638f$export$ac0b13ba2bbce4d5).REGISTERED && server.supportsSASLPlain && !server.account) children.push((0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
				<${$47db4ea8a56fc107$var$AccountNagger}
					server=${server}
					onAuthClick=${this.props.onAuthClick}
					onRegisterClick=${this.props.onRegisterClick}
				/>
			`);
        let onChannelClick = this.props.onChannelClick;
        let onNickClick = this.props.onNickClick;
        let onVerifyClick = this.props.onVerifyClick;
        function createLogLine(msg) {
            return (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
				<${$47db4ea8a56fc107$var$LogLine}
					key=${"msg-" + msg.key}
					message=${msg}
					buffer=${buf}
					server=${server}
					onChannelClick=${onChannelClick}
					onNickClick=${onNickClick}
					onVerifyClick=${onVerifyClick}
				/>
			`;
        }
        function createFoldGroup(msgs) {
            // Merge NICK change chains
            let nickChanges = new Map();
            let mergedMsgs = [];
            for (let msg of msgs){
                let keep = true;
                switch(msg.command){
                    case "PART":
                    case "QUIT":
                        nickChanges.delete(msg.prefix.name);
                        break;
                    case "NICK":
                        let prev = nickChanges.get(msg.prefix.name);
                        if (!prev) {
                            // Future NICK messages may mutate this one
                            msg = {
                                ...msg
                            };
                            nickChanges.set(msg.params[0], msg);
                            break;
                        }
                        prev.params = msg.params;
                        nickChanges.delete(msg.prefix.name);
                        nickChanges.set(msg.params[0], prev);
                        keep = false;
                        break;
                }
                if (keep) mergedMsgs.push(msg);
            }
            msgs = mergedMsgs;
            // Filter out PART → JOIN pairs, as well as no-op NICKs from previous step
            let partIndexes = new Map();
            let keep = [];
            msgs.forEach((msg, i)=>{
                if (msg.command === "PART" || msg.command === "QUIT") partIndexes.set(msg.prefix.name, i);
                if (msg.command === "JOIN" && partIndexes.has(msg.prefix.name)) {
                    keep[partIndexes.get(msg.prefix.name)] = false;
                    partIndexes.delete(msg.prefix.name);
                    keep.push(false);
                } else if (msg.command === "NICK" && msg.prefix.name == msg.params[0]) keep.push(false);
                else keep.push(true);
            });
            msgs = msgs.filter((msg, i)=>keep[i]);
            if (msgs.length === 0) return null;
            else if (msgs.length === 1) return createLogLine(msgs[0]);
            return (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
				<${$47db4ea8a56fc107$var$FoldGroup}
					key=${"fold-" + msgs[0].key + "-" + msgs[msgs.length - 1].key}
					messages=${msgs}
					buffer=${buf}
					server=${server}
					onNickClick=${onNickClick}
				/>
			`;
        }
        let hasUnreadSeparator = false;
        let prevDate = new Date();
        let foldMessages = [];
        let lastMonitor = null;
        buf.messages.forEach((msg)=>{
            let sep = [];
            if (settings.bufferEvents === (0, $fca64bf918d5638f$export$3ee12e3d13dfa897).HIDE && $47db4ea8a56fc107$var$canFoldMessage(msg)) return;
            if (msg.command === $bd3c59ab25aed5ca$export$b3c89fff1b2cdce3 || msg.command === $bd3c59ab25aed5ca$export$69132af27147d725) {
                let skip = !lastMonitor || msg.command === lastMonitor;
                lastMonitor = msg.command;
                if (skip) return;
            }
            if (!hasUnreadSeparator && buf.type != (0, $fca64bf918d5638f$export$a9b603917c4d9863).SERVER && !(0, $fca64bf918d5638f$export$23261bae4c963bb3)(msg, buf.prevReadReceipt)) {
                sep.push((0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`<${$47db4ea8a56fc107$var$UnreadSeparator} key="unread"/>`);
                hasUnreadSeparator = true;
            }
            let date = new Date(msg.tags.time);
            if (!$47db4ea8a56fc107$var$sameDate(prevDate, date)) sep.push((0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`<${$47db4ea8a56fc107$var$DateSeparator} key=${"date-" + date} date=${date}/>`);
            prevDate = date;
            if (sep.length > 0) {
                children.push(createFoldGroup(foldMessages));
                children.push(sep);
                foldMessages = [];
            }
            // TODO: consider checking the time difference too
            if (settings.bufferEvents === (0, $fca64bf918d5638f$export$3ee12e3d13dfa897).FOLD && $47db4ea8a56fc107$var$canFoldMessage(msg)) {
                foldMessages.push(msg);
                return;
            }
            if (foldMessages.length > 0) {
                children.push(createFoldGroup(foldMessages));
                foldMessages = [];
            }
            children.push(createLogLine(msg));
        });
        children.push(createFoldGroup(foldMessages));
        return (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
			<div class="logline-list">
				${children}
			</div>
		`;
    }
}






function $cd5f528e18548e6d$var$BufferItem(props) {
    function handleClick(event) {
        event.preventDefault();
        props.onClick();
    }
    function handleMouseDown(event) {
        if (event.button === 1) {
            event.preventDefault();
            props.onClose();
        }
    }
    let name = props.buffer.name;
    if (props.buffer.type == (0, $fca64bf918d5638f$export$a9b603917c4d9863).SERVER) name = (0, $fca64bf918d5638f$export$53e73e095c2ac1e2)(props.server, props.bouncerNetwork);
    let title;
    let classes = [
        "type-" + props.buffer.type
    ];
    if (props.active) classes.push("active");
    if (props.buffer.unread != (0, $fca64bf918d5638f$export$9be0a2424da959ae).NONE) classes.push("unread-" + props.buffer.unread);
    switch(props.buffer.type){
        case (0, $fca64bf918d5638f$export$a9b603917c4d9863).SERVER:
            let isError = props.server.status === (0, $fca64bf918d5638f$export$ac0b13ba2bbce4d5).DISCONNECTED;
            if (props.bouncerNetwork && props.bouncerNetwork.error) isError = true;
            if (isError) classes.push("error");
            break;
        case (0, $fca64bf918d5638f$export$a9b603917c4d9863).NICK:
            let user = props.server.users.get(name);
            if (user && $bd3c59ab25aed5ca$export$64ec8def5466157c(user.realname, name)) title = (0, $803ef401580605c5$export$6a0f863afc2134d8)(user.realname);
            break;
    }
    return (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
		<li class="${classes.join(" ")}">
			<a
				href=${(0, $fca64bf918d5638f$export$64b0f097aebd4e10)(props.buffer)}
				title=${title}
				onClick=${handleClick}
				onMouseDown=${handleMouseDown}
			>${name}</a>
		</li>
	`;
}
function $cd5f528e18548e6d$export$2e2bcd8739ae039(props) {
    let items = Array.from(props.buffers.values()).map((buf)=>{
        let server = props.servers.get(buf.server);
        let bouncerNetwork = null;
        if (server.bouncerNetID) bouncerNetwork = props.bouncerNetworks.get(server.bouncerNetID);
        return (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
			<${$cd5f528e18548e6d$var$BufferItem}
				key=${buf.id}
				buffer=${buf}
				server=${server}
				bouncerNetwork=${bouncerNetwork}
				onClick=${()=>props.onBufferClick(buf)}
				onClose=${()=>props.onBufferClose(buf)}
				active=${props.activeBuffer == buf.id}
			/>
		`;
    });
    return (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`<ul>${items}</ul>`;
}







const $94cb31469f63b35c$var$UserStatus = {
    HERE: "here",
    GONE: "gone",
    OFFLINE: "offline"
};
function $94cb31469f63b35c$var$NickStatus(props) {
    let textMap = {
        [$94cb31469f63b35c$var$UserStatus.HERE]: "User is online",
        [$94cb31469f63b35c$var$UserStatus.GONE]: "User is away",
        [$94cb31469f63b35c$var$UserStatus.OFFLINE]: "User is offline"
    };
    let text = textMap[props.status];
    return (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`<span class="status status-${props.status}" title=${text}>●</span>`;
}
function $94cb31469f63b35c$export$2e2bcd8739ae039(props) {
    let fullyConnected = props.server.status === (0, $fca64bf918d5638f$export$ac0b13ba2bbce4d5).REGISTERED;
    if (props.bouncerNetwork) fullyConnected = fullyConnected && props.bouncerNetwork.state === "connected";
    let description = null, actions = [];
    switch(props.buffer.type){
        case (0, $fca64bf918d5638f$export$a9b603917c4d9863).SERVER:
            switch(props.server.status){
                case (0, $fca64bf918d5638f$export$ac0b13ba2bbce4d5).DISCONNECTED:
                    description = "Disconnected";
                    break;
                case (0, $fca64bf918d5638f$export$ac0b13ba2bbce4d5).CONNECTING:
                    description = "Connecting...";
                    break;
                case (0, $fca64bf918d5638f$export$ac0b13ba2bbce4d5).REGISTERING:
                    description = "Logging in...";
                    break;
                case (0, $fca64bf918d5638f$export$ac0b13ba2bbce4d5).REGISTERED:
                    if (props.bouncerNetwork) switch(props.bouncerNetwork.state){
                        case "disconnected":
                            description = "Bouncer disconnected from network";
                            if (props.bouncerNetwork.error) description += ": " + props.bouncerNetwork.error;
                            break;
                        case "connecting":
                            description = "Bouncer connecting to network...";
                            break;
                        case "connected":
                            // host can be undefined e.g. when using UNIX domain sockets
                            description = `Connected to ${props.bouncerNetwork.host || "network"}`;
                            break;
                    }
                    else if (props.buffer.serverInfo) {
                        let serverInfo = props.buffer.serverInfo;
                        description = `Connected to ${serverInfo.name}`;
                    } else description = "Connected";
                    break;
            }
            let joinButton = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
			<button
				key="join"
				onClick=${props.onJoin}
			>Join channel</button>
		`;
            let reconnectButton = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
			<button
				key="reconect"
				onClick=${props.onReconnect}
			>Reconnect</button>
		`;
            let settingsButton = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
			<button
				key="settings"
				onClick="${props.onOpenSettings}"
			>Settings</button>
		`;
            if (props.server.isBouncer) {
                if (props.server.bouncerNetID) {
                    if (fullyConnected) actions.push(joinButton);
                    if (props.server.status === (0, $fca64bf918d5638f$export$ac0b13ba2bbce4d5).REGISTERED) actions.push((0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
						<button
							key="manage"
							onClick=${props.onManageNetwork}
						>Manage network</button>
					`);
                } else {
                    if (fullyConnected) actions.push((0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
						<button
							key="add"
							onClick=${props.onAddNetwork}
						>Add network</button>
					`);
                    else if (props.server.status === (0, $fca64bf918d5638f$export$ac0b13ba2bbce4d5).DISCONNECTED) actions.push(reconnectButton);
                    actions.push(settingsButton);
                }
            } else {
                if (fullyConnected) actions.push(joinButton);
                else if (props.server.status === (0, $fca64bf918d5638f$export$ac0b13ba2bbce4d5).DISCONNECTED) actions.push(reconnectButton);
                actions.push(settingsButton);
            }
            break;
        case (0, $fca64bf918d5638f$export$a9b603917c4d9863).CHANNEL:
            if (props.buffer.topic) description = (0, $37d24d778c2f247c$export$2e2bcd8739ae039)((0, $803ef401580605c5$export$6a0f863afc2134d8)(props.buffer.topic), props.onChannelClick);
            if (props.buffer.joined) actions.push((0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
				<button
					key="part"
					class="danger"
					onClick=${props.onClose}
				>Leave</button>
			`);
            else {
                if (fullyConnected) actions.push((0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
					<button
						key="join"
						onClick=${props.onJoin}
					>Join</button>
				`);
                actions.push((0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
				<button
					key="part"
					class="danger"
					onClick=${props.onClose}
				>Close</button>
			`);
            }
            break;
        case (0, $fca64bf918d5638f$export$a9b603917c4d9863).NICK:
            if (props.user) {
                let status = $94cb31469f63b35c$var$UserStatus.HERE;
                if (props.user.offline) status = $94cb31469f63b35c$var$UserStatus.OFFLINE;
                else if (props.user.away) status = $94cb31469f63b35c$var$UserStatus.GONE;
                let realname = props.buffer.name;
                if ($bd3c59ab25aed5ca$export$64ec8def5466157c(props.user.realname, props.buffer.name)) realname = (0, $803ef401580605c5$export$6a0f863afc2134d8)(props.user.realname || "");
                let details = [];
                if (props.user.username && props.user.hostname) details.push(`${props.user.username}@${props.user.hostname}`);
                if (props.user.account) {
                    let desc = `This user is verified and has logged in to the server with the account ${props.user.account}.`;
                    let item;
                    if (props.user.account === props.buffer.name) item = "authenticated";
                    else item = `authenticated as ${props.user.account}`;
                    details.push((0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`<abbr title=${desc}>${item}</abbr>`);
                } else if (props.server.reliableUserAccounts) {
                    // If the server supports MONITOR and WHOX, we can faithfully
                    // keep user.account up-to-date for user queries
                    let desc = "This user has not been verified and is not logged in.";
                    details.push((0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`<abbr title=${desc}>unauthenticated</abbr>`);
                }
                if (props.user.operator) {
                    let desc = "This user is a server operator, they have administrator privileges.";
                    details.push((0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`<abbr title=${desc}>server operator</abbr>`);
                }
                if (props.user.bot) {
                    let desc = "This user is an automated bot.";
                    details.push((0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`<abbr title=${desc}>bot</abbr>`);
                }
                details = details.map((item, i)=>{
                    if (i === 0) return item;
                    return [
                        ", ",
                        item
                    ];
                });
                if (details.length > 0) details = [
                    "(",
                    details,
                    ")"
                ];
                description = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`<${$94cb31469f63b35c$var$NickStatus} status=${status}/> ${realname} ${details}`;
            }
            actions = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
			<button
				key="close"
				class="danger"
				onClick=${props.onClose}
			>Close</button>
		`;
            break;
    }
    let name = props.buffer.name;
    if (props.buffer.type == (0, $fca64bf918d5638f$export$a9b603917c4d9863).SERVER) name = (0, $fca64bf918d5638f$export$53e73e095c2ac1e2)(props.server, props.bouncerNetwork);
    return (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
		<div class="title">${name}</div>
		${description ? (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`<div class="description">${description}</div>` : null}
		<div class="actions">${actions}</div>
	`;
}






class $15e0fa56cfe1c276$var$MemberItem extends (0, $b2a774aae58c7b4e$export$16fa2f45be04daa8) {
    constructor(props){
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }
    shouldComponentUpdate(nextProps) {
        return this.props.nick !== nextProps.nick || this.props.membership !== nextProps.membership || this.props.user !== nextProps.user;
    }
    handleClick(event) {
        event.preventDefault();
        this.props.onClick();
    }
    render() {
        // XXX: If we were feeling creative we could generate unique colors for
        // each item in ISUPPORT CHANMODES. But I am not feeling creative.
        const membmap = {
            "~": "owner",
            "&": "admin",
            "@": "op",
            "%": "halfop",
            "+": "voice"
        };
        const membclass = membmap[this.props.membership[0]] || "";
        let membership = "";
        if (this.props.membership) membership = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
				<span class="membership ${membclass}" title=${membclass}>
					${this.props.membership}
				</span>
			`;
        let title;
        let user = this.props.user;
        let classes = [
            "nick"
        ];
        if (user) {
            let mask = "";
            if (user.username && user.hostname) mask = `${user.username}@${user.hostname}`;
            if ($bd3c59ab25aed5ca$export$64ec8def5466157c(user.realname, this.props.nick)) {
                title = (0, $803ef401580605c5$export$6a0f863afc2134d8)(user.realname);
                if (mask) title = `${title} (${mask})`;
            } else title = mask;
            if (user.account) title += `\nAuthenticated as ${user.account}`;
            if (user.away) {
                classes.push("away");
                title += "\nAway";
            }
        }
        return (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
			<li>
				<a
					href=${$bd3c59ab25aed5ca$export$b1ef46223b559f9d({
            entity: this.props.nick,
            enttype: "user"
        })}
					class=${classes.join(" ")}
					title=${title}
					onClick=${this.handleClick}
				>
					<${0, $0bbd5f20273017a0$export$2e2bcd8739ae039} value=${this.props.membership}/>
					${this.props.nick}
				</a>
			</li>
		`;
    }
}
function $15e0fa56cfe1c276$var$sortMembers(a, b) {
    let [nickA, membA] = a, [nickB, membB] = b;
    const prefixPrivs = [
        "~",
        "&",
        "@",
        "%",
        "+"
    ]; // TODO: grab it from ISUPPORT PREFIX
    let i = prefixPrivs.indexOf(membA[0]), j = prefixPrivs.indexOf(membB[0]);
    if (i < 0) i = prefixPrivs.length;
    if (j < 0) j = prefixPrivs.length;
    if (i !== j) return i - j;
    return nickA.localeCompare(nickB);
}
class $15e0fa56cfe1c276$export$2e2bcd8739ae039 extends (0, $b2a774aae58c7b4e$export$16fa2f45be04daa8) {
    shouldComponentUpdate(nextProps) {
        return this.props.members !== nextProps.members || this.props.users !== nextProps.users;
    }
    render() {
        return (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
			<ul>
				${Array.from(this.props.members).sort($15e0fa56cfe1c276$var$sortMembers).map(([nick, membership])=>(0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
					<${$15e0fa56cfe1c276$var$MemberItem}
						key=${nick}
						nick=${nick}
						membership=${membership}
						user=${this.props.users.get(nick)}
						onClick=${()=>this.props.onNickClick(nick)}
					/>
				`)}
			</ul>
		`;
    }
}




class $c6f536f0bcf4fccd$export$2e2bcd8739ae039 extends (0, $b2a774aae58c7b4e$export$16fa2f45be04daa8) {
    state = {
        url: "",
        pass: "",
        nick: "",
        password: "",
        rememberMe: false,
        username: "",
        realname: "",
        autojoin: true
    };
    nickInput = (0, $b2a774aae58c7b4e$export$7d1e3a5e95ceca43)();
    constructor(props){
        super(props);
        this.handleInput = this.handleInput.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        if (props.params) this.state = {
            ...this.state,
            url: props.params.url || "",
            nick: props.params.nick || "",
            rememberMe: props.params.autoconnect || false,
            username: props.params.username || "",
            realname: props.params.realname || ""
        };
    }
    handleInput(event) {
        let target = event.target;
        let value = target.type == "checkbox" ? target.checked : target.value;
        this.setState({
            [target.name]: value
        });
    }
    handleSubmit(event) {
        event.preventDefault();
        if (this.props.connecting) return;
        let params = {
            url: this.state.url,
            pass: this.state.pass,
            nick: this.state.nick,
            autoconnect: this.state.rememberMe,
            username: this.state.username,
            realname: this.state.realname,
            saslPlain: null,
            autojoin: []
        };
        if (this.state.password) params.saslPlain = {
            username: params.username || params.nick,
            password: this.state.password
        };
        else if (this.props.auth === "external") params.saslExternal = true;
        else if (this.props.auth === "oauth2") params.saslOauthBearer = this.props.params.saslOauthBearer;
        if (this.state.autojoin) params.autojoin = this.props.params.autojoin || [];
        this.props.onSubmit(params);
    }
    componentDidMount() {
        if (this.nickInput.current) this.nickInput.current.focus();
    }
    render() {
        let disabled = this.props.connecting;
        let serverURL = null;
        if (!this.props.params || !this.props.params.url) serverURL = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
				<label>
					Server URL:<br/>
					<input
						type="text"
						name="url"
						value=${this.state.url}
						disabled=${disabled}
						inputmode="url"
					/>
				</label>
				<br/><br/>
			`;
        let status = null;
        if (this.props.connecting) status = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
				<p>Connecting...</p>
			`;
        else if (this.props.error) status = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
				<p class="error-text">${(0, $37d24d778c2f247c$export$2e2bcd8739ae039)(this.props.error)}</p>
			`;
        let auth = null;
        if (this.props.auth !== "disabled" && this.props.auth !== "external" && this.props.auth !== "oauth2") auth = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
				<label>
					Password:<br/>
					<input
						type="password"
						name="password"
						value=${this.state.password}
						disabled=${disabled}
						required=${this.props.auth === "mandatory"}
						placeholder=${this.props.auth !== "mandatory" ? "(optional)" : ""}
					/>
				</label>
				<br/><br/>
			`;
        let autojoin = null;
        let channels = this.props.params.autojoin || [];
        if (channels.length > 0) {
            let s = channels.length > 1 ? "s" : "";
            autojoin = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
				<label>
					<input
						type="checkbox"
						name="autojoin"
						checked=${this.state.autojoin}
					/>
					Auto-join channel${s} <strong>${channels.join(", ")}</strong>
				</label>
				<br/><br/>
			`;
        }
        return (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
			<form onInput=${this.handleInput} onSubmit=${this.handleSubmit}>
				<h2>Connect to IRC</h2>

				<label>
					Nickname:<br/>
					<input
						type="username"
						name="nick"
						value=${this.state.nick}
						disabled=${disabled}
						ref=${this.nickInput}
						required
						autofocus
					/>
				</label>
				<br/><br/>

				${auth}

				${autojoin}

				<label>
					<input
						type="checkbox"
						name="rememberMe"
						checked=${this.state.rememberMe}
						disabled=${disabled}
					/>
					Remember me
				</label>
				<br/><br/>

				<details>
					<summary role="button">Advanced options</summary>

					<br/>

					${serverURL}

					<label>
						Username:<br/>
						<input
							type="username"
							name="username"
							value=${this.state.username}
							disabled=${disabled}
							placeholder="Same as nickname"
						/>
					</label>
					<br/><br/>

					<label>
						Real name:<br/>
						<input
							type="text"
							name="realname"
							value=${this.state.realname}
							disabled=${disabled}
							placeholder="Same as nickname"
						/>
					</label>
					<br/><br/>

					<label>
						Server password:<br/>
						<input
							type="password"
							name="pass"
							value=${this.state.pass}
							disabled=${disabled}
							placeholder="None"
						/>
					</label>
					<br/><br/>
				</details>

				<br/>
				<button disabled=${disabled}>Connect</button>

				${status}
			</form>
		`;
    }
}



class $b4b4b87f4b38722c$export$2e2bcd8739ae039 extends (0, $b2a774aae58c7b4e$export$16fa2f45be04daa8) {
    state = {
        channel: "#"
    };
    constructor(props){
        super(props);
        this.handleInput = this.handleInput.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        if (props.channel) this.state.channel = props.channel;
    }
    handleInput(event) {
        let target = event.target;
        let value = target.type == "checkbox" ? target.checked : target.value;
        this.setState({
            [target.name]: value
        });
    }
    handleSubmit(event) {
        event.preventDefault();
        let params = {
            channel: this.state.channel
        };
        this.props.onSubmit(params);
    }
    render() {
        return (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
			<form onInput=${this.handleInput} onSubmit=${this.handleSubmit}>
				<label>
					Channel:<br/>
					<input type="text" name="channel" value=${this.state.channel} autofocus required/>
				</label>
				<br/>

				<br/>
				<button>Join</button>
			</form>
		`;
    }
}




function $f6fdf5978ceb757f$var$getSiblingBuffer(buffers, bufID, delta) {
    let bufList = Array.from(buffers.values());
    let i = bufList.findIndex((buf)=>buf.id === bufID);
    if (i < 0) return null;
    i = (i + bufList.length + delta) % bufList.length;
    return bufList[i];
}
const $f6fdf5978ceb757f$export$63ce3c18bd0f1276 = [
    {
        key: "h",
        altKey: true,
        description: "Mark all messages as read",
        execute: (app)=>{
            app.setState((state)=>{
                let buffers = new Map();
                state.buffers.forEach((buf)=>{
                    buffers.set(buf.id, {
                        ...buf,
                        unread: (0, $fca64bf918d5638f$export$9be0a2424da959ae).NONE,
                        prevReadReceipt: null
                    });
                    let receipts = {};
                    if (buf.messages.length > 0) {
                        let lastMsg = buf.messages[buf.messages.length - 1];
                        receipts[(0, $fca64bf918d5638f$export$c49c54eaac29b59a).READ] = (0, $fca64bf918d5638f$export$1274528beb7cd977)(lastMsg);
                    }
                    let client = app.clients.get(buf.server);
                    app.bufferStore.put({
                        name: buf.name,
                        server: client.params,
                        unread: (0, $fca64bf918d5638f$export$9be0a2424da959ae).NONE,
                        receipts: receipts
                    });
                });
                return {
                    buffers: buffers
                };
            }, ()=>{
                app.updateDocumentTitle();
            });
        }
    },
    {
        key: "a",
        altKey: true,
        description: "Jump to next buffer with activity",
        execute: (app)=>{
            // TODO: order by age if same priority
            let firstServerBuffer = null;
            let target = null;
            for (let buf of app.state.buffers.values()){
                if (!firstServerBuffer && buf.type === (0, $fca64bf918d5638f$export$a9b603917c4d9863).SERVER) firstServerBuffer = buf;
                if (buf.unread === (0, $fca64bf918d5638f$export$9be0a2424da959ae).NONE) continue;
                if (!target || (0, $fca64bf918d5638f$export$9be0a2424da959ae).compare(buf.unread, target.unread) > 0) target = buf;
            }
            if (!target) target = firstServerBuffer;
            if (target) app.switchBuffer(target);
        }
    },
    {
        key: "ArrowUp",
        altKey: true,
        description: "Jump to the previous buffer",
        execute: (app)=>{
            let prev = $f6fdf5978ceb757f$var$getSiblingBuffer(app.state.buffers, app.state.activeBuffer, -1);
            if (prev) app.switchBuffer(prev);
        }
    },
    {
        key: "ArrowDown",
        altKey: true,
        description: "Jump to the next buffer",
        execute: (app)=>{
            let next = $f6fdf5978ceb757f$var$getSiblingBuffer(app.state.buffers, app.state.activeBuffer, 1);
            if (next) app.switchBuffer(next);
        }
    },
    {
        key: "k",
        ctrlKey: true,
        description: "Switch to a buffer",
        execute: (app)=>{
            app.openDialog("switch");
        }
    }
];
function $f6fdf5978ceb757f$export$de27182ff8187d6c(app) {
    let byKey = {};
    $f6fdf5978ceb757f$export$63ce3c18bd0f1276.forEach((binding)=>{
        if (!byKey[binding.key]) byKey[binding.key] = [];
        byKey[binding.key].push(binding);
    });
    window.addEventListener("keydown", (event)=>{
        let candidates = byKey[event.key];
        if (!candidates) return;
        candidates = candidates.filter((binding)=>{
            return !!binding.altKey == event.altKey && !!binding.ctrlKey == event.ctrlKey;
        });
        if (candidates.length != 1) return;
        event.preventDefault();
        candidates[0].execute(app);
    });
}




function $b5b0ab28313e6465$var$getActiveClient(app) {
    let buf = app.state.buffers.get(app.state.activeBuffer);
    if (!buf) throw new Error("Not connected to server");
    return app.clients.get(buf.server);
}
function $b5b0ab28313e6465$var$getActiveTarget(app) {
    let activeBuffer = app.state.buffers.get(app.state.activeBuffer);
    if (!activeBuffer) throw new Error("Not in a buffer");
    return activeBuffer.name;
}
function $b5b0ab28313e6465$var$getActiveChannel(app) {
    let activeBuffer = app.state.buffers.get(app.state.activeBuffer);
    if (!activeBuffer || activeBuffer.type !== (0, $fca64bf918d5638f$export$a9b603917c4d9863).CHANNEL) throw new Error("Not in a channel");
    return activeBuffer.name;
}
async function $b5b0ab28313e6465$var$setUserHostMode(app, args, mode) {
    let nick = args[0];
    if (!nick) throw new Error("Missing nick");
    let activeChannel = $b5b0ab28313e6465$var$getActiveChannel(app);
    let client = $b5b0ab28313e6465$var$getActiveClient(app);
    let whois = await client.whois(nick);
    const info = whois[$bd3c59ab25aed5ca$export$9514b1191eaefcec].params;
    const user = info[2];
    const host = info[3];
    client.send({
        command: "MODE",
        params: [
            activeChannel,
            mode,
            `*!${user}@${host}`
        ]
    });
}
function $b5b0ab28313e6465$var$markServerBufferUnread(app) {
    let activeBuffer = app.state.buffers.get(app.state.activeBuffer);
    if (!activeBuffer || activeBuffer.type === (0, $fca64bf918d5638f$export$a9b603917c4d9863).SERVER) return;
    app.setBufferState({
        server: activeBuffer.server
    }, (buf)=>{
        return {
            unread: (0, $fca64bf918d5638f$export$9be0a2424da959ae).union(buf.unread, (0, $fca64bf918d5638f$export$9be0a2424da959ae).MESSAGE)
        };
    });
}
const $b5b0ab28313e6465$var$join = {
    usage: "<name> [password]",
    description: "Join a channel",
    execute: (app, args)=>{
        let channel = args[0];
        if (!channel) throw new Error("Missing channel name");
        if (args.length > 1) app.open(channel, null, args[1]);
        else app.open(channel);
    }
};
const $b5b0ab28313e6465$var$kick = {
    usage: "<nick> [comment]",
    description: "Remove a user from the channel",
    execute: (app, args)=>{
        let nick = args[0];
        let activeChannel = $b5b0ab28313e6465$var$getActiveChannel(app);
        let params = [
            activeChannel,
            nick
        ];
        if (args.length > 1) params.push(args.slice(1).join(" "));
        $b5b0ab28313e6465$var$getActiveClient(app).send({
            command: "KICK",
            params: params
        });
    }
};
const $b5b0ab28313e6465$var$ban = {
    usage: "[nick]",
    description: "Ban a user from the channel, or display the current ban list",
    execute: (app, args)=>{
        if (args.length == 0) {
            let activeChannel = $b5b0ab28313e6465$var$getActiveChannel(app);
            $b5b0ab28313e6465$var$getActiveClient(app).send({
                command: "MODE",
                params: [
                    activeChannel,
                    "+b"
                ]
            });
        } else return $b5b0ab28313e6465$var$setUserHostMode(app, args, "+b");
    }
};
function $b5b0ab28313e6465$var$givemode(app, args, mode) {
    // TODO: Handle several users at once
    let nick = args[0];
    if (!nick) throw new Error("Missing nick");
    let activeChannel = $b5b0ab28313e6465$var$getActiveChannel(app);
    $b5b0ab28313e6465$var$getActiveClient(app).send({
        command: "MODE",
        params: [
            activeChannel,
            mode,
            nick
        ]
    });
}
var $b5b0ab28313e6465$export$2e2bcd8739ae039 = {
    "away": {
        usage: "[message]",
        description: "Set away message",
        execute: (app, args)=>{
            const params = [];
            if (args.length) params.push(args.join(" "));
            $b5b0ab28313e6465$var$getActiveClient(app).send({
                command: "AWAY",
                params: params
            });
        }
    },
    "ban": $b5b0ab28313e6465$var$ban,
    "buffer": {
        usage: "<name>",
        description: "Switch to a buffer",
        execute: (app, args)=>{
            let name = args[0];
            for (let buf of app.state.buffers.values())if (buf.name === name) {
                app.switchBuffer(buf);
                return;
            }
            throw new Error("Unknown buffer");
        }
    },
    "close": {
        description: "Close the current buffer",
        execute: (app, args)=>{
            let activeBuffer = app.state.buffers.get(app.state.activeBuffer);
            if (!activeBuffer || activeBuffer.type == (0, $fca64bf918d5638f$export$a9b603917c4d9863).SERVER) throw new Error("Not in a user or channel buffer");
            app.close(activeBuffer.id);
        }
    },
    "deop": {
        usage: "<nick>",
        description: "Remove operator status for a user on this channel",
        execute: (app, args)=>$b5b0ab28313e6465$var$givemode(app, args, "-o")
    },
    "devoice": {
        usage: "<nick>",
        description: "Remove voiced status for a user on this channel",
        execute: (app, args)=>$b5b0ab28313e6465$var$givemode(app, args, "-v")
    },
    "disconnect": {
        description: "Disconnect from the server",
        execute: (app, args)=>{
            app.disconnect();
        }
    },
    "help": {
        description: "Show help menu",
        execute: (app, args)=>{
            app.openHelp();
        }
    },
    "invite": {
        usage: "<nick>",
        description: "Invite a user to the channel",
        execute: (app, args)=>{
            let nick = args[0];
            if (!nick) throw new Error("Missing nick");
            let activeChannel = $b5b0ab28313e6465$var$getActiveChannel(app);
            $b5b0ab28313e6465$var$getActiveClient(app).send({
                command: "INVITE",
                params: [
                    nick,
                    activeChannel
                ]
            });
        }
    },
    "j": $b5b0ab28313e6465$var$join,
    "join": $b5b0ab28313e6465$var$join,
    "kick": $b5b0ab28313e6465$var$kick,
    "kickban": {
        usage: "<target>",
        description: "Ban a user and removes them from the channel",
        execute: (app, args)=>{
            $b5b0ab28313e6465$var$kick.execute(app, args);
            $b5b0ab28313e6465$var$ban.execute(app, args);
        }
    },
    "lusers": {
        usage: "[<mask> [<target>]]",
        description: "Request user statistics about the network",
        execute: (app, args)=>{
            $b5b0ab28313e6465$var$getActiveClient(app).send({
                command: "LUSERS",
                params: args
            });
            $b5b0ab28313e6465$var$markServerBufferUnread(app);
        }
    },
    "me": {
        usage: "<action>",
        description: "Send an action message to the current buffer",
        execute: (app, args)=>{
            let action = args.join(" ");
            let target = $b5b0ab28313e6465$var$getActiveTarget(app);
            let text = `\x01ACTION ${action}\x01`;
            app.privmsg(target, text);
        }
    },
    "mode": {
        usage: "[target] [modes] [mode args...]",
        description: "Query or change a channel or user mode",
        execute: (app, args)=>{
            let target = args[0];
            if (!target || target.startsWith("+") || target.startsWith("-")) {
                let activeChannel = $b5b0ab28313e6465$var$getActiveChannel(app);
                args = [
                    activeChannel,
                    ...args
                ];
            }
            $b5b0ab28313e6465$var$getActiveClient(app).send({
                command: "MODE",
                params: args
            });
        }
    },
    "motd": {
        usage: "[server]",
        description: "Get the Message Of The Day",
        execute: (app, args)=>{
            $b5b0ab28313e6465$var$getActiveClient(app).send({
                command: "MOTD",
                params: args
            });
            $b5b0ab28313e6465$var$markServerBufferUnread(app);
        }
    },
    "msg": {
        usage: "<target> <message>",
        description: "Send a message to a nickname or a channel",
        execute: (app, args)=>{
            let target = args[0];
            let text = args.slice(1).join(" ");
            $b5b0ab28313e6465$var$getActiveClient(app).send({
                command: "PRIVMSG",
                params: [
                    target,
                    text
                ]
            });
        }
    },
    "nick": {
        usage: "<nick>",
        description: "Change current nickname",
        execute: (app, args)=>{
            let newNick = args[0];
            $b5b0ab28313e6465$var$getActiveClient(app).send({
                command: "NICK",
                params: [
                    newNick
                ]
            });
        }
    },
    "notice": {
        usage: "<target> <message>",
        description: "Send a notice to a nickname or a channel",
        execute: (app, args)=>{
            let target = args[0];
            let text = args.slice(1).join(" ");
            $b5b0ab28313e6465$var$getActiveClient(app).send({
                command: "NOTICE",
                params: [
                    target,
                    text
                ]
            });
        }
    },
    "op": {
        usage: "<nick>",
        description: "Give a user operator status on this channel",
        execute: (app, args)=>$b5b0ab28313e6465$var$givemode(app, args, "+o")
    },
    "part": {
        usage: "[reason]",
        description: "Leave a channel",
        execute: (app, args)=>{
            let reason = args.join(" ");
            let activeChannel = $b5b0ab28313e6465$var$getActiveChannel(app);
            let params = [
                activeChannel
            ];
            if (reason) params.push(reason);
            $b5b0ab28313e6465$var$getActiveClient(app).send({
                command: "PART",
                params: params
            });
        }
    },
    "query": {
        usage: "<nick> [message]",
        description: "Open a buffer to send messages to a nickname",
        execute: (app, args)=>{
            let nick = args[0];
            if (!nick) throw new Error("Missing nickname");
            app.open(nick);
            if (args.length > 1) {
                let text = args.slice(1).join(" ");
                app.privmsg(nick, text);
            }
        }
    },
    "quiet": {
        usage: "[nick]",
        description: "Quiet a user in the channel, or display the current quiet list",
        execute: (app, args)=>{
            if (args.length == 0) $b5b0ab28313e6465$var$getActiveClient(app).send({
                command: "MODE",
                params: [
                    $b5b0ab28313e6465$var$getActiveChannel(app),
                    "+q"
                ]
            });
            else return $b5b0ab28313e6465$var$setUserHostMode(app, args, "+q");
        }
    },
    "quit": {
        description: "Quit",
        execute: (app, args)=>{
            app.close({
                name: (0, $fca64bf918d5638f$export$50f2960994553271)
            });
        }
    },
    "quote": {
        usage: "<command>",
        description: "Send a raw IRC command to the server",
        execute: (app, args)=>{
            let msg;
            try {
                msg = $bd3c59ab25aed5ca$export$f2f615077a189f21(args.join(" "));
            } catch (err) {
                throw new Error("Failed to parse IRC command: " + err.message);
            }
            $b5b0ab28313e6465$var$getActiveClient(app).send(msg);
        }
    },
    "reconnect": {
        description: "Reconnect to the server",
        execute: (app, args)=>{
            app.reconnect();
        }
    },
    "setname": {
        usage: "<realname>",
        description: "Change current realname",
        execute: (app, args)=>{
            let newRealname = args.join(" ");
            let client = $b5b0ab28313e6465$var$getActiveClient(app);
            if (!client.caps.enabled.has("setname")) throw new Error("Server doesn't support changing the realname");
            client.send({
                command: "SETNAME",
                params: [
                    newRealname
                ]
            });
        // TODO: save to local storage
        }
    },
    "stats": {
        usage: "<query> [server]",
        description: "Request server statistics",
        execute: (app, args)=>{
            let query = args[0];
            if (!query) throw new Error("Missing query");
            let params = [
                query
            ];
            if (args.length > 1) params.push(args.slice(1).join(" "));
            $b5b0ab28313e6465$var$getActiveClient(app).send({
                command: "STATS",
                params: params
            });
            $b5b0ab28313e6465$var$markServerBufferUnread(app);
        }
    },
    "topic": {
        usage: "<topic>",
        description: "Change the topic of the current channel",
        execute: (app, args)=>{
            let activeChannel = $b5b0ab28313e6465$var$getActiveChannel(app);
            let params = [
                activeChannel
            ];
            if (args.length > 0) params.push(args.join(" "));
            $b5b0ab28313e6465$var$getActiveClient(app).send({
                command: "TOPIC",
                params: params
            });
        }
    },
    "unban": {
        usage: "<nick>",
        description: "Remove a user from the ban list",
        execute: (app, args)=>{
            return $b5b0ab28313e6465$var$setUserHostMode(app, args, "-b");
        }
    },
    "unquiet": {
        usage: "<nick>",
        description: "Remove a user from the quiet list",
        execute: (app, args)=>{
            return $b5b0ab28313e6465$var$setUserHostMode(app, args, "-q");
        }
    },
    "voice": {
        usage: "<nick>",
        description: "Give a user voiced status on this channel",
        execute: (app, args)=>$b5b0ab28313e6465$var$givemode(app, args, "+v")
    },
    "who": {
        usage: "<mask>",
        description: "Retrieve a list of users",
        execute: (app, args)=>{
            $b5b0ab28313e6465$var$getActiveClient(app).send({
                command: "WHO",
                params: args
            });
            $b5b0ab28313e6465$var$markServerBufferUnread(app);
        }
    },
    "whois": {
        usage: "<nick>",
        description: "Retrieve information about a user",
        execute: (app, args)=>{
            let nick = args[0];
            if (!nick) throw new Error("Missing nick");
            $b5b0ab28313e6465$var$getActiveClient(app).send({
                command: "WHOIS",
                params: [
                    nick
                ]
            });
            $b5b0ab28313e6465$var$markServerBufferUnread(app);
        }
    },
    "whowas": {
        usage: "<nick> [count]",
        description: "Retrieve information about an offline user",
        execute: (app, args)=>{
            if (args.length < 1) throw new Error("Missing nick");
            $b5b0ab28313e6465$var$getActiveClient(app).send({
                command: "WHOWAS",
                params: args
            });
            $b5b0ab28313e6465$var$markServerBufferUnread(app);
        }
    },
    "list": {
        usage: "[filter]",
        description: "Retrieve a list of channels from a network",
        execute: (app, args)=>{
            $b5b0ab28313e6465$var$getActiveClient(app).send({
                command: "LIST",
                params: args
            });
            $b5b0ab28313e6465$var$markServerBufferUnread(app);
        }
    }
};


function $af9ce1e202e3524a$var$KeyBindingsHelp() {
    let l = (0, $f6fdf5978ceb757f$export$63ce3c18bd0f1276).map((binding)=>{
        let keys = [];
        if (binding.ctrlKey) keys.push("Ctrl");
        if (binding.altKey) keys.push("Alt");
        keys.push(binding.key);
        keys = keys.map((name, i)=>{
            return (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
				${i > 0 ? "+" : null}
				<kbd>${name}</kbd>
			`;
        });
        return (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
			<dt>${keys}</dt>
			<dd>${binding.description}</dd>
		`;
    });
    l.push((0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
		<dt><kbd>Tab</kbd></dt>
		<dd>Automatically complete nickname or channel</dd>
	`);
    if (!window.matchMedia("(pointer: none)").matches) l.push((0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
			<dt><strong>Middle mouse click</strong></dt>
			<dd>Close buffer</dd>
		`);
    return (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`<dl>${l}</dl>`;
}
function $af9ce1e202e3524a$var$CommandsHelp() {
    let l = Object.keys((0, $b5b0ab28313e6465$export$2e2bcd8739ae039)).map((name)=>{
        let cmd = (0, $b5b0ab28313e6465$export$2e2bcd8739ae039)[name];
        let usage = [
            (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`<strong>/${name}</strong>`
        ];
        if (cmd.usage) usage.push(" " + cmd.usage);
        return (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
			<dt><code>${usage}</code></dt>
			<dd>${cmd.description}</dd>
		`;
    });
    return (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`<dl>${l}</dl>`;
}
function $af9ce1e202e3524a$export$2e2bcd8739ae039() {
    return (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
		<h3>Key bindings</h3>
		<${$af9ce1e202e3524a$var$KeyBindingsHelp}/>

		<h3>Commands</h3>
		<${$af9ce1e202e3524a$var$CommandsHelp}/>
	`;
}



const $03b5941ba753e1f6$var$defaultParams = {
    name: "",
    host: "",
    port: 6697,
    nickname: "",
    username: "",
    realname: "",
    pass: ""
};
class $03b5941ba753e1f6$export$2e2bcd8739ae039 extends (0, $b2a774aae58c7b4e$export$16fa2f45be04daa8) {
    prevParams = null;
    state = {
        ...$03b5941ba753e1f6$var$defaultParams,
        autojoin: true
    };
    constructor(props){
        super(props);
        this.prevParams = {
            ...$03b5941ba753e1f6$var$defaultParams
        };
        this.handleInput = this.handleInput.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        if (props.params) Object.keys($03b5941ba753e1f6$var$defaultParams).forEach((k)=>{
            if (props.params[k] !== undefined) {
                this.state[k] = props.params[k];
                this.prevParams[k] = props.params[k];
            }
        });
    }
    handleInput(event) {
        let target = event.target;
        let value = target.type == "checkbox" ? target.checked : target.value;
        this.setState({
            [target.name]: value
        });
    }
    handleSubmit(event) {
        event.preventDefault();
        let params = {};
        Object.keys($03b5941ba753e1f6$var$defaultParams).forEach((k)=>{
            if (!this.props.isNew && this.prevParams[k] == this.state[k]) return;
            if (this.props.isNew && $03b5941ba753e1f6$var$defaultParams[k] == this.state[k]) return;
            params[k] = this.state[k];
        });
        let autojoin = this.state.autojoin ? this.props.autojoin : null;
        this.props.onSubmit(params, autojoin);
    }
    render() {
        let removeNetwork = null;
        if (!this.props.isNew) removeNetwork = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
				<button type="button" class="danger" onClick=${()=>this.props.onRemove()}>
					Remove network
				</button>
			`;
        let autojoin = null;
        if (this.props.autojoin) autojoin = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
				<label>
					<input
						type="checkbox"
						name="autojoin"
						checked=${this.state.autojoin}
					/>
					Auto-join channel <strong>${this.props.autojoin}</strong>
				</label>
				<br/><br/>
			`;
        return (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
			<form onInput=${this.handleInput} onSubmit=${this.handleSubmit}>
				<label>
					Hostname:<br/>
					<input type="text" name="host" value=${this.state.host} autofocus required/>
				</label>
				<br/><br/>

				${autojoin}

				<details>
					<summary role="button">Advanced options</summary>

					<br/>

					<label>
						Port:<br/>
						<input type="number" name="port" value=${this.state.port}/>
					</label>
					<br/><br/>

					<label>
						Network name:<br/>
						<input type="text" name="name" value=${this.state.name}/>
					</label>
					<br/><br/>

					<label>
						Nickname:<br/>
						<input type="username" name="nickname" value=${this.state.nickname}/>
					</label>
					<br/><br/>

					<label>
						Username:<br/>
						<input type="username" name="username" value=${this.state.username}/>
					</label>
					<br/><br/>

					<label>
						Real name:<br/>
						<input type="text" name="realname" value=${this.state.realname}/>
					</label>
					<br/><br/>

					<label>
						Server password:<br/>
						<input type="password" name="pass" value=${this.state.pass} placeholder="None"/>
					</label>
					<br/>
				</details>

				<br/>
				${removeNetwork}
				${" "}
				<button>
					${this.props.isNew ? "Add network" : "Save network"}
				</button>
			</form>
		`;
    }
}



class $368ce7ef0e8c1c36$export$2e2bcd8739ae039 extends (0, $b2a774aae58c7b4e$export$16fa2f45be04daa8) {
    state = {
        username: "",
        password: ""
    };
    constructor(props){
        super(props);
        this.handleInput = this.handleInput.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        if (props.username) this.state.username = props.username;
    }
    handleInput(event) {
        let target = event.target;
        let value = target.type == "checkbox" ? target.checked : target.value;
        this.setState({
            [target.name]: value
        });
    }
    handleSubmit(event) {
        event.preventDefault();
        this.props.onSubmit(this.state.username, this.state.password);
    }
    render() {
        return (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
			<form onInput=${this.handleInput} onSubmit=${this.handleSubmit}>
				<label>
					Username:<br/>
					<input type="username" name="username" value=${this.state.username} required/>
				</label>
				<br/><br/>

				<label>
					Password:<br/>
					<input type="password" name="password" value=${this.state.password} required autofocus/>
				</label>
				<br/><br/>

				<button>Login</button>
			</form>
		`;
    }
}



class $210f1d422ab09f4c$export$2e2bcd8739ae039 extends (0, $b2a774aae58c7b4e$export$16fa2f45be04daa8) {
    state = {
        email: "",
        password: ""
    };
    constructor(props){
        super(props);
        this.handleInput = this.handleInput.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    handleInput(event) {
        let target = event.target;
        let value = target.type == "checkbox" ? target.checked : target.value;
        this.setState({
            [target.name]: value
        });
    }
    handleSubmit(event) {
        event.preventDefault();
        this.props.onSubmit(this.state.email, this.state.password);
    }
    render() {
        return (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
			<form onInput=${this.handleInput} onSubmit=${this.handleSubmit}>
				<label>
					E-mail:<br/>
					<input
						type="email"
						name="email"
						value=${this.state.email}
						required=${this.props.emailRequired}
						placeholder=${this.props.emailRequired ? null : "(optional)"}
						autofocus
					/>
				</label>
				<br/><br/>

				<label>
					Password:<br/>
					<input type="password" name="password" value=${this.state.password} required/>
				</label>
				<br/><br/>

				<button>Register</button>
			</form>
		`;
    }
}




class $5855ce19a38be3e6$export$2e2bcd8739ae039 extends (0, $b2a774aae58c7b4e$export$16fa2f45be04daa8) {
    state = {
        code: ""
    };
    constructor(props){
        super(props);
        this.handleInput = this.handleInput.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    handleInput(event) {
        let target = event.target;
        let value = target.type == "checkbox" ? target.checked : target.value;
        this.setState({
            [target.name]: value
        });
    }
    handleSubmit(event) {
        event.preventDefault();
        this.props.onSubmit(this.state.code);
    }
    render() {
        return (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
			<form onInput=${this.handleInput} onSubmit=${this.handleSubmit}>
				<p>Your account <strong>${this.props.account}</strong> has been created, but a verification code is required to complete the registration.</p>

				<p>${(0, $37d24d778c2f247c$export$2e2bcd8739ae039)(this.props.message)}</p>

				<label>
					Verification code:<br/>
					<input type="text" name="code" value=${this.state.code} required autofocus autocomplete="off"/>
				</label>
				<br/><br/>

				<button>Verify account</button>
			</form>
		`;
    }
}



class $9fbbfef00d6a25bf$export$2e2bcd8739ae039 extends (0, $b2a774aae58c7b4e$export$16fa2f45be04daa8) {
    state = {};
    constructor(props){
        super(props);
        this.state.secondsInTimestamps = props.settings.secondsInTimestamps;
        this.state.bufferEvents = props.settings.bufferEvents;
        this.handleInput = this.handleInput.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    handleInput(event) {
        let target = event.target;
        let value = target.type == "checkbox" ? target.checked : target.value;
        this.setState({
            [target.name]: value
        }, ()=>{
            this.props.onChange(this.state);
        });
    }
    handleSubmit(event) {
        event.preventDefault();
        this.props.onClose();
    }
    registerProtocol() {
        let url = window.location.origin + window.location.pathname + "?open=%s";
        try {
            navigator.registerProtocolHandler("irc", url);
            navigator.registerProtocolHandler("ircs", url);
        } catch (err) {
            console.error("Failed to register protocol handler: ", err);
        }
    }
    render() {
        let protocolHandler = null;
        if (this.props.showProtocolHandler) protocolHandler = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
				<div class="protocol-handler">
					<div class="left">
						Set gamja as your default IRC client for this browser.
						IRC links will be automatically opened here.
					</div>
					<div class="right">
						<button type="button" onClick=${()=>this.registerProtocol()}>
							Enable
						</button>
					</div>
				</div>
				<br/><br/>
			`;
        return (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
			<form onInput=${this.handleInput} onSubmit=${this.handleSubmit}>
				<label>
					<input
						type="checkbox"
						name="secondsInTimestamps"
						checked=${this.state.secondsInTimestamps}
					/>
					Show seconds in time indicator
				</label>
				<br/><br/>

				<label>
					<input
						type="radio"
						name="bufferEvents"
						value="fold"
						checked=${this.state.bufferEvents === "fold"}
					/>
					Show and fold chat events
				</label>
				<br/>
				<label>
					<input
						type="radio"
						name="bufferEvents"
						value="expand"
						checked=${this.state.bufferEvents === "expand"}
					/>
					Show and expand chat events
				</label>
				<br/>
				<label>
					<input
						type="radio"
						name="bufferEvents"
						value="hide"
						checked=${this.state.bufferEvents === "hide"}
					/>
					Hide chat events
				</label>
				<br/><br/>

				${protocolHandler}

				<button type="button" class="danger" onClick=${()=>this.props.onDisconnect()}>
					Disconnect
				</button>
				<button>
					Close
				</button>
			</form>
		`;
    }
}





class $9b625992f92feff7$var$SwitcherItem extends (0, $b2a774aae58c7b4e$export$16fa2f45be04daa8) {
    constructor(props){
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }
    handleClick(event) {
        event.preventDefault();
        this.props.onClick();
    }
    render() {
        let class_ = this.props.selected ? "selected" : "";
        return (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
			<li>
				<a
					href=${(0, $fca64bf918d5638f$export$64b0f097aebd4e10)(this.props.buffer)}
					class=${class_}
					onClick=${this.handleClick}
				>
					<span class="server">
						${(0, $fca64bf918d5638f$export$53e73e095c2ac1e2)(this.props.server, this.props.bouncerNetwork)}
					</span>
					${this.props.buffer.name}
				</a>
			</li>
		`;
    }
}
function $9b625992f92feff7$var$matchString(s, query) {
    return s.toLowerCase().includes(query) ? 1 : 0;
}
function $9b625992f92feff7$var$matchBuffer(buf, server, query) {
    let score = 2 * $9b625992f92feff7$var$matchString(buf.name, query);
    switch(buf.type){
        case (0, $fca64bf918d5638f$export$a9b603917c4d9863).CHANNEL:
            score += $9b625992f92feff7$var$matchString(buf.topic || "", query);
            break;
        case (0, $fca64bf918d5638f$export$a9b603917c4d9863).NICK:
            let user = server.users.get(buf.name);
            if (user && user.realname && $bd3c59ab25aed5ca$export$64ec8def5466157c(user.realname, buf.name)) score += $9b625992f92feff7$var$matchString(user.realname, query);
            break;
    }
    return score;
}
class $9b625992f92feff7$export$2e2bcd8739ae039 extends (0, $b2a774aae58c7b4e$export$16fa2f45be04daa8) {
    state = {
        query: "",
        selected: 0
    };
    constructor(props){
        super(props);
        this.handleInput = this.handleInput.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleKeyUp = this.handleKeyUp.bind(this);
    }
    getSuggestions() {
        let query = this.state.query.toLowerCase();
        let l = [];
        let scores = new Map();
        for (let buf of this.props.buffers.values()){
            if (buf.type === (0, $fca64bf918d5638f$export$a9b603917c4d9863).SERVER) continue;
            let score = 0;
            if (query !== "") {
                let server = this.props.servers.get(buf.server);
                score = $9b625992f92feff7$var$matchBuffer(buf, server, query);
                if (!score) continue;
            }
            scores.set(buf.id, score);
            l.push(buf);
        }
        l.sort((a, b)=>{
            return scores.get(b.id) - scores.get(a.id);
        });
        return l.slice(0, 20);
    }
    handleInput(event) {
        let target = event.target;
        this.setState({
            [target.name]: target.value
        });
    }
    handleSubmit(event) {
        event.preventDefault();
        this.props.onSubmit(this.getSuggestions()[this.state.selected]);
    }
    handleKeyUp(event) {
        switch(event.key){
            case "ArrowUp":
                event.stopPropagation();
                this.move(-1);
                break;
            case "ArrowDown":
                event.stopPropagation();
                this.move(1);
                break;
        }
    }
    move(delta) {
        let numSuggestions = this.getSuggestions().length;
        this.setState((state)=>{
            return {
                selected: (state.selected + delta + numSuggestions) % numSuggestions
            };
        });
    }
    render() {
        let items = this.getSuggestions().map((buf, i)=>{
            let server = this.props.servers.get(buf.server);
            let bouncerNetwork = null;
            if (server.bouncerNetID) bouncerNetwork = this.props.bouncerNetworks.get(server.bouncerNetID);
            return (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
				<${$9b625992f92feff7$var$SwitcherItem}
					buffer=${buf}
					server=${server}
					bouncerNetwork=${bouncerNetwork}
					selected=${this.state.selected === i}
					onClick=${()=>this.props.onSubmit(buf)}
				/>
			`;
        });
        return (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
			<form
				onInput=${this.handleInput}
				onSubmit=${this.handleSubmit}
				onKeyUp=${this.handleKeyUp}
			>
				<input
					type="search"
					name="query"
					value=${this.state.query}
					placeholder="Filter"
					autocomplete="off"
					autofocus
				/>
				<ul class="switcher-list">
					${items}
				</ul>
			</form>
		`;
    }
}



function $142bbba13add3ea5$var$encodeContentDisposition(filename) {
    // Encode filename according to RFC 5987 if necessary. Note,
    // encodeURIComponent will percent-encode a superset of attr-char.
    let encodedFilename = encodeURIComponent(filename);
    if (encodedFilename === filename) return 'attachment; filename="' + filename + '"';
    else return "attachment; filename*=UTF-8''" + encodedFilename;
}
class $142bbba13add3ea5$export$2e2bcd8739ae039 extends (0, $b2a774aae58c7b4e$export$16fa2f45be04daa8) {
    state = {
        text: ""
    };
    textInput = (0, $b2a774aae58c7b4e$export$7d1e3a5e95ceca43)();
    lastAutocomplete = null;
    constructor(props){
        super(props);
        this.handleInput = this.handleInput.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputKeyDown = this.handleInputKeyDown.bind(this);
        this.handleInputPaste = this.handleInputPaste.bind(this);
        this.handleWindowKeyDown = this.handleWindowKeyDown.bind(this);
        this.handleWindowPaste = this.handleWindowPaste.bind(this);
    }
    handleInput(event) {
        this.setState({
            [event.target.name]: event.target.value
        });
        if (this.props.readOnly && event.target.name === "text" && !event.target.value) event.target.blur();
    }
    handleSubmit(event) {
        event.preventDefault();
        this.props.onSubmit(this.state.text);
        this.setState({
            text: ""
        });
    }
    handleInputKeyDown(event) {
        let input = event.target;
        if (!this.props.autocomplete || event.key !== "Tab") return;
        if (input.selectionStart !== input.selectionEnd) return;
        event.preventDefault();
        let carretPos = input.selectionStart;
        let text = this.state.text;
        let autocomplete;
        if (this.lastAutocomplete && this.lastAutocomplete.text === text && this.lastAutocomplete.carretPos === carretPos) autocomplete = this.lastAutocomplete;
        else {
            this.lastAutocomplete = null;
            let wordStart;
            for(wordStart = carretPos - 1; wordStart >= 0; wordStart--){
                if (text[wordStart] === " ") break;
            }
            wordStart++;
            let wordEnd;
            for(wordEnd = carretPos; wordEnd < text.length; wordEnd++){
                if (text[wordEnd] === " ") break;
            }
            let word = text.slice(wordStart, wordEnd);
            if (!word) return;
            let replacements = this.props.autocomplete(word);
            if (replacements.length === 0) return;
            autocomplete = {
                text: text,
                carretPos: input.selectionStart,
                prefix: text.slice(0, wordStart),
                suffix: text.slice(wordEnd),
                replacements: replacements,
                replIndex: -1
            };
        }
        let n = autocomplete.replacements.length;
        if (event.shiftKey) autocomplete.replIndex--;
        else autocomplete.replIndex++;
        autocomplete.replIndex = (autocomplete.replIndex + n) % n;
        let repl = autocomplete.replacements[autocomplete.replIndex];
        if (!autocomplete.prefix && !autocomplete.suffix) {
            if (repl.startsWith("/")) repl += " ";
            else repl += ": ";
        }
        autocomplete.text = autocomplete.prefix + repl + autocomplete.suffix;
        autocomplete.carretPos = autocomplete.prefix.length + repl.length;
        input.value = autocomplete.text;
        input.selectionStart = autocomplete.carretPos;
        input.selectionEnd = input.selectionStart;
        this.lastAutocomplete = autocomplete;
        this.setState({
            text: autocomplete.text
        });
    }
    async handleInputPaste(event) {
        let client = this.props.client;
        if (!event.clipboardData.files.length || !client || this.props.readOnly) return;
        let endpoint = client.isupport.filehost();
        if (!endpoint) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        // TODO: support more than one file
        let file = event.clipboardData.files.item(0);
        let auth;
        if (client.params.saslPlain) {
            let params = client.params.saslPlain;
            auth = "Basic " + btoa(params.username + ":" + params.password);
        } else if (client.params.saslOauthBearer) auth = "Bearer " + client.params.saslOauthBearer.token;
        let headers = {
            "Content-Length": file.size,
            "Content-Disposition": $142bbba13add3ea5$var$encodeContentDisposition(file.name)
        };
        if (file.type) headers["Content-Type"] = file.type;
        if (auth) headers["Authorization"] = auth;
        // TODO: show a loading UI while uploading
        // TODO: show a cancel button
        let resp = await fetch(endpoint, {
            method: "POST",
            body: file,
            headers: headers,
            credentials: "include"
        });
        if (!resp.ok) throw new Error(`HTTP request failed (${resp.status})`);
        let loc = resp.headers.get("Location");
        if (!loc) throw new Error("filehost response missing Location header field");
        let uploadURL = new URL(loc, endpoint);
        this.setState((state)=>{
            if (state.text) return {
                text: state.text + " " + uploadURL.toString()
            };
            else return {
                text: uploadURL.toString()
            };
        });
    }
    handleWindowKeyDown(event) {
        // If an <input> or <button> is focused, ignore.
        if (document.activeElement && document.activeElement !== document.body) switch(document.activeElement.tagName.toLowerCase()){
            case "section":
            case "a":
                break;
            default:
                return;
        }
        // If a modifier is pressed, reserve for key bindings.
        if (event.altKey || event.ctrlKey || event.metaKey) return;
        // Ignore events that don't produce a Unicode string. If the key event
        // result in a character being typed by the user, KeyboardEvent.key
        // will contain the typed string. The key string may contain one
        // Unicode non-control character and multiple Unicode combining
        // characters. String.prototype.length cannot be used since it would
        // return the number of Unicode code-points. Instead, the spread
        // operator is used to count the number of non-combining Unicode
        // characters.
        if ([
            ...event.key
        ].length !== 1) return;
        if (this.state.text) return;
        if (this.props.readOnly || this.props.commandOnly && event.key !== "/") return;
        event.preventDefault();
        this.setState({
            text: event.key
        }, ()=>{
            this.focus();
        });
    }
    handleWindowPaste(event) {
        // If an <input> is focused, ignore.
        if (document.activeElement !== document.body && document.activeElement.tagName !== "SECTION") return;
        if (this.props.readOnly) return;
        if (!this.textInput.current) return;
        if (event.clipboardData.files.length > 0) {
            this.handleInputPaste(event);
            return;
        }
        let text = event.clipboardData.getData("text");
        event.preventDefault();
        event.stopImmediatePropagation();
        this.textInput.current.focus();
        this.textInput.current.setRangeText(text, undefined, undefined, "end");
        this.setState({
            text: this.textInput.current.value
        });
    }
    componentDidMount() {
        window.addEventListener("keydown", this.handleWindowKeyDown);
        window.addEventListener("paste", this.handleWindowPaste);
    }
    componentWillUnmount() {
        window.removeEventListener("keydown", this.handleWindowKeyDown);
        window.removeEventListener("paste", this.handleWindowPaste);
    }
    focus() {
        if (!this.textInput.current) return;
        document.activeElement.blur(); // in case we're read-only
        this.textInput.current.focus();
    }
    render() {
        let className = "";
        if (this.props.readOnly && !this.state.text) className = "read-only";
        let placeholder = "Type a message";
        if (this.props.commandOnly) placeholder = "Type a command (see /help)";
        return (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
			<form
				id="composer"
				class=${className}
				onInput=${this.handleInput}
				onSubmit=${this.handleSubmit}
			>
				<input
					type="text"
					name="text"
					ref=${this.textInput}
					value=${this.state.text}
					autocomplete="off"
					placeholder=${placeholder}
					enterkeyhint="send"
					onKeyDown=${this.handleInputKeyDown}
					onPaste=${this.handleInputPaste}
					maxlength=${this.props.maxLen}
				/>
			</form>
		`;
    }
}



let $9ead1202cd2221f9$var$store = new Map();
class $9ead1202cd2221f9$export$2e2bcd8739ae039 extends (0, $b2a774aae58c7b4e$export$16fa2f45be04daa8) {
    constructor(props){
        super(props);
        this.handleScroll = this.handleScroll.bind(this);
    }
    isAtBottom() {
        let target = this.props.target.current;
        return target.scrollTop >= target.scrollHeight - target.offsetHeight;
    }
    saveScrollPosition() {
        let target = this.props.target.current;
        let sticky = target.querySelectorAll(this.props.stickTo);
        let stickToKey = null;
        if (!this.isAtBottom()) for(let i = 0; i < sticky.length; i++){
            let el = sticky[i];
            if (el.offsetTop >= target.scrollTop + target.offsetTop) {
                stickToKey = el.dataset.key;
                break;
            }
        }
        $9ead1202cd2221f9$var$store.set(this.props.scrollKey, stickToKey);
    }
    restoreScrollPosition() {
        let target = this.props.target.current;
        if (!target.firstChild) return;
        let stickToKey = $9ead1202cd2221f9$var$store.get(this.props.scrollKey);
        if (!stickToKey) target.firstChild.scrollIntoView({
            block: "end"
        });
        else {
            let stickTo = target.querySelector('[data-key="' + stickToKey + '"]');
            if (stickTo) stickTo.scrollIntoView();
        }
        if (target.scrollTop == 0) this.props.onScrollTop();
    }
    handleScroll() {
        if (this.props.target.current.scrollTop == 0) this.props.onScrollTop();
    }
    componentDidMount() {
        this.restoreScrollPosition();
        this.props.target.current.addEventListener("scroll", this.handleScroll);
    }
    componentWillReceiveProps(nextProps) {
        if (this.props.scrollKey !== nextProps.scrollKey || this.props.children !== nextProps.children) this.saveScrollPosition();
    }
    componentDidUpdate(prevProps) {
        if (!this.props.target.current) return;
        this.restoreScrollPosition();
    }
    componentWillUnmount() {
        this.props.target.current.removeEventListener("scroll", this.handleScroll);
        this.saveScrollPosition();
    }
    render() {
        return this.props.children;
    }
}



class $676cb1384c20bf0e$export$2e2bcd8739ae039 extends (0, $b2a774aae58c7b4e$export$16fa2f45be04daa8) {
    body = (0, $b2a774aae58c7b4e$export$7d1e3a5e95ceca43)();
    constructor(props){
        super(props);
        this.handleCloseClick = this.handleCloseClick.bind(this);
        this.handleBackdropClick = this.handleBackdropClick.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
    }
    dismiss() {
        this.props.onDismiss();
    }
    handleCloseClick(event) {
        event.preventDefault();
        this.dismiss();
    }
    handleBackdropClick(event) {
        if (event.target.className == "dialog") this.dismiss();
    }
    handleKeyDown(event) {
        if (event.key == "Escape") this.dismiss();
    }
    componentDidMount() {
        window.addEventListener("keydown", this.handleKeyDown);
        let autofocus = this.body.current.querySelector("input[autofocus]");
        if (autofocus) autofocus.focus();
    }
    componentWillUnmount() {
        window.removeEventListener("keydown", this.handleKeyDown);
    }
    render() {
        return (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
			<div class="dialog" onClick=${this.handleBackdropClick}>
				<div class="dialog-body" ref=${this.body}>
					<div class="dialog-header">
						<h2>${this.props.title}</h2>
						<button class="dialog-close" onClick=${this.handleCloseClick}>×</button>
					</div>
					${this.props.children}
				</div>
			</div>
		`;
    }
}








const $5c2a91b7f6173cd8$var$baseConfig = {
    server: {}
};
const $5c2a91b7f6173cd8$var$configPromise = fetch("./config.json").then((resp)=>{
    if (resp.ok) return resp.json();
    if (resp.status !== 404) console.error("Failed to fetch config: HTTP error:", resp.status, resp.statusText);
    return {};
}).catch((err)=>{
    console.error("Failed to fetch config:", err);
    return {};
}).then((config)=>{
    return {
        ...$5c2a91b7f6173cd8$var$baseConfig,
        ...config
    };
});
const $5c2a91b7f6173cd8$var$CHATHISTORY_MAX_SIZE = 4000;
function $5c2a91b7f6173cd8$var$isProduction() {
    // NODE_ENV is set by the Parcel build system
    try {
        return true;
    } catch (err) {
        return false;
    }
}
function $5c2a91b7f6173cd8$var$parseQueryString() {
    let query = window.location.search.substring(1);
    let params = {};
    query.split("&").forEach((s)=>{
        if (!s) return;
        let pair = s.split("=");
        params[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || "");
    });
    return params;
}
function $5c2a91b7f6173cd8$var$splitHostPort(str) {
    let host = str;
    let port = null;
    // Literal IPv6 addresses contain colons and are enclosed in square brackets
    let i = str.lastIndexOf(":");
    if (i > 0 && !str.endsWith("]")) {
        host = str.slice(0, i);
        port = parseInt(str.slice(i + 1), 10);
    }
    if (host.startsWith("[") && host.endsWith("]")) host = host.slice(1, host.length - 1);
    return {
        host: host,
        port: port
    };
}
function $5c2a91b7f6173cd8$var$fillConnectParams(params) {
    let host = window.location.host || "localhost:8080";
    let proto = "wss:";
    if (window.location.protocol != "https:") proto = "ws:";
    let path = window.location.pathname || "/";
    if (!window.location.host) path = "/";
    params = {
        ...params
    };
    if (!params.url) params.url = proto + "//" + host + path + "socket";
    if (params.url.startsWith("/")) params.url = proto + "//" + host + params.url;
    if (params.url.indexOf("://") < 0) params.url = proto + "//" + params.url;
    if (!params.username) params.username = params.nick;
    if (!params.realname) params.realname = params.nick;
    return params;
}
function $5c2a91b7f6173cd8$var$showNotification(title, options) {
    if (!window.Notification || Notification.permission !== "granted") return null;
    // This can still fail due to:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=481856
    try {
        return new Notification(title, options);
    } catch (err) {
        console.error("Failed to show notification: ", err);
        return null;
    }
}
function $5c2a91b7f6173cd8$var$getReceipt(stored, type) {
    if (!stored || !stored.receipts) return null;
    return stored.receipts[(0, $fca64bf918d5638f$export$c49c54eaac29b59a).READ];
}
function $5c2a91b7f6173cd8$var$getLatestReceipt(bufferStore, server, type) {
    let buffers = bufferStore.list(server);
    let last = null;
    for (let buf of buffers){
        if (buf.name === "*") continue;
        let receipt = $5c2a91b7f6173cd8$var$getReceipt(buf, type);
        if ((0, $fca64bf918d5638f$export$4f7e80d679306a83)(last, receipt)) last = receipt;
    }
    return last;
}
let $5c2a91b7f6173cd8$var$lastErrorID = 0;
class $5c2a91b7f6173cd8$export$2e2bcd8739ae039 extends (0, $b2a774aae58c7b4e$export$16fa2f45be04daa8) {
    state = {
        ...(0, $fca64bf918d5638f$export$7254cc27399e90bd).create(),
        connectParams: {
            url: null,
            pass: null,
            username: null,
            realname: null,
            nick: null,
            saslPlain: null,
            saslExternal: false,
            autoconnect: false,
            autojoin: [],
            ping: 0
        },
        connectForm: true,
        loading: true,
        dialog: null,
        dialogData: null,
        error: null,
        openPanels: {
            bufferList: false,
            memberList: false
        }
    };
    debug = !$5c2a91b7f6173cd8$var$isProduction();
    config = {
        ...$5c2a91b7f6173cd8$var$baseConfig
    };
    clients = new Map();
    endOfHistory = new Map();
    receipts = new Map();
    buffer = (0, $b2a774aae58c7b4e$export$7d1e3a5e95ceca43)();
    composer = (0, $b2a774aae58c7b4e$export$7d1e3a5e95ceca43)();
    switchToChannel = null;
    /**
	 * Parsed irc:// URL to automatically open. The user will be prompted for
	 * confirmation for security reasons.
	 */ autoOpenURL = null;
    messageNotifications = new Set();
    baseTitle = null;
    lastFocusPingDate = null;
    constructor(props){
        super(props);
        this.handleConnectSubmit = this.handleConnectSubmit.bind(this);
        this.handleJoinSubmit = this.handleJoinSubmit.bind(this);
        this.handleBufferListClick = this.handleBufferListClick.bind(this);
        this.handleBufferListClose = this.handleBufferListClose.bind(this);
        this.toggleBufferList = this.toggleBufferList.bind(this);
        this.toggleMemberList = this.toggleMemberList.bind(this);
        this.handleComposerSubmit = this.handleComposerSubmit.bind(this);
        this.handleChannelClick = this.handleChannelClick.bind(this);
        this.handleNickClick = this.handleNickClick.bind(this);
        this.autocomplete = this.autocomplete.bind(this);
        this.handleBufferScrollTop = this.handleBufferScrollTop.bind(this);
        this.dismissDialog = this.dismissDialog.bind(this);
        this.handleAddNetworkClick = this.handleAddNetworkClick.bind(this);
        this.handleNetworkSubmit = this.handleNetworkSubmit.bind(this);
        this.handleNetworkRemove = this.handleNetworkRemove.bind(this);
        this.handleDismissError = this.handleDismissError.bind(this);
        this.handleAuthSubmit = this.handleAuthSubmit.bind(this);
        this.handleRegisterSubmit = this.handleRegisterSubmit.bind(this);
        this.handleVerifyClick = this.handleVerifyClick.bind(this);
        this.handleVerifySubmit = this.handleVerifySubmit.bind(this);
        this.handleOpenSettingsClick = this.handleOpenSettingsClick.bind(this);
        this.handleSettingsChange = this.handleSettingsChange.bind(this);
        this.handleSettingsDisconnect = this.handleSettingsDisconnect.bind(this);
        this.handleSwitchSubmit = this.handleSwitchSubmit.bind(this);
        this.handleWindowFocus = this.handleWindowFocus.bind(this);
        this.state.settings = {
            ...this.state.settings,
            ...$740325ae3fd2006f$export$a5a6e0b888b2c992.load()
        };
        this.bufferStore = new $740325ae3fd2006f$export$a143d493d941bafc();
        $5c2a91b7f6173cd8$var$configPromise.then((config)=>{
            this.handleConfig(config);
            return config;
        });
    }
    /**
	 * Handle configuration data and populate the connection parameters.
	 *
	 * The priority order is:
	 *
	 * - URL params
	 * - Saved parameters in local storage
	 * - Configuration data (fetched from the config.json file)
	 * - Default server URL constructed from the current URL location (this is
	 *   done in fillConnectParams)
	 */ async handleConfig(config) {
        let connectParams = {
            ...this.state.connectParams
        };
        if (typeof config.server.url === "string") connectParams.url = config.server.url;
        if (Array.isArray(config.server.autojoin)) connectParams.autojoin = config.server.autojoin;
        else if (typeof config.server.autojoin === "string") connectParams.autojoin = [
            config.server.autojoin
        ];
        if (typeof config.server.nick === "string") connectParams.nick = config.server.nick;
        if (typeof config.server.autoconnect === "boolean") connectParams.autoconnect = config.server.autoconnect;
        if (config.server.auth === "external") connectParams.saslExternal = true;
        if (typeof config.server.ping === "number") connectParams.ping = config.server.ping;
        if (connectParams.autoconnect && config.server.auth === "mandatory") {
            console.error('Error in config.json: cannot set server.autoconnect = true and server.auth = "mandatory"');
            connectParams.autoconnect = false;
        }
        if (config.server.auth === "oauth2" && (!config.oauth2 || !config.oauth2.url || !config.oauth2.client_id)) {
            console.error('Error in config.json: server.auth = "oauth2" requires oauth2 settings');
            config.server.auth = null;
        }
        let autoconnect = $740325ae3fd2006f$export$3b637ec8b5dd5146.load();
        if (autoconnect) connectParams = {
            ...connectParams,
            ...autoconnect,
            autoconnect: true,
            autojoin: []
        };
        let autojoin = [];
        let queryParams = $5c2a91b7f6173cd8$var$parseQueryString();
        // Don't allow to silently override the server URL if there's one in
        // config.json, because this has security implications. But still allow
        // setting server to an empty string to reveal the server field in the
        // connect form.
        if (typeof queryParams.server === "string" && (!connectParams.url || !queryParams.server)) {
            connectParams.url = queryParams.server;
            // When using a custom server, some configuration options don't
            // make sense anymore.
            config.server.auth = null;
        }
        if (typeof queryParams.nick === "string") connectParams.nick = queryParams.nick;
        if (typeof queryParams.channels === "string") autojoin = queryParams.channels.split(",");
        if (typeof queryParams.open === "string") this.autoOpenURL = $bd3c59ab25aed5ca$export$4b3d9a5bae55976(queryParams.open);
        if (queryParams.debug === "1") this.debug = true;
        if (window.location.hash) autojoin = window.location.hash.split(",");
        this.config = config;
        if (!connectParams.nick && connectParams.autoconnect) connectParams.nick = "user-*";
        if (connectParams.nick && connectParams.nick.includes("*")) {
            let savedNick = localStorage.getItem("titan_chat_nick");
            if (savedNick) connectParams.nick = savedNick;
            else {
                // No saved nick — show the form so the user can pick their name
                connectParams.autoconnect = false;
                let placeholder = Math.random().toString(36).substr(2, 7);
                connectParams.nick = connectParams.nick.replace("*", placeholder);
            }
        }
        if (config.server.auth === "oauth2" && !connectParams.saslOauthBearer) {
            if (queryParams.error) {
                console.error("OAuth 2.0 authorization failed: ", queryParams.error);
                this.showError("Authentication failed: " + (queryParams.error_description || queryParams.error));
                return;
            }
            if (!queryParams.code) {
                this.redirectOauth2Authorize();
                return;
            }
            // Strip code from query params, to prevent page refreshes from
            // trying to exchange the code again
            let url = new URL(window.location.toString());
            url.searchParams.delete("code");
            url.searchParams.delete("state");
            window.history.replaceState(null, "", url.toString());
            let saslOauthBearer;
            try {
                saslOauthBearer = await this.exchangeOauth2Code(queryParams.code);
            } catch (err) {
                this.showError(err);
                return;
            }
            connectParams.saslOauthBearer = saslOauthBearer;
            if (saslOauthBearer.username && !connectParams.nick) connectParams.nick = saslOauthBearer.username;
        }
        if (autojoin.length > 0) {
            if (connectParams.autoconnect) // Ask the user whether they want to join that new channel.
            // TODO: support multiple channels here
            this.autoOpenURL = {
                host: "",
                entity: autojoin[0]
            };
            else connectParams.autojoin = autojoin;
        }
        this.setState({
            loading: false,
            connectParams: connectParams
        });
        if (connectParams.autoconnect) {
            this.setState({
                connectForm: false
            });
            this.connect(connectParams);
        }
    }
    async redirectOauth2Authorize() {
        let serverMetadata;
        try {
            serverMetadata = await $572a887a57d3418e$export$9326d7767c1b7bbc(this.config.oauth2.url);
        } catch (err) {
            console.error("Failed to fetch OAuth 2.0 server metadata:", err);
            this.showError("Failed to fetch OAuth 2.0 server metadata");
            return;
        }
        $572a887a57d3418e$export$425e62132119a96f({
            serverMetadata: serverMetadata,
            clientId: this.config.oauth2.client_id,
            redirectUri: window.location.toString(),
            scope: this.config.oauth2.scope
        });
    }
    async exchangeOauth2Code(code) {
        let serverMetadata = await $572a887a57d3418e$export$9326d7767c1b7bbc(this.config.oauth2.url);
        let redirectUri = new URL(window.location.toString());
        redirectUri.searchParams.delete("code");
        redirectUri.searchParams.delete("state");
        let data = await $572a887a57d3418e$export$97e44d582df4b68f({
            serverMetadata: serverMetadata,
            redirectUri: redirectUri.toString(),
            code: code,
            clientId: this.config.oauth2.client_id,
            clientSecret: this.config.oauth2.client_secret
        });
        // TODO: handle expires_in/refresh_token
        let token = data.access_token;
        let username = null;
        if (serverMetadata.introspection_endpoint) try {
            let data = await $572a887a57d3418e$export$e03aeda7cfb66622({
                serverMetadata: serverMetadata,
                token: token,
                clientId: this.config.oauth2.client_id,
                clientSecret: this.config.oauth2.client_secret
            });
            username = data.username;
        } catch (err) {
            console.warn("Failed to introspect OAuth 2.0 token:", err);
        }
        return {
            token: token,
            username: username
        };
    }
    showError(err) {
        console.error("App error: ", err);
        let text;
        if (err instanceof Error) {
            let l = [];
            while(err){
                l.push(err.message);
                err = err.cause;
            }
            text = l.join(": ");
        } else text = String(err);
        this.setState({
            error: text
        });
        $5c2a91b7f6173cd8$var$lastErrorID++;
        return $5c2a91b7f6173cd8$var$lastErrorID;
    }
    dismissError(id) {
        if (id && id !== $5c2a91b7f6173cd8$var$lastErrorID) return;
        this.setState({
            error: null
        });
    }
    handleDismissError(event) {
        event.preventDefault();
        this.dismissError();
    }
    setServerState(id, updater, callback) {
        this.setState((state)=>{
            return (0, $fca64bf918d5638f$export$7254cc27399e90bd).updateServer(state, id, updater);
        }, callback);
    }
    setBufferState(id, updater, callback) {
        this.setState((state)=>{
            return (0, $fca64bf918d5638f$export$7254cc27399e90bd).updateBuffer(state, id, updater);
        }, callback);
    }
    syncBufferUnread(serverID, name) {
        let client = this.clients.get(serverID);
        let stored = this.bufferStore.get({
            name: name,
            server: client.params
        });
        if (client.caps.enabled.has("draft/chathistory") && stored) this.setBufferState({
            server: serverID,
            name: name
        }, {
            unread: stored.unread
        }, ()=>{
            this.updateDocumentTitle();
        });
        this.bufferStore.put({
            name: name,
            server: client.params,
            closed: false
        });
    }
    createBuffer(serverID, name) {
        let client = this.clients.get(serverID);
        let id = null;
        let isNew = false;
        this.setState((state)=>{
            let updated;
            [id, updated] = (0, $fca64bf918d5638f$export$7254cc27399e90bd).createBuffer(state, name, serverID, client);
            isNew = !!updated;
            return updated;
        });
        if (isNew) this.syncBufferUnread(serverID, name);
        return id;
    }
    sendReadReceipt(client, storedBuffer) {
        if (!client.supportsReadMarker()) return;
        let readReceipt = storedBuffer.receipts[(0, $fca64bf918d5638f$export$c49c54eaac29b59a).READ];
        if (storedBuffer.name === "*" || !readReceipt) return;
        client.setReadMarker(storedBuffer.name, readReceipt.time);
    }
    switchBuffer(id) {
        let buf;
        this.setState((state)=>{
            buf = (0, $fca64bf918d5638f$export$7254cc27399e90bd).getBuffer(state, id);
            if (!buf) return;
            let client = this.clients.get(buf.server);
            let stored = this.bufferStore.get({
                name: buf.name,
                server: client.params
            });
            let prevReadReceipt = $5c2a91b7f6173cd8$var$getReceipt(stored, (0, $fca64bf918d5638f$export$c49c54eaac29b59a).READ);
            let update = (0, $fca64bf918d5638f$export$7254cc27399e90bd).updateBuffer(state, buf.id, {
                prevReadReceipt: prevReadReceipt
            });
            return {
                activeBuffer: buf.id,
                ...update
            };
        }, ()=>{
            if (!buf) return;
            if (this.buffer.current) this.buffer.current.focus();
            let server = this.state.servers.get(buf.server);
            if (buf.type === (0, $fca64bf918d5638f$export$a9b603917c4d9863).NICK && !server.users.has(buf.name)) this.whoUserBuffer(buf.name, buf.server);
            if (buf.type === (0, $fca64bf918d5638f$export$a9b603917c4d9863).CHANNEL && !buf.hasInitialWho) this.whoChannelBuffer(buf.name, buf.server);
            this.updateDocumentTitle();
        });
        // TODO: only mark as read if user scrolled at the bottom
        this.markBufferAsRead(id);
    }
    markBufferAsRead(id) {
        let buf;
        this.setState((state)=>{
            buf = (0, $fca64bf918d5638f$export$7254cc27399e90bd).getBuffer(state, id);
            if (!buf) return;
            return (0, $fca64bf918d5638f$export$7254cc27399e90bd).updateBuffer(state, buf.id, {
                unread: (0, $fca64bf918d5638f$export$9be0a2424da959ae).NONE
            });
        }, ()=>{
            if (!buf) return;
            let client = this.clients.get(buf.server);
            for (let notif of this.messageNotifications)if (client.cm(notif.data.bufferName) === client.cm(buf.name)) notif.close();
            if (buf.messages.length > 0) {
                let lastMsg = buf.messages[buf.messages.length - 1];
                let stored = {
                    name: buf.name,
                    server: client.params,
                    unread: (0, $fca64bf918d5638f$export$9be0a2424da959ae).NONE,
                    receipts: {
                        [(0, $fca64bf918d5638f$export$c49c54eaac29b59a).READ]: (0, $fca64bf918d5638f$export$1274528beb7cd977)(lastMsg)
                    }
                };
                if (this.bufferStore.put(stored)) this.sendReadReceipt(client, stored);
            }
            this.updateDocumentTitle();
        });
    }
    updateDocumentTitle() {
        let buf = (0, $fca64bf918d5638f$export$7254cc27399e90bd).getBuffer(this.state, this.state.activeBuffer);
        let server;
        if (buf) server = this.state.servers.get(buf.server);
        let bouncerNetwork;
        if (server.bouncerNetID) bouncerNetwork = this.state.bouncerNetworks.get(server.bouncerNetID);
        let numUnread = 0;
        for (let buffer of this.state.buffers.values())if ((0, $fca64bf918d5638f$export$9be0a2424da959ae).compare(buffer.unread, (0, $fca64bf918d5638f$export$9be0a2424da959ae).HIGHLIGHT) >= 0) numUnread++;
        let parts = [];
        if (buf && buf.type !== (0, $fca64bf918d5638f$export$a9b603917c4d9863).SERVER) parts.push(buf.name);
        if (bouncerNetwork) parts.push((0, $fca64bf918d5638f$export$53e73e095c2ac1e2)(server, bouncerNetwork));
        parts.push(this.baseTitle);
        let title = "";
        if (numUnread > 0) title = `(${numUnread}) `;
        title += parts.join(" \xb7 ");
        document.title = title;
    }
    prepareChatMessage(serverID, msg) {
        // Treat server-wide broadcasts as highlights. They're sent by server
        // operators and can contain important information.
        if (msg.isHighlight === undefined) {
            let client = this.clients.get(serverID);
            msg.isHighlight = $bd3c59ab25aed5ca$export$fdd47ba7a4ecfeff(msg, client.nick, client.cm) || $bd3c59ab25aed5ca$export$8b29011f3cb5e124(msg);
        }
        if (!msg.tags) // Can happen for outgoing messages for instance
        msg.tags = {};
        if (!msg.tags.time) msg.tags.time = $bd3c59ab25aed5ca$export$3ae94a2503e890a1(new Date());
    }
    addChatMessage(serverID, bufName, msg) {
        this.prepareChatMessage(serverID, msg);
        let bufID = {
            server: serverID,
            name: bufName
        };
        this.setState((state)=>(0, $fca64bf918d5638f$export$7254cc27399e90bd).addMessage(state, msg, bufID));
    }
    handleChatMessage(serverID, bufName, msg) {
        let client = this.clients.get(serverID);
        this.prepareChatMessage(serverID, msg);
        let stored = this.bufferStore.get({
            name: bufName,
            server: client.params
        });
        let deliveryReceipt = $5c2a91b7f6173cd8$var$getReceipt(stored, (0, $fca64bf918d5638f$export$c49c54eaac29b59a).DELIVERED);
        let readReceipt = $5c2a91b7f6173cd8$var$getReceipt(stored, (0, $fca64bf918d5638f$export$c49c54eaac29b59a).READ);
        let isDelivered = (0, $fca64bf918d5638f$export$23261bae4c963bb3)(msg, deliveryReceipt);
        let isRead = (0, $fca64bf918d5638f$export$23261bae4c963bb3)(msg, readReceipt);
        if (client.isMyNick(msg.prefix.name)) isRead = true;
        let msgUnread = (0, $fca64bf918d5638f$export$9be0a2424da959ae).NONE;
        if ((msg.command == "PRIVMSG" || msg.command == "NOTICE") && !isRead) {
            let target = msg.params[0];
            let text = msg.params[1];
            let kind;
            if (msg.isHighlight) {
                msgUnread = (0, $fca64bf918d5638f$export$9be0a2424da959ae).HIGHLIGHT;
                kind = "highlight";
            } else if (client.isMyNick(target)) {
                msgUnread = (0, $fca64bf918d5638f$export$9be0a2424da959ae).HIGHLIGHT;
                kind = "private message";
            } else msgUnread = (0, $fca64bf918d5638f$export$9be0a2424da959ae).MESSAGE;
            if (msgUnread == (0, $fca64bf918d5638f$export$9be0a2424da959ae).HIGHLIGHT && !isDelivered && !$bd3c59ab25aed5ca$export$60937d95e568734f(msg)) {
                let title = "New " + kind + " from " + msg.prefix.name;
                if (client.isChannel(bufName)) title += " in " + bufName;
                let notif = $5c2a91b7f6173cd8$var$showNotification(title, {
                    body: (0, $803ef401580605c5$export$6a0f863afc2134d8)(text),
                    requireInteraction: true,
                    tag: "msg,server=" + serverID + ",from=" + msg.prefix.name + ",to=" + bufName,
                    data: {
                        bufferName: bufName,
                        message: msg
                    }
                });
                if (notif) {
                    notif.addEventListener("click", ()=>{
                        // TODO: scroll to message
                        this.switchBuffer({
                            server: serverID,
                            name: bufName
                        });
                    });
                    notif.addEventListener("close", ()=>{
                        this.messageNotifications.delete(notif);
                    });
                    this.messageNotifications.add(notif);
                }
            }
        }
        if (msg.command === "INVITE" && client.isMyNick(msg.params[0])) {
            msgUnread = (0, $fca64bf918d5638f$export$9be0a2424da959ae).HIGHLIGHT;
            let channel = msg.params[1];
            let notif = new Notification("Invitation to " + channel, {
                body: msg.prefix.name + " has invited you to " + channel,
                requireInteraction: true,
                tag: "invite,server=" + serverID + ",from=" + msg.prefix.name + ",channel=" + channel,
                actions: [
                    {
                        action: "accept",
                        title: "Accept"
                    }
                ]
            });
            if (notif) notif.addEventListener("click", (event)=>{
                if (event.action === "accept") {
                    let stored = {
                        name: bufName,
                        server: client.params,
                        receipts: {
                            [(0, $fca64bf918d5638f$export$c49c54eaac29b59a).READ]: (0, $fca64bf918d5638f$export$1274528beb7cd977)(msg)
                        }
                    };
                    if (this.bufferStore.put(stored)) this.sendReadReceipt(client, stored);
                    this.open(channel, serverID);
                } else // TODO: scroll to message
                this.switchBuffer({
                    server: serverID,
                    name: bufName
                });
            });
        }
        // Open a new buffer if the message doesn't come from me or is a
        // self-message
        if ((!client.isMyNick(msg.prefix.name) || client.isMyNick(bufName)) && msg.command != "PART" && msg.comand != "QUIT" && msg.command != $bd3c59ab25aed5ca$export$b3c89fff1b2cdce3 && msg.command != $bd3c59ab25aed5ca$export$69132af27147d725) this.createBuffer(serverID, bufName);
        let bufID = {
            server: serverID,
            name: bufName
        };
        this.setState((state)=>(0, $fca64bf918d5638f$export$7254cc27399e90bd).addMessage(state, msg, bufID));
        this.setBufferState(bufID, (buf)=>{
            // TODO: set unread if scrolled up
            let unread = buf.unread;
            let prevReadReceipt = buf.prevReadReceipt;
            let receipts = {
                [(0, $fca64bf918d5638f$export$c49c54eaac29b59a).DELIVERED]: (0, $fca64bf918d5638f$export$1274528beb7cd977)(msg)
            };
            if (this.state.activeBuffer !== buf.id || !document.hasFocus()) unread = (0, $fca64bf918d5638f$export$9be0a2424da959ae).union(unread, msgUnread);
            else receipts[(0, $fca64bf918d5638f$export$c49c54eaac29b59a).READ] = (0, $fca64bf918d5638f$export$1274528beb7cd977)(msg);
            // Don't show unread marker for my own messages
            if (client.isMyNick(msg.prefix.name) && !(0, $fca64bf918d5638f$export$23261bae4c963bb3)(msg, prevReadReceipt)) prevReadReceipt = (0, $fca64bf918d5638f$export$1274528beb7cd977)(msg);
            let stored = {
                name: buf.name,
                server: client.params,
                unread: unread,
                receipts: receipts
            };
            if (this.bufferStore.put(stored)) this.sendReadReceipt(client, stored);
            return {
                unread: unread,
                prevReadReceipt: prevReadReceipt
            };
        }, ()=>{
            if (msgUnread === (0, $fca64bf918d5638f$export$9be0a2424da959ae).HIGHLIGHT) this.updateDocumentTitle();
        });
    }
    connect(params) {
        // Merge our previous connection params so that config options such as
        // the ping interval are applied
        params = {
            ...this.state.connectParams,
            ...params
        };
        let serverID = null;
        this.setState((state)=>{
            let update;
            [serverID, update] = (0, $fca64bf918d5638f$export$7254cc27399e90bd).createServer(state);
            return update;
        });
        this.setState({
            connectParams: params
        });
        let client = new (0, $6796cfbd59091fe3$export$2e2bcd8739ae039)({
            ...$5c2a91b7f6173cd8$var$fillConnectParams(params),
            eventPlayback: this.state.settings.bufferEvents !== (0, $fca64bf918d5638f$export$3ee12e3d13dfa897).HIDE
        });
        client.debug = this.debug;
        this.clients.set(serverID, client);
        this.setServerState(serverID, {
            status: client.status
        });
        let errorID = null;
        client.addEventListener("status", ()=>{
            this.setServerState(serverID, {
                status: client.status
            });
            switch(client.status){
                case (0, $6796cfbd59091fe3$export$2e2bcd8739ae039).Status.DISCONNECTED:
                    this.setServerState(serverID, {
                        account: null
                    });
                    this.setState((state)=>{
                        let buffers = new Map(state.buffers);
                        state.buffers.forEach((buf)=>{
                            if (buf.server !== serverID) return;
                            buffers.set(buf.id, {
                                ...buf,
                                joined: false
                            });
                        });
                        return {
                            buffers: buffers
                        };
                    });
                    break;
                case (0, $6796cfbd59091fe3$export$2e2bcd8739ae039).Status.REGISTERED:
                    this.setState({
                        connectForm: false
                    });
                    if (errorID) this.dismissError(errorID);
                    break;
            }
        });
        client.addEventListener("message", (event)=>{
            this.handleMessage(serverID, event.detail.message);
        });
        client.addEventListener("error", (event)=>{
            errorID = this.showError(event.detail);
        });
        this.createBuffer(serverID, (0, $fca64bf918d5638f$export$50f2960994553271));
        if (!this.state.activeBuffer) this.switchBuffer({
            server: serverID,
            name: (0, $fca64bf918d5638f$export$50f2960994553271)
        });
        if (params.autojoin.length > 0) this.switchToChannel = params.autojoin[0];
    }
    disconnect(serverID) {
        if (!serverID) serverID = (0, $fca64bf918d5638f$export$7254cc27399e90bd).getActiveServerID(this.state);
        let client = this.clients.get(serverID);
        if (client) {
            this.clients.delete(serverID);
            client.disconnect();
        }
    }
    reconnect(serverID) {
        if (!serverID) serverID = (0, $fca64bf918d5638f$export$7254cc27399e90bd).getActiveServerID(this.state);
        let client = this.clients.get(serverID);
        if (client) client.reconnect();
    }
    serverFromBouncerNetwork(bouncerNetworkID) {
        for (let [id, client] of this.clients){
            if (client.params.bouncerNetwork === bouncerNetworkID) return id;
        }
        return null;
    }
    routeMessage(serverID, msg) {
        let client = this.clients.get(serverID);
        let chatHistoryBatch = $bd3c59ab25aed5ca$export$f4751a564f6d84a3(msg, "chathistory");
        // Reply triggered by some command sent by us, not worth displaying to
        // the user
        if (msg.internal) return [];
        let target, channel, affectedBuffers;
        switch(msg.command){
            case "MODE":
                target = msg.params[0];
                if (client.isChannel(target)) return [
                    target
                ];
                return [
                    (0, $fca64bf918d5638f$export$50f2960994553271)
                ];
            case "NOTICE":
            case "PRIVMSG":
                target = msg.params[0];
                if (client.isMyNick(target)) {
                    if (client.cm(msg.prefix.name) === client.cm(client.serverPrefix.name)) target = (0, $fca64bf918d5638f$export$50f2960994553271);
                    else {
                        let context = msg.tags["+draft/channel-context"];
                        if (context && client.isChannel(context) && (0, $fca64bf918d5638f$export$7254cc27399e90bd).getBuffer(this.state, {
                            server: serverID,
                            name: context
                        })) target = context;
                        else target = msg.prefix.name;
                    }
                }
                let allowedPrefixes = client.isupport.statusMsg();
                if (allowedPrefixes) {
                    let parts = $bd3c59ab25aed5ca$export$4812b7165edd26af(target, allowedPrefixes);
                    if (client.isChannel(parts.name)) target = parts.name;
                }
                // Don't open a new buffer if this is just a NOTICE or a garbage
                // CTCP message
                let openNewBuffer = true;
                if (msg.command !== "PRIVMSG") openNewBuffer = false;
                else {
                    let ctcp = $bd3c59ab25aed5ca$export$60937d95e568734f(msg);
                    if (ctcp && ctcp.command !== "ACTION") openNewBuffer = false;
                }
                if (!openNewBuffer && !(0, $fca64bf918d5638f$export$7254cc27399e90bd).getBuffer(this.state, {
                    server: serverID,
                    name: target
                })) target = (0, $fca64bf918d5638f$export$50f2960994553271);
                return [
                    target
                ];
            case "JOIN":
                channel = msg.params[0];
                if (!client.isMyNick(msg.prefix.name)) return [
                    channel
                ];
                return [];
            case "PART":
                channel = msg.params[0];
                return [
                    channel
                ];
            case "KICK":
                channel = msg.params[0];
                return [
                    channel
                ];
            case "QUIT":
                affectedBuffers = [];
                if (chatHistoryBatch) affectedBuffers.push(chatHistoryBatch.params[0]);
                else this.state.buffers.forEach((buf)=>{
                    if (buf.server != serverID) return;
                    if (!buf.members.has(msg.prefix.name)) return;
                    affectedBuffers.push(buf.name);
                });
                return affectedBuffers;
            case "NICK":
                let newNick = msg.params[0];
                affectedBuffers = [];
                if (chatHistoryBatch) affectedBuffers.push(chatHistoryBatch.params[0]);
                else {
                    this.state.buffers.forEach((buf)=>{
                        if (buf.server != serverID) return;
                        if (!buf.members.has(msg.prefix.name)) return;
                        affectedBuffers.push(buf.name);
                    });
                    if (client.isMyNick(newNick)) {
                        affectedBuffers.push((0, $fca64bf918d5638f$export$50f2960994553271));
                        localStorage.setItem("titan_chat_nick", newNick);
                    }
                }
                return affectedBuffers;
            case "TOPIC":
                channel = msg.params[0];
                return [
                    channel
                ];
            case "INVITE":
                channel = msg.params[1];
                // TODO: find a more reliable way to do this
                let bufName = channel;
                if (!(0, $fca64bf918d5638f$export$7254cc27399e90bd).getBuffer(this.state, {
                    server: serverID,
                    name: channel
                })) bufName = (0, $fca64bf918d5638f$export$50f2960994553271);
                return [
                    bufName
                ];
            case $bd3c59ab25aed5ca$export$8e826dfe9edc5be1:
            case $bd3c59ab25aed5ca$export$110395ee82c419bd:
            case $bd3c59ab25aed5ca$export$cf24d3ab5a850c9f:
            case $bd3c59ab25aed5ca$export$edbdd9cee2ab5be8:
            case $bd3c59ab25aed5ca$export$a1ba792f52c3a77c:
            case $bd3c59ab25aed5ca$export$385b5d59fd211cdd:
            case $bd3c59ab25aed5ca$export$15ba3f1b034be103:
            case $bd3c59ab25aed5ca$export$1766db7a19d745c:
            case $bd3c59ab25aed5ca$export$903bdc290bba373b:
            case $bd3c59ab25aed5ca$export$e4ff1ea9594cfaf7:
                channel = msg.params[1];
                return [
                    channel
                ];
            case $bd3c59ab25aed5ca$export$6bc24f4e6578b579:
                channel = msg.params[2];
                return [
                    channel
                ];
            case $bd3c59ab25aed5ca$export$b3c89fff1b2cdce3:
            case $bd3c59ab25aed5ca$export$69132af27147d725:
                let targets = msg.params[1].split(",");
                affectedBuffers = [];
                for (let target of targets){
                    let prefix = $bd3c59ab25aed5ca$export$3059e96a5fe807c3(target);
                    affectedBuffers.push(prefix.name);
                }
                return affectedBuffers;
            case $bd3c59ab25aed5ca$export$533b33f42abb0931:
            case $bd3c59ab25aed5ca$export$31b0bce566d09826:
            case $bd3c59ab25aed5ca$export$1d0c7ae9b6b17819:
            case $bd3c59ab25aed5ca$export$cad5f2640c65ad1e:
            case $bd3c59ab25aed5ca$export$7e8b5ab33a021d11:
            case $bd3c59ab25aed5ca$export$cfb24fa60294f9b1:
            case $bd3c59ab25aed5ca$export$a675057415015158:
            case $bd3c59ab25aed5ca$export$c233ee342453910:
            case $bd3c59ab25aed5ca$export$b1fa6c92095fdab1:
            case $bd3c59ab25aed5ca$export$18c4a4c5c97dce9b:
            case $bd3c59ab25aed5ca$export$698923df90b7ea6d:
            case $bd3c59ab25aed5ca$export$cba31abc2138b15e:
            case $bd3c59ab25aed5ca$export$7304bc4447b68935:
            case "AWAY":
            case "SETNAME":
            case "CHGHOST":
            case "ACCOUNT":
            case "CAP":
            case "AUTHENTICATE":
            case "PING":
            case "PONG":
            case "BATCH":
            case "TAGMSG":
            case "CHATHISTORY":
            case "ACK":
            case "BOUNCER":
            case "MARKREAD":
                // Ignore these
                return [];
            default:
                return [
                    (0, $fca64bf918d5638f$export$50f2960994553271)
                ];
        }
    }
    handleMessage(serverID, msg) {
        let client = this.clients.get(serverID);
        if ($bd3c59ab25aed5ca$export$f4751a564f6d84a3(msg, "chathistory")) return; // Handled by the caller
        let destBuffers = this.routeMessage(serverID, msg);
        this.setState((state)=>(0, $fca64bf918d5638f$export$7254cc27399e90bd).handleMessage(state, msg, serverID, client));
        let target, channel;
        switch(msg.command){
            case $bd3c59ab25aed5ca$export$cac9ca3596de2b3a:
                this.fetchBacklog(serverID);
                {
                    let wc = this.clients.get(serverID);
                    if (wc) localStorage.setItem("titan_chat_nick", wc.nick);
                }
                break;
            case $bd3c59ab25aed5ca$export$cad5f2640c65ad1e:
            case $bd3c59ab25aed5ca$export$7e8b5ab33a021d11:
                // These messages are used to indicate the end of the ISUPPORT list
                // Restore opened channel and user buffers
                let join = [];
                for (let buf of this.bufferStore.list(client.params)){
                    if (buf.name === "*" || buf.closed) continue;
                    if (client.isChannel(buf.name)) {
                        if (client.caps.enabled.has("soju.im/bouncer-networks")) continue;
                        join.push(buf.name);
                    } else {
                        this.createBuffer(serverID, buf.name);
                        this.whoUserBuffer(buf.name, serverID);
                    }
                }
                // Auto-join channels given at connect-time
                let server = this.state.servers.get(serverID);
                let bouncerNetID = server.bouncerNetID;
                let bouncerNetwork = null;
                if (bouncerNetID) bouncerNetwork = this.state.bouncerNetworks.get(bouncerNetID);
                if (!bouncerNetwork || bouncerNetwork.state === "connected") {
                    join = join.concat(client.params.autojoin);
                    client.params.autojoin = [];
                }
                if (join.length > 0) client.send({
                    command: "JOIN",
                    params: [
                        join.join(",")
                    ]
                });
                let serverHost = bouncerNetwork ? bouncerNetwork.host : "";
                if (this.autoOpenURL && serverHost === this.autoOpenURL.host) {
                    this.openURL(this.autoOpenURL);
                    this.autoOpenURL = null;
                }
            case "JOIN":
                channel = msg.params[0];
                if (client.isMyNick(msg.prefix.name)) this.syncBufferUnread(serverID, channel);
                if (channel == this.switchToChannel) {
                    this.switchBuffer({
                        server: serverID,
                        name: channel
                    });
                    this.switchToChannel = null;
                }
                break;
            case "BOUNCER":
                if (msg.params[0] !== "NETWORK") break; // We're only interested in network updates
                if (client.isupport.bouncerNetID()) break;
                let id = msg.params[1];
                let attrs = null;
                if (msg.params[2] !== "*") attrs = $bd3c59ab25aed5ca$export$ede4b2e0172bbdb1(msg.params[2]);
                let isNew = false;
                this.setState((state)=>{
                    if (!attrs) return (0, $fca64bf918d5638f$export$7254cc27399e90bd).deleteBouncerNetwork(state, id);
                    else {
                        isNew = !state.bouncerNetworks.has(id);
                        return (0, $fca64bf918d5638f$export$7254cc27399e90bd).storeBouncerNetwork(state, id, attrs);
                    }
                }, ()=>{
                    if (!attrs) {
                        let serverID = this.serverFromBouncerNetwork(id);
                        if (serverID) this.close({
                            server: serverID,
                            name: (0, $fca64bf918d5638f$export$50f2960994553271)
                        });
                    } else if (isNew) this.connect({
                        ...client.params,
                        bouncerNetwork: id
                    });
                    if (attrs && attrs.state === "connected") {
                        let serverID = this.serverFromBouncerNetwork(id);
                        let client = this.clients.get(serverID);
                        if (client && client.status === (0, $6796cfbd59091fe3$export$2e2bcd8739ae039).Status.REGISTERED && client.params.autojoin && client.params.autojoin.length > 0) {
                            client.send({
                                command: "JOIN",
                                params: [
                                    client.params.autojoin.join(",")
                                ]
                            });
                            client.params.autojoin = [];
                        }
                    }
                });
                break;
            case "BATCH":
                if (!msg.params[0].startsWith("-")) break;
                let name = msg.params[0].slice(1);
                let batch = client.batches.get(name);
                if (!batch || batch.type !== "soju.im/bouncer-networks") break;
                // We've received a BOUNCER NETWORK batch. If we have a URL to
                // auto-open and no existing network matches it, ask the user to
                // create a new network.
                if (this.autoOpenURL && this.autoOpenURL.host && !this.findBouncerNetIDByHost(this.autoOpenURL.host)) {
                    this.openURL(this.autoOpenURL);
                    this.autoOpenURL = null;
                }
                break;
            case "MARKREAD":
                target = msg.params[0];
                let bound = msg.params[1];
                if (bound === "*" || !bound.startsWith("timestamp=")) break;
                let readReceipt = {
                    time: bound.replace("timestamp=", "")
                };
                let stored = this.bufferStore.get({
                    name: target,
                    server: client.params
                });
                if ((0, $fca64bf918d5638f$export$4f7e80d679306a83)(readReceipt, $5c2a91b7f6173cd8$var$getReceipt(stored, (0, $fca64bf918d5638f$export$c49c54eaac29b59a).READ))) break;
                for (let notif of this.messageNotifications){
                    if (client.cm(notif.data.bufferName) !== client.cm(target)) continue;
                    if ((0, $fca64bf918d5638f$export$23261bae4c963bb3)(notif.data.message, readReceipt)) notif.close();
                }
                let unread;
                let closed = true;
                this.setBufferState({
                    server: serverID,
                    name: target
                }, (buf)=>{
                    closed = false;
                    // Re-compute unread status
                    unread = (0, $fca64bf918d5638f$export$9be0a2424da959ae).NONE;
                    for(let i = buf.messages.length - 1; i >= 0; i--){
                        let msg = buf.messages[i];
                        if (msg.command !== "PRIVMSG" && msg.command !== "NOTICE") continue;
                        if ((0, $fca64bf918d5638f$export$23261bae4c963bb3)(msg, readReceipt)) break;
                        if (msg.isHighlight || client.isMyNick(buf.name)) {
                            unread = (0, $fca64bf918d5638f$export$9be0a2424da959ae).HIGHLIGHT;
                            break;
                        }
                        unread = (0, $fca64bf918d5638f$export$9be0a2424da959ae).MESSAGE;
                    }
                    return {
                        unread: unread
                    };
                }, ()=>{
                    this.bufferStore.put({
                        name: target,
                        server: client.params,
                        unread: unread,
                        closed: closed,
                        receipts: {
                            [(0, $fca64bf918d5638f$export$c49c54eaac29b59a).READ]: readReceipt
                        }
                    });
                    this.updateDocumentTitle();
                });
                break;
            default:
                if ($bd3c59ab25aed5ca$export$e6127cc7fe7395c3(msg.command) && msg.command != $bd3c59ab25aed5ca$export$7e8b5ab33a021d11) {
                    let description = msg.params[msg.params.length - 1];
                    this.showError(description);
                }
        }
        destBuffers.forEach((bufName)=>{
            this.handleChatMessage(serverID, bufName, msg);
        });
    }
    async fetchBacklog(serverID) {
        let client = this.clients.get(serverID);
        if (!client.caps.enabled.has("draft/chathistory")) return;
        if (client.caps.enabled.has("soju.im/bouncer-networks") && !client.params.bouncerNetwork) return;
        let lastReceipt = $5c2a91b7f6173cd8$var$getLatestReceipt(this.bufferStore, client.params, (0, $fca64bf918d5638f$export$c49c54eaac29b59a).DELIVERED);
        if (!lastReceipt) return;
        let now = $bd3c59ab25aed5ca$export$3ae94a2503e890a1(new Date());
        let targets = await client.fetchHistoryTargets(now, lastReceipt.time);
        targets.forEach(async (target)=>{
            let from = lastReceipt;
            let to = {
                time: now
            };
            // Maybe we've just received a READ update from the
            // server, avoid over-fetching history
            let stored = this.bufferStore.get({
                name: target.name,
                server: client.params
            });
            let readReceipt = $5c2a91b7f6173cd8$var$getReceipt(stored, (0, $fca64bf918d5638f$export$c49c54eaac29b59a).READ);
            if ((0, $fca64bf918d5638f$export$4f7e80d679306a83)(from, readReceipt)) from = readReceipt;
            // If we already have messages stored for the target,
            // fetch all messages we've missed
            let buf = (0, $fca64bf918d5638f$export$7254cc27399e90bd).getBuffer(this.state, {
                server: serverID,
                name: target.name
            });
            if (buf && buf.messages.length > 0) {
                let lastMsg = buf.messages[buf.messages.length - 1];
                from = (0, $fca64bf918d5638f$export$1274528beb7cd977)(lastMsg);
            }
            // Query read marker if this is a user (ie, we haven't received
            // the read marker as part of a JOIN burst)
            if (client.supportsReadMarker() && client.isNick(target.name)) client.fetchReadMarker(target.name);
            let result;
            try {
                result = await client.fetchHistoryBetween(target.name, from, to, $5c2a91b7f6173cd8$var$CHATHISTORY_MAX_SIZE);
            } catch (err) {
                console.error("Failed to fetch backlog for '" + target.name + "': ", err);
                this.showError("Failed to fetch backlog for '" + target.name + "'");
                return;
            }
            for (let msg of result.messages){
                let destBuffers = this.routeMessage(serverID, msg);
                for (let bufName of destBuffers)this.handleChatMessage(serverID, bufName, msg);
            }
        });
    }
    handleConnectSubmit(connectParams) {
        this.dismissError();
        if (connectParams.autoconnect) $740325ae3fd2006f$export$3b637ec8b5dd5146.put(connectParams);
        else $740325ae3fd2006f$export$3b637ec8b5dd5146.put(null);
        // Disconnect previous server, if any
        let activeBuffer = this.state.buffers.get(this.state.activeBuffer);
        if (activeBuffer) this.close(activeBuffer.server);
        this.connect(connectParams);
    }
    handleChannelClick(event) {
        let handled = this.openURL(event.target.href);
        if (handled) event.preventDefault();
    }
    findBouncerNetIDByHost(host) {
        for (let [id, bouncerNetwork] of this.state.bouncerNetworks){
            if (bouncerNetwork.host === host) return id;
        }
        return null;
    }
    openURL(url) {
        if (typeof url === "string") url = $bd3c59ab25aed5ca$export$4b3d9a5bae55976(url);
        if (!url) return false;
        let { host: host, port: port } = $5c2a91b7f6173cd8$var$splitHostPort(url.host);
        let serverID;
        if (!url.host) serverID = (0, $fca64bf918d5638f$export$7254cc27399e90bd).getActiveServerID(this.state);
        else {
            let bouncerNetID = this.findBouncerNetIDByHost(host);
            if (!bouncerNetID) {
                // Open dialog to create network if bouncer
                let client = this.clients.values().next().value;
                if (!client || !client.caps.enabled.has("soju.im/bouncer-networks")) return false;
                let params = {
                    host: host
                };
                if (typeof port === "number") params.port = port;
                this.openDialog("network", {
                    params: params,
                    autojoin: url.entity
                });
                return true;
            }
            for (let [id, server] of this.state.servers)if (server.bouncerNetID === bouncerNetID) {
                serverID = id;
                break;
            }
        }
        if (!serverID) return false;
        let buf = (0, $fca64bf918d5638f$export$7254cc27399e90bd).getBuffer(this.state, {
            server: serverID,
            name: url.entity || (0, $fca64bf918d5638f$export$50f2960994553271)
        });
        if (buf) this.switchBuffer(buf.id);
        else this.openDialog("join", {
            server: serverID,
            channel: url.entity
        });
        return true;
    }
    handleNickClick(nick) {
        this.open(nick);
    }
    whoUserBuffer(target, serverID) {
        let client = this.clients.get(serverID);
        client.who(target, {
            fields: [
                "flags",
                "hostname",
                "nick",
                "realname",
                "username",
                "account"
            ]
        });
        client.monitor(target);
        if (client.supportsReadMarker()) client.fetchReadMarker(target);
    }
    async whoChannelBuffer(target, serverID) {
        let client = this.clients.get(serverID);
        // Prevent multiple WHO commands for the same channel in parallel
        this.setBufferState({
            name: target,
            server: serverID
        }, {
            hasInitialWho: true
        });
        let hasInitialWho = false;
        try {
            await client.who(target, {
                fields: [
                    "flags",
                    "hostname",
                    "nick",
                    "realname",
                    "username",
                    "account"
                ]
            });
            hasInitialWho = true;
        } finally{
            this.setBufferState({
                name: target,
                server: serverID
            }, {
                hasInitialWho: hasInitialWho
            });
        }
    }
    open(target, serverID, password) {
        if (!serverID) serverID = (0, $fca64bf918d5638f$export$7254cc27399e90bd).getActiveServerID(this.state);
        let client = this.clients.get(serverID);
        if (client.isServer(target)) this.switchBuffer({
            server: serverID
        });
        else if (client.isChannel(target)) {
            this.switchToChannel = target;
            client.join(target, password).catch((err)=>{
                this.showError(err);
            });
        } else {
            this.whoUserBuffer(target, serverID);
            this.createBuffer(serverID, target);
            this.switchBuffer({
                server: serverID,
                name: target
            });
        }
    }
    close(id) {
        let buf = (0, $fca64bf918d5638f$export$7254cc27399e90bd).getBuffer(this.state, id);
        if (!buf) return;
        let client = this.clients.get(buf.server);
        switch(buf.type){
            case (0, $fca64bf918d5638f$export$a9b603917c4d9863).SERVER:
                this.setState((state)=>{
                    let buffers = new Map(state.buffers);
                    for (let [id, b] of state.buffers)if (b.server === buf.server) buffers.delete(id);
                    let activeBuffer = state.activeBuffer;
                    if (activeBuffer && state.buffers.get(activeBuffer).server === buf.server) {
                        if (buffers.size > 0) activeBuffer = buffers.keys().next().value;
                        else activeBuffer = null;
                    }
                    return {
                        buffers: buffers,
                        activeBuffer: activeBuffer
                    };
                });
                let disconnectAll = client && !client.params.bouncerNetwork && client.caps.enabled.has("soju.im/bouncer-networks");
                let isFirstServer = this.state.servers.keys().next().value === buf.server;
                this.disconnect(buf.server);
                this.setState((state)=>{
                    let servers = new Map(state.servers);
                    servers.delete(buf.server);
                    let connectForm = state.connectForm;
                    if (servers.size == 0) connectForm = true;
                    return {
                        servers: servers,
                        connectForm: connectForm
                    };
                });
                if (disconnectAll) {
                    for (let serverID of this.clients.keys())this.close({
                        server: serverID,
                        name: (0, $fca64bf918d5638f$export$50f2960994553271)
                    });
                    this.bufferStore.clear();
                } else this.bufferStore.clear(client.params);
                // TODO: only clear autoconnect if this server is stored there
                if (isFirstServer) $740325ae3fd2006f$export$3b637ec8b5dd5146.put(null);
                break;
            case (0, $fca64bf918d5638f$export$a9b603917c4d9863).CHANNEL:
                if (buf.joined) client.send({
                    command: "PART",
                    params: [
                        buf.name
                    ]
                });
            // fallthrough
            case (0, $fca64bf918d5638f$export$a9b603917c4d9863).NICK:
                if (this.state.activeBuffer === buf.id) this.switchBuffer({
                    name: (0, $fca64bf918d5638f$export$50f2960994553271)
                });
                this.setState((state)=>{
                    let buffers = new Map(state.buffers);
                    buffers.delete(buf.id);
                    return {
                        buffers: buffers
                    };
                });
                client.unmonitor(buf.name);
                this.bufferStore.put({
                    name: buf.name,
                    server: client.params,
                    closed: true
                });
                break;
        }
    }
    disconnectAll() {
        this.close(this.state.buffers.keys().next().value);
    }
    executeCommand(s) {
        let parts = s.split(" ");
        let name = parts[0].toLowerCase().slice(1);
        let args = parts.slice(1);
        let cmd = (0, $b5b0ab28313e6465$export$2e2bcd8739ae039)[name];
        if (!cmd) {
            this.showError(`Unknown command "${name}" (run "/help" to get a command list)`);
            return;
        }
        try {
            cmd.execute(this, args);
        } catch (error) {
            console.error(`Failed to execute command "${name}":`, error);
            this.showError(error.message);
        }
    }
    privmsg(target, text) {
        if (target == (0, $fca64bf918d5638f$export$50f2960994553271)) {
            this.showError("Cannot send message in server buffer");
            return;
        }
        let serverID = (0, $fca64bf918d5638f$export$7254cc27399e90bd).getActiveServerID(this.state);
        let client = this.clients.get(serverID);
        let msg = {
            command: "PRIVMSG",
            params: [
                target,
                text
            ]
        };
        client.send(msg);
        if (!client.caps.enabled.has("echo-message")) {
            msg.prefix = {
                name: client.nick
            };
            this.handleChatMessage(serverID, target, msg);
        }
    }
    handleComposerSubmit(text) {
        if (!text) return;
        if (text.startsWith("//")) text = text.slice(1);
        else if (text.startsWith("/")) {
            this.executeCommand(text);
            return;
        }
        let buf = this.state.buffers.get(this.state.activeBuffer);
        if (!buf) return;
        this.privmsg(buf.name, text);
    }
    handleBufferListClick(id) {
        this.switchBuffer(id);
        this.closeBufferList();
    }
    handleBufferListClose(id) {
        this.close(id);
        this.closeBufferList();
    }
    toggleBufferList() {
        this.setState((state)=>{
            let openPanels = {
                ...state.openPanels,
                bufferList: !state.openPanels.bufferList
            };
            return {
                openPanels: openPanels
            };
        });
    }
    toggleMemberList() {
        this.setState((state)=>{
            let openPanels = {
                ...state.openPanels,
                memberList: !state.openPanels.memberList
            };
            return {
                openPanels: openPanels
            };
        });
    }
    closeBufferList() {
        this.setState((state)=>{
            let openPanels = {
                ...state.openPanels,
                bufferList: false
            };
            return {
                openPanels: openPanels
            };
        });
    }
    closeMemberList() {
        this.setState((state)=>{
            let openPanels = {
                ...state.openPanels,
                memberList: false
            };
            return {
                openPanels: openPanels
            };
        });
    }
    handleJoinClick(buf) {
        switch(buf.type){
            case (0, $fca64bf918d5638f$export$a9b603917c4d9863).SERVER:
                this.openDialog("join", {
                    server: buf.server
                });
                break;
            case (0, $fca64bf918d5638f$export$a9b603917c4d9863).CHANNEL:
                let client = this.clients.get(buf.server);
                client.send({
                    command: "JOIN",
                    params: [
                        buf.name
                    ]
                });
                break;
        }
    }
    handleJoinSubmit(data) {
        this.open(data.channel, this.state.dialogData.server);
        this.dismissDialog();
    }
    autocomplete(prefix) {
        function fromList(l, prefix) {
            prefix = prefix.toLowerCase();
            let repl = [];
            for (let item of l)if (item.toLowerCase().startsWith(prefix)) repl.push(item);
            return repl;
        }
        if (prefix.startsWith("/")) {
            let repl = fromList(Object.keys((0, $b5b0ab28313e6465$export$2e2bcd8739ae039)), prefix.slice(1));
            return repl.map((cmd)=>"/" + cmd);
        }
        // TODO: consider using the CHANTYPES ISUPPORT token here
        if (prefix.startsWith("#")) {
            let chanNames = [];
            for (const buf of this.state.buffers.values())if (buf.name.startsWith("#")) chanNames.push(buf.name);
            return fromList(chanNames, prefix);
        }
        let buf = this.state.buffers.get(this.state.activeBuffer);
        if (!buf || !buf.members) return [];
        return fromList(buf.members.keys(), prefix);
    }
    openHelp() {
        this.openDialog("help");
    }
    async handleBufferScrollTop() {
        let buf = this.state.buffers.get(this.state.activeBuffer);
        if (!buf || buf.type == (0, $fca64bf918d5638f$export$a9b603917c4d9863).SERVER) return;
        let client = this.clients.get(buf.server);
        if (!client || !client.caps.enabled.has("draft/chathistory") || !client.caps.enabled.has("server-time")) return;
        if (this.endOfHistory.get(buf.id)) return;
        let before;
        if (buf.messages.length > 0) before = buf.messages[0].tags["time"];
        else before = $bd3c59ab25aed5ca$export$3ae94a2503e890a1(new Date());
        // Avoids sending multiple CHATHISTORY commands in parallel
        this.endOfHistory.set(buf.id, true);
        let limit = 100;
        if (client.caps.enabled.has("draft/event-playback")) limit = 200;
        let result = await client.fetchHistoryBefore(buf.name, before, limit);
        this.endOfHistory.set(buf.id, !result.more);
        if (result.messages.length > 0) {
            let msg = result.messages[result.messages.length - 1];
            let receipts = {
                [(0, $fca64bf918d5638f$export$c49c54eaac29b59a).DELIVERED]: (0, $fca64bf918d5638f$export$1274528beb7cd977)(msg)
            };
            if (this.state.activeBuffer === buf.id) receipts[(0, $fca64bf918d5638f$export$c49c54eaac29b59a).READ] = (0, $fca64bf918d5638f$export$1274528beb7cd977)(msg);
            let stored = {
                name: buf.name,
                server: client.params,
                receipts: receipts
            };
            if (this.bufferStore.put(stored)) this.sendReadReceipt(client, stored);
            this.setBufferState(buf, ({ prevReadReceipt: prevReadReceipt })=>{
                if (!(0, $fca64bf918d5638f$export$23261bae4c963bb3)(msg, prevReadReceipt)) prevReadReceipt = (0, $fca64bf918d5638f$export$1274528beb7cd977)(msg);
                return {
                    prevReadReceipt: prevReadReceipt
                };
            });
        }
        for (let msg of result.messages)this.addChatMessage(buf.server, buf.name, msg);
    }
    openDialog(name, data) {
        this.setState({
            dialog: name,
            dialogData: data
        });
    }
    dismissDialog() {
        this.setState({
            dialog: null,
            dialogData: null
        });
    }
    setDialogLoading(promise) {
        const setLoading = (loading)=>{
            this.setState((state)=>{
                return {
                    dialogData: {
                        ...state.dialogData,
                        loading: loading
                    }
                };
            });
        };
        setLoading(true);
        promise.finally(()=>setLoading(false));
    }
    handleAuthClick(serverID) {
        let client = this.clients.get(serverID);
        this.openDialog("auth", {
            username: client.nick
        });
    }
    handleAuthSubmit(username, password) {
        let serverID = (0, $fca64bf918d5638f$export$7254cc27399e90bd).getActiveServerID(this.state);
        let client = this.clients.get(serverID);
        let promise = client.authenticate("PLAIN", {
            username: username,
            password: password
        }).then(()=>{
            this.dismissDialog();
            let firstClient = this.clients.values().next().value;
            if (client !== firstClient) return;
            let autoconnect = $740325ae3fd2006f$export$3b637ec8b5dd5146.load();
            if (!autoconnect) return;
            console.log("Saving SASL PLAIN credentials");
            autoconnect = {
                ...autoconnect,
                saslPlain: {
                    username: username,
                    password: password
                }
            };
            $740325ae3fd2006f$export$3b637ec8b5dd5146.put(autoconnect);
        });
        this.setDialogLoading(promise);
    }
    handleRegisterClick(serverID) {
        let client = this.clients.get(serverID);
        let emailRequired = client.checkAccountRegistrationCap("email-required");
        this.openDialog("register", {
            emailRequired: emailRequired
        });
    }
    handleRegisterSubmit(email, password) {
        let serverID = (0, $fca64bf918d5638f$export$7254cc27399e90bd).getActiveServerID(this.state);
        let client = this.clients.get(serverID);
        // TODO: show registration status (pending/error) in dialog
        let promise = client.registerAccount(email, password).then((data)=>{
            this.dismissDialog();
            if (data.verificationRequired) this.handleVerifyClick(data.account, data.message);
            let firstClient = this.clients.values().next().value;
            if (client !== firstClient) return;
            let autoconnect = $740325ae3fd2006f$export$3b637ec8b5dd5146.load();
            if (!autoconnect) return;
            console.log("Saving account registration credentials");
            autoconnect = {
                ...autoconnect,
                saslPlain: {
                    username: data.account,
                    password: password
                }
            };
            $740325ae3fd2006f$export$3b637ec8b5dd5146.put(autoconnect);
        });
        this.setDialogLoading(promise);
    }
    handleVerifyClick(account, message) {
        this.openDialog("verify", {
            account: account,
            message: message
        });
    }
    handleVerifySubmit(code) {
        let serverID = (0, $fca64bf918d5638f$export$7254cc27399e90bd).getActiveServerID(this.state);
        let client = this.clients.get(serverID);
        // TODO: display verification status (pending/error) in dialog
        let promise = client.verifyAccount(this.state.dialogData.account, code).then(()=>{
            this.dismissDialog();
        });
        this.setDialogLoading(promise);
    }
    handleAddNetworkClick() {
        this.openDialog("network");
    }
    handleManageNetworkClick(serverID) {
        let server = this.state.servers.get(serverID);
        let bouncerNetID = server.bouncerNetID;
        let bouncerNetwork = this.state.bouncerNetworks.get(bouncerNetID);
        this.openDialog("network", {
            id: bouncerNetID,
            params: bouncerNetwork
        });
    }
    async handleNetworkSubmit(attrs, autojoin) {
        let client = this.clients.values().next().value;
        this.dismissDialog();
        if (this.state.dialogData && this.state.dialogData.id) {
            if (Object.keys(attrs).length == 0) return;
            client.send({
                command: "BOUNCER",
                params: [
                    "CHANGENETWORK",
                    this.state.dialogData.id,
                    $bd3c59ab25aed5ca$export$c27de7dba30c634a(attrs)
                ]
            });
        } else {
            attrs = {
                ...attrs,
                tls: "1"
            };
            let id = await client.createBouncerNetwork(attrs);
            if (!autojoin) return;
            // By this point, bouncer-networks-notify should've advertised
            // the new network
            let serverID = this.serverFromBouncerNetwork(id);
            let newClient = this.clients.get(serverID);
            newClient.params.autojoin = [
                autojoin
            ];
            this.switchToChannel = autojoin;
        }
    }
    handleNetworkRemove() {
        let client = this.clients.values().next().value;
        client.send({
            command: "BOUNCER",
            params: [
                "DELNETWORK",
                this.state.dialogData.id
            ]
        });
        this.dismissDialog();
    }
    handleOpenSettingsClick() {
        let showProtocolHandler = false;
        for (let [id, client] of this.clients)if (client.caps.enabled.has("soju.im/bouncer-networks")) {
            showProtocolHandler = true;
            break;
        }
        this.openDialog("settings", {
            showProtocolHandler: showProtocolHandler
        });
    }
    handleSettingsChange(settings) {
        $740325ae3fd2006f$export$a5a6e0b888b2c992.put(settings);
        this.setState({
            settings: settings
        });
    }
    handleSettingsDisconnect() {
        this.dismissDialog();
        this.disconnectAll();
    }
    handleSwitchSubmit(buf) {
        this.dismissDialog();
        if (buf) this.switchBuffer(buf);
    }
    handleWindowFocus() {
        if (this.state.activeBuffer) // TODO: only do this if scrolled at the bottom
        this.markBufferAsRead(this.state.activeBuffer);
        // When the user focuses gamja, send a PING to make sure we detect any
        // network errors ASAP
        let now = new Date();
        if (this.lastFocusPingDate && now.getTime() - this.lastFocusPingDate.getTime() < 15000) return;
        this.lastFocusPingDate = now;
        for (let client of this.clients.values())client.send({
            command: "PING",
            params: [
                "gamja"
            ]
        });
    }
    componentDidMount() {
        this.baseTitle = document.title;
        (0, $f6fdf5978ceb757f$export$de27182ff8187d6c)(this);
        window.addEventListener("focus", this.handleWindowFocus);
    }
    componentWillUnmount() {
        document.title = this.baseTitle;
        window.removeEventListener("focus", this.handleWindowFocus);
    }
    render() {
        if (this.state.loading) {
            let error = null;
            if (this.state.error) error = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`<form><p class="error-text">${this.state.error}</p></form>`;
            return (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`<section id="connect">${error}</section>`;
        }
        let activeBuffer = null, activeServer = null, activeBouncerNetwork = null;
        if (this.state.buffers.get(this.state.activeBuffer)) {
            activeBuffer = this.state.buffers.get(this.state.activeBuffer);
            activeServer = this.state.servers.get(activeBuffer.server);
            let bouncerNetID = activeServer.bouncerNetID;
            if (bouncerNetID) activeBouncerNetwork = this.state.bouncerNetworks.get(bouncerNetID);
        }
        let activeClient = null;
        if (activeBuffer) activeClient = this.clients.get(activeBuffer.server);
        if (this.state.connectForm) {
            let status = activeServer ? activeServer.status : (0, $fca64bf918d5638f$export$ac0b13ba2bbce4d5).DISCONNECTED;
            let connecting = status === (0, $fca64bf918d5638f$export$ac0b13ba2bbce4d5).CONNECTING || status === (0, $fca64bf918d5638f$export$ac0b13ba2bbce4d5).REGISTERING;
            return (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
				<section id="connect">
					<${0, $c6f536f0bcf4fccd$export$2e2bcd8739ae039}
						error=${this.state.error}
						params=${this.state.connectParams}
						auth=${this.config.server.auth}
						connecting=${connecting}
						onSubmit=${this.handleConnectSubmit}
					/>
				</section>
			`;
        }
        let bufferHeader = null;
        if (activeBuffer) {
            let activeUser = null;
            if (activeBuffer.type == (0, $fca64bf918d5638f$export$a9b603917c4d9863).NICK) activeUser = activeServer.users.get(activeBuffer.name);
            bufferHeader = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
				<section id="buffer-header">
					<${0, $94cb31469f63b35c$export$2e2bcd8739ae039}
						buffer=${activeBuffer}
						server=${activeServer}
						user=${activeUser}
						bouncerNetwork=${activeBouncerNetwork}
						onChannelClick=${this.handleChannelClick}
						onClose=${()=>this.close(activeBuffer)}
						onJoin=${()=>this.handleJoinClick(activeBuffer)}
						onReconnect=${()=>this.reconnect()}
						onAddNetwork=${this.handleAddNetworkClick}
						onManageNetwork=${()=>this.handleManageNetworkClick(activeBuffer.server)}
						onOpenSettings=${this.handleOpenSettingsClick}
					/>
				</section>
			`;
        }
        let memberList = null;
        if (activeBuffer && activeBuffer.type == (0, $fca64bf918d5638f$export$a9b603917c4d9863).CHANNEL) memberList = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
				<section
						id="member-list"
						class=${this.state.openPanels.memberList ? "expand" : ""}
				>
					<button
						class="expander"
						onClick=${this.toggleMemberList}
					>
						<span></span>
						<span></span>
					</button>
					<section>
						<section id="member-list-header">
							${activeBuffer.members.size} users
						</section>
						<${0, $15e0fa56cfe1c276$export$2e2bcd8739ae039}
							members=${activeBuffer.members}
							users=${activeServer.users}
							onNickClick=${this.handleNickClick}
						/>
					</section>
				</section>
			`;
        let dialog = null;
        let dialogData = this.state.dialogData || {};
        let dialogBody;
        switch(this.state.dialog){
            case "network":
                let isNew = !dialogData.id;
                let title = isNew ? "Add network" : "Edit network";
                dialog = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
				<${0, $676cb1384c20bf0e$export$2e2bcd8739ae039} title=${title} onDismiss=${this.dismissDialog}>
					<${0, $03b5941ba753e1f6$export$2e2bcd8739ae039}
						onSubmit=${this.handleNetworkSubmit}
						onRemove=${this.handleNetworkRemove}
						params=${dialogData.params}
						autojoin=${dialogData.autojoin}
						isNew=${isNew}
					/>
				</>
			`;
                break;
            case "help":
                dialog = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
				<${0, $676cb1384c20bf0e$export$2e2bcd8739ae039} title="Help" onDismiss=${this.dismissDialog}>
					<${0, $af9ce1e202e3524a$export$2e2bcd8739ae039}/>
				</>
			`;
                break;
            case "join":
                dialog = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
				<${0, $676cb1384c20bf0e$export$2e2bcd8739ae039} title="Join channel" onDismiss=${this.dismissDialog}>
					<${0, $b4b4b87f4b38722c$export$2e2bcd8739ae039} channel=${dialogData.channel} onSubmit=${this.handleJoinSubmit}/>
				</>
			`;
                break;
            case "auth":
                if (dialogData.loading) dialogBody = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`<p>Logging in…</p>`;
                else dialogBody = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
					<${0, $368ce7ef0e8c1c36$export$2e2bcd8739ae039} username=${dialogData.username} onSubmit=${this.handleAuthSubmit}/>
				`;
                dialog = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
				<${0, $676cb1384c20bf0e$export$2e2bcd8739ae039} title="Login to ${(0, $fca64bf918d5638f$export$53e73e095c2ac1e2)(activeServer, activeBouncerNetwork)}" onDismiss=${this.dismissDialog}>
					${dialogBody}
				</>
			`;
                break;
            case "register":
                if (dialogData.loading) dialogBody = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`<p>Creating account…</p>`;
                else dialogBody = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
					<${0, $210f1d422ab09f4c$export$2e2bcd8739ae039} emailRequired=${dialogData.emailRequired} onSubmit=${this.handleRegisterSubmit}/>
				`;
                dialog = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
				<${0, $676cb1384c20bf0e$export$2e2bcd8739ae039} title="Register a new ${(0, $fca64bf918d5638f$export$53e73e095c2ac1e2)(activeServer, activeBouncerNetwork)} account" onDismiss=${this.dismissDialog}>
					${dialogBody}
				</>
			`;
                break;
            case "verify":
                if (dialogData.loading) dialogBody = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`<p>Verifying account…</p>`;
                else dialogBody = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
					<${0, $5855ce19a38be3e6$export$2e2bcd8739ae039} account=${dialogData.account} message=${dialogData.message} onSubmit=${this.handleVerifySubmit}/>
				`;
                dialog = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
				<${0, $676cb1384c20bf0e$export$2e2bcd8739ae039} title="Verify ${(0, $fca64bf918d5638f$export$53e73e095c2ac1e2)(activeServer, activeBouncerNetwork)} account" onDismiss=${this.dismissDialog}>
					${dialogBody}
				</>
			`;
                break;
            case "settings":
                dialog = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
				<${0, $676cb1384c20bf0e$export$2e2bcd8739ae039} title="Settings" onDismiss=${this.dismissDialog}>
					<${0, $9fbbfef00d6a25bf$export$2e2bcd8739ae039}
						settings=${this.state.settings}
						showProtocolHandler=${dialogData.showProtocolHandler}
						onChange=${this.handleSettingsChange}
						onDisconnect=${this.handleSettingsDisconnect}
						onClose=${this.dismissDialog}
					/>
				</>
			`;
                break;
            case "switch":
                dialog = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
				<${0, $676cb1384c20bf0e$export$2e2bcd8739ae039} title="Switch to a channel or user" onDismiss=${this.dismissDialog}>
					<${0, $9b625992f92feff7$export$2e2bcd8739ae039}
						buffers=${this.state.buffers}
						servers=${this.state.servers}
						bouncerNetworks=${this.state.bouncerNetworks}
						onSubmit=${this.handleSwitchSubmit}/>
				</>
			`;
                break;
        }
        let error = null;
        if (this.state.error) error = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
				<div id="error-msg">
					${this.state.error}
					${" "}
					<button onClick=${this.handleDismissError}>×</button>
				</div>
			`;
        let composerReadOnly = false;
        if (activeServer && activeServer.status !== (0, $fca64bf918d5638f$export$ac0b13ba2bbce4d5).REGISTERED) composerReadOnly = true;
        let commandOnly = false;
        let privmsgMaxLen;
        if (activeBuffer && activeBuffer.type === (0, $fca64bf918d5638f$export$a9b603917c4d9863).SERVER) commandOnly = true;
        else if (activeBuffer) {
            let client = this.clients.get(activeBuffer.server);
            privmsgMaxLen = $bd3c59ab25aed5ca$export$feed2f17626e5168(client.isupport, client.nick, activeBuffer.name);
        }
        let app = (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
			<section
					id="buffer-list"
					class=${this.state.openPanels.bufferList ? "expand" : ""}
			>
				<${(0, $cd5f528e18548e6d$export$2e2bcd8739ae039)}
					buffers=${this.state.buffers}
					servers=${this.state.servers}
					bouncerNetworks=${this.state.bouncerNetworks}
					activeBuffer=${this.state.activeBuffer}
					onBufferClick=${this.handleBufferListClick}
					onBufferClose=${this.handleBufferListClose}
				/>
				<button
					class="expander"
					onClick=${this.toggleBufferList}
				>
					<span></span>
					<span></span>
				</button>
			</section>
			${bufferHeader}
			<${(0, $9ead1202cd2221f9$export$2e2bcd8739ae039)}
				target=${this.buffer}
				stickTo=".logline"
				scrollKey=${this.state.activeBuffer}
				onScrollTop=${this.handleBufferScrollTop}
			>
				<section id="buffer" ref=${this.buffer} tabindex="-1">
					<${(0, $47db4ea8a56fc107$export$2e2bcd8739ae039)}
						buffer=${activeBuffer}
						server=${activeServer}
						bouncerNetwork=${activeBouncerNetwork}
						settings=${this.state.settings}
						onChannelClick=${this.handleChannelClick}
						onNickClick=${this.handleNickClick}
						onAuthClick=${()=>this.handleAuthClick(activeBuffer.server)}
						onRegisterClick=${()=>this.handleRegisterClick(activeBuffer.server)}
						onVerifyClick=${this.handleVerifyClick}
					/>
				</section>
			</>
			${memberList}
			<${(0, $142bbba13add3ea5$export$2e2bcd8739ae039)}
				ref=${this.composer}
				client=${activeClient}
				readOnly=${composerReadOnly}
				onSubmit=${this.handleComposerSubmit}
				autocomplete=${this.autocomplete}
				commandOnly=${commandOnly}
				maxLen=${privmsgMaxLen}
			/>
			${dialog}
			${error}
		`;
        return (0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`
			<${(0, $fca64bf918d5638f$export$8fa45c82eddfe270).Provider} value=${this.state.settings}>
				${app}
			</>
		`;
    }
}


(0, $b2a774aae58c7b4e$export$b3890eb0ae9dca99)((0, $3bbe59931da17a80$export$c0bb0b647f701bb5)`<${(0, $5c2a91b7f6173cd8$export$2e2bcd8739ae039)}/>`, document.body);


//# sourceMappingURL=index.05e1a15d.js.map
